(function () {
    'use strict';

    /**
     * @ngdoc overview
     * @name index
     * @description
     * Enlaces sobre la documentación:
     *
     * {@link https://github.com/CodeineLabs/gulp-ngdocs-components}
     *
     * {@link https://github.com/nikhilmodak/gulp-ngdocs}
     *
     * {@link https://github.com/angular/angular.js/wiki/Contribution%3A-Writing-AngularJS-Documentation}
     */

    /**
     * @ngdoc overview
     * @name app
     * @description
     * Módulo base de la aplicación.
     */
    angular.module('app', [
        'ui.bootstrap',
        'ui.router',
        'angular-loading-bar',
        'angularjs-dropdown-multiselect',
        'jcs-autoValidate',
        'ncy-angular-breadcrumb',
        'ngAnimate',
        'ngCacheBuster',
        'ngCookies',
        'ngFileUpload',
        'ngResource',
        'ngSanitize',
        'ngStorage',
        'ngTable',
        'ngTagsInput',
        'oc.lazyLoad',
        'pascalprecht.translate',
        'tmh.dynamicLocale',
        'vcRecaptcha',
        '720kb.socialshare',
        'thatisuday.ng-image-gallery'
    ]).run(appRun);

    /* @ngInject */
    function appRun($rootScope, $translate, $localStorage, StateHandler, ValidateConfig, TranslationHandler) {

        TranslationHandler.initialize();
        StateHandler.initialize();
        ValidateConfig.initialize();

        $rootScope.changeLanguage = function (key) {
            if ($translate.use() !== key) {
                $translate.use(key).then(function () {
                    $translate.refresh();
                });
                $localStorage.lang = key;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('usuariosListAdmin', {
            templateUrl: 'app/components/aspg/usuarios/admin/usuarios/usuarios-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, UsuarioAspg, NG_TABLE_DEFAULT_PARAMS, Descargas) {
        var vm = this;

        vm.item = UsuarioAspg;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            eliminado: false
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {login: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (usuario, borradoFisico) {
            var titulo = 'usuarios.admin.usuarios.deshabilitar.title';
            var body = 'usuarios.admin.usuarios.deshabilitar.confirm';

            if (borradoFisico){
                titulo = 'usuarios.admin.usuarios.delete.title';
                body = 'usuarios.admin.usuarios.delete.confirm';
            }
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (UsuarioAspg) {
                            return new UsuarioAspg(usuario);
                        },
                        params: function () {
                            return {
                                title: titulo,
                                body: body,
                                property: 'login',
                                borradoFisico: borradoFisico
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

        // Recuperar
        vm.showRecoverConfirmation = function (usuario) {
            ModalService.open({
                    templateUrl: 'app/components/form/confirm/confirm.modal.html',
                    controller: 'ConfirmModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        item: function () {
                            return usuario;
                        },
                        params: function () {
                            return {
                                title: 'usuarios.admin.usuarios.recover.title',
                                body: 'usuarios.admin.usuarios.recover.confirm',
                                property: 'login'
                            };
                        },
                        /* @ngInject */
                        tipo: function (UsuarioAspg) {
                            return UsuarioAspg;
                        },
                        funcion: function () {
                            return "recover";
                        },
                        parametros: function () {
                            return {id: usuario.id};
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

        // Generar lista de usuarios
        vm.generarExcel = function () {
            Descargas.descargar('api/usuario-aspg/generar-excel');
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('suscriptoresListAdmin', {
            templateUrl: 'app/components/aspg/usuarios/admin/suscriptores/suscriptores-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper, ModalService, Suscriptor, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Suscriptor;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {email: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (suscriptor) {
            ModalService.open({
                templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                controller: 'EntityDeleteModalController',
                controllerAs: 'ctrl',
                resolve: {
                    /* @ngInject */
                    item: function (Suscriptor) {
                        return new Suscriptor(suscriptor);
                    },
                    params: function () {
                        return {
                            title: 'usuarios.admin.suscriptores.delete.title',
                            body: 'usuarios.admin.suscriptores.delete.confirm',
                            property: 'email'
                        };
                    }
                }
            }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

        vm.showEditModal = function (suscriptor) {
            ModalService.open({
                    templateUrl: 'app/components/aspg/usuarios/admin/suscriptores/suscriptor-edit.html',
                    controller: 'suscriptorEditConroller',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Suscriptor) {
                            return new Suscriptor(suscriptor);
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('suscriptorEditConroller', Controller);

    /* @ngInject */
    function Controller(item, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;

        vm.confirm = function () {
            vm.item.$save().then(function () {
                ModalService.close(vm.item);
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('enviarMail', {
            templateUrl: 'app/components/aspg/usuarios/admin/email/enviar-mail.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                suscriptores: '<'
            }
        });

    /* @ngInject */
    function Controller(Suscriptor) {
        var vm = this;
        vm.email = {
            asunto: null,
            cuerpo: null
        };

        vm.tipoDestinatario = 'grupo';
        vm.infoGeneral = false;
        vm.infoJuegos = false;
        vm.infoTienda = false;
        vm.suscriptor = null;

        vm.enviar = function () {
            var destinatario;

            switch (vm.tipoDestinatario){
                case 'grupo':
                    destinatario = {infoGeneral: vm.infoGeneral, infoJuegos: vm.infoJuegos, infoTienda: vm.infoTienda};
                    if (!destinatario.infoJuegos && !destinatario.infoGeneral && !destinatario.infoTienda){
                        vm.errorDestinatario = true;
                        return;
                    }
                    break;
                case 'suscriptor':
                default:
                    destinatario = {email: vm.suscriptor.email};
            }

            Suscriptor.enviarEmail(destinatario, vm.email).$promise.then(function () {
                vm.success = true;
                vm.error = false;
            }).catch(function(){
                vm.error = true;
                vm.success = false;
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, SALA_MUSEO_FORM_ADMIN) {
        var config = SALA_MUSEO_FORM_ADMIN();
        var base = "admin/museos/salaMuseo";
        var params = {
            parent: "admin/museos/museo",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{museoid:int}/sala",
            translateBase: "museos.salaMuseo.admin.",
            templateList: '<sala-museo-list-admin></sala-museo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/aspg/museos/admin/museos-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                museo: function ($stateParams, Museo) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    if ($stateParams.museoid) {
                        return Museo.get({id: $stateParams.museoid}).$promise;
                    } else return {};
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (SalaMuseo, $stateParams) {
                    return SalaMuseo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('salaMuseoListAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/salamuseo/sala-museo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, SalaMuseo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = SalaMuseo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.museoid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (SalaMuseo) {
                            return SalaMuseo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'museos.salaMuseo.admin.delete.title',
                                body: 'museos.salaMuseo.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('SALA_MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<sala-museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></sala-museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (SalaMuseo) {
                        return new SalaMuseo();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('salaMuseoFormAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/salamuseo/sala-museo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService, MuseosUtil) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.urlBaseImagen = MuseosUtil.getRutaSalas(vm.item.id);

        function init() {
            if (!vm.item.museo) {
                vm.item.museo = {id: $stateParams.museoid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/museos/salaMuseo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, MUSEO_FORM_ADMIN) {
        var config = MUSEO_FORM_ADMIN();
        var base = "admin/museos/museo";
        var params = {
            view: 'contentChildren',
            base: base,
            baseUrl: "/museo",
            translateBase: "museos.museo.admin.",
            templateList: '<museo-list-admin></museo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN'],
                hideBreadcrumb: true
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/aspg/museos/admin/museos-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                breadcrumb: function ($breadcrumb) {
                    return $breadcrumb;
                },
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/museos');
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Museo, $stateParams) {
                    return Museo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('museoListAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/museo/museo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Museo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Museo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Museo) {
                            return Museo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'museos.museo.admin.delete.title',
                                body: 'museos.museo.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Museo) {
                        return new Museo();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('museoFormAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/museo/museo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService, MuseosUtil) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.urlBaseImagen = MuseosUtil.getRutaMuseos(vm.item.id);

        function init() {
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/museos/museo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('salaListPublic', {
            templateUrl: 'app/components/aspg/museos/public/salamuseo/sala-list.public.html',
            controllerAs: 'ctrl',
            bindings: {
                salas: '<'
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('salaDetailsPublic', {
            templateUrl: 'app/components/aspg/museos/public/salamuseo/sala-details.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                sala: '<'
            }
        });

    /* @ngInject */
    function Controller(MuseosUtil) {
        var vm = this;

        // Imágen de la sala
        var urlBaseImagen = MuseosUtil.getRutaSalas(vm.sala.id);
        vm.imagen = MuseosUtil.obtenerImagen(urlBaseImagen, vm.sala.imagenPath);
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, OBRA_MUSEO_FORM_ADMIN) {
        var config = OBRA_MUSEO_FORM_ADMIN();
        var base = "admin/museos/obraMuseo";
        var params = {
            parent: "admin/museos/salaMuseo",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{salaid:int}/obra",
            translateBase: "museos.obraMuseo.admin.",
            templateList: '<obra-museo-list-admin></obra-museo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/aspg/museos/admin/museos-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                sala: function ($stateParams, SalaMuseo) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    if ($stateParams.salaid) {
                        return SalaMuseo.get({id: $stateParams.salaid}).$promise;
                    } else return {};
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (ObraMuseo, $stateParams) {
                    return ObraMuseo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('obraMuseoListAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/obramuseo/obra-museo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, ObraMuseo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = ObraMuseo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.salaid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (ObraMuseo) {
                            return ObraMuseo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'museos.obraMuseo.admin.delete.title',
                                body: 'museos.obraMuseo.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('OBRA_MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<obra-museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></obra-museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (ObraMuseo) {
                        return new ObraMuseo();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('obraMuseoFormAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/obramuseo/obra-museo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService, MuseosUtil) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.urlBaseImagen = MuseosUtil.getRutaObras(vm.item.id);

        function init() {
            if (!vm.item.museo) {
                vm.item.sala = {id: $stateParams.salaid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/museos/obraMuseo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('obraListPublic', {
            templateUrl: 'app/components/aspg/museos/public/obramuseo/obra-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                obras: '<',
                sala: '<'
            }
        });

    /* @ngInject */
    function Controller(MuseosUtil, $window) {
        var vm = this;
        vm.imagenes = MuseosUtil.obtenerImagenesNgGallery(vm.obras);

        vm.irARecepcion = function(){
            $window.history.back();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('museoListPublic', {
            templateUrl: 'app/components/aspg/museos/public/museo/museo-list.public.html',
            controllerAs: 'ctrl',
            bindings: {
                museos: '<'
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('museoInfoPublic', {
            templateUrl: 'app/components/aspg/museos/public/museo/museo-info.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                museo: '<'
            }
        });

    /* @ngInject */
    function Controller(MuseosUtil, ModalService) {
        var vm = this;

        // Imágen del museo
        var urlBaseImagen = MuseosUtil.getRutaMuseos(vm.museo.id);
        vm.imagen = MuseosUtil.obtenerThumbnail(urlBaseImagen, vm.museo.imagenPath);

        vm.abrirImagen = function () {
            ModalService.openImagen(vm.imagen);
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('museoDetailsPublic', {
            templateUrl: 'app/components/aspg/museos/public/museo/museo-details.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                museo: '<'
            }
        });

    /* @ngInject */
    function Controller(MuseosUtil) {
        var vm = this;

        // Imágen del museo
        var urlBaseImagen = MuseosUtil.getRutaMuseos(vm.museo.id);
        vm.imagen = MuseosUtil.obtenerImagen(urlBaseImagen, vm.museo.imagenPath);
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, WEB_FORM_ADMIN) {
        var config = WEB_FORM_ADMIN();
        var base = "admin/web";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "web.web.admin.",
            templateList: '<web-list-admin></web-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/webs');
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Web, $stateParams) {
                    return Web.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('webListAdmin', {
            templateUrl: 'app/components/web/admin/web/web-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Web, WebUtil, RutasService, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Web;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Web) {
                            return Web.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'web.web.admin.delete.title',
                                body: 'web.web.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

        vm.rutaBase = RutasService.getBaseUrl() + WebUtil.getRutaWebPublica();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('WEB_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<web-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'permisos-categoria="' + resolve + 'permisosCategoria"' +
                'categorias="' + resolve + 'categorias"' +
                '></web-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Web) {
                        return new Web();
                    },
                    /* @ngInject */
                    permisosCategoria: function (COMPONENTES) {
                        return COMPONENTES.webs.categoriasAdmin;
                    },
                    /* @ngInject */
                    categorias: function (CategoriaWeb) {
                        return CategoriaWeb.query({sortProperty: 'nombre'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('webFormAdmin', {
            templateUrl: 'app/components/web/admin/web/web-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                permisosCategoria: '<',
                categorias: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService, WebUtil, CATEGORIA_WEB_FORM_ADMIN) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.urlBaseArchivo = WebUtil.getRutaWebs(vm.item.id);

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/web/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.openCategoriaModal = function () {
            ModalService.openComponent('web.categoriaWeb.admin.create.title', CATEGORIA_WEB_FORM_ADMIN, {size: 'lg'}).result.then(function (result) {
                // Asociamos el nuevo elemento a la entidad
                vm.item.categoriaWeb = result;
                vm.categorias.push(result);
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, CATEGORIA_WEB_FORM_ADMIN, COMPONENTES, PERMISOS) {
        var configCategorias = COMPONENTES.webs.categoriasAdmin;
        if (configCategorias === 'none') return;

        var config = CATEGORIA_WEB_FORM_ADMIN();
        var base = "admin/categoriaWeb";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "web.categoriaWeb.admin.",
            templateList: '<categoria-web-list-admin permisos="$resolve.permisos"></categoria-web-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/webs');
                }
            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                permisos: function () {
                    return configCategorias;
                }
            }
        });
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (CategoriaWeb, $stateParams) {
                    return CategoriaWeb.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados

        if (PERMISOS('list', configCategorias)) {
            $stateProvider
                .state(params.base, state.parent)
                .state(state.list.name, state.list);
        }
        if (PERMISOS('create', configCategorias)) {
            $stateProvider
                .state(state.create.name, state.create);
        }
        if (PERMISOS('edit', configCategorias)) {
            $stateProvider
                .state(state.edit.name, state.edit);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaWebListAdmin', {
            templateUrl: 'app/components/web/admin/categoriaweb/categoria-web-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, CategoriaWeb, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = CategoriaWeb;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (CategoriaWeb) {
                            return CategoriaWeb.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'web.categoriaWeb.admin.delete.title',
                                body: 'web.categoriaWeb.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_WEB_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-web-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-web-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaWeb) {
                        return new CategoriaWeb();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaWebFormAdmin', {
            templateUrl: 'app/components/web/admin/categoriaweb/categoria-web-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/categoriaWeb/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, NOVEDAD_FORM_ADMIN) {
        var config = NOVEDAD_FORM_ADMIN();
        var base = "admin/novedad";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "novedades.novedad.admin.",
            templateList: '<novedad-list-admin></novedad-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/novedades');
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Novedad, $stateParams) {
                    return Novedad.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('novedadListAdmin', {
            templateUrl: 'app/components/novedades/admin/novedad/novedad-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, Novedad, Language) {
        var vm = this;

        vm.lang = Language.getCurrent();

        vm.item = Novedad;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined,
            idioma: vm.lang
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {'n.fecha': 'desc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Novedad) {
                            return Novedad.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'novedades.novedad.admin.delete.title',
                                body: 'novedades.novedad.admin.delete.confirm',
                                property: 'url'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('NOVEDAD_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<novedad-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'permisos-categoria="' + resolve + 'permisosCategoria"' +
                'categorias="' + resolve + 'categorias"' +
                'idiomas="' + resolve + 'idiomas"' +
                '></novedad-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Novedad) {
                        return new Novedad();
                    },
                    /* @ngInject */
                    permisosCategoria: function (COMPONENTES) {
                        return COMPONENTES.novedades.categoriasAdmin;
                    },
                    /* @ngInject */
                    categorias: function (CategoriaNovedad) {
                        return CategoriaNovedad.query({sortProperty: 'nombre'}).$promise.then(function (data) {
                            return data.content;
                        });
                    },
                    /* @ngInject */
                    idiomas: function (Language) {
                        return Language.getList();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('novedadFormAdmin', {
            templateUrl: 'app/components/novedades/admin/novedad/novedad-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                permisosCategoria: '<',
                categorias: '<',
                idiomas: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, NovedadUtil, ModalService, FormUtils, Language, CATEGORIA_NOVEDAD_FORM_ADMIN) {
        var vm = this;

        $timeout(function () {
            angular.element('.tab-content .form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.lang = Language.getDefault();

        vm.urlBaseImagen = NovedadUtil.getRuta(vm.item.id);

        vm.validar = function () {
            vm.active = FormUtils.validarTabs(vm.form, vm.active, vm.idiomas);
        };

        // Guardar formulario
        vm.save = function () {
            if (!vm.item.url || vm.actualizarUrl) {
                vm.item.tituloParaUrl = vm.item.descripciones[vm.lang].titulo;
            }

            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/novedad/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.openCategoriaModal = function () {
            ModalService.openComponent('novedades.categoriaNovedad.admin.create.title', CATEGORIA_NOVEDAD_FORM_ADMIN, {size: 'md'}).result.then(function (result) {
                // Asociamos el nuevo elemento a la entidad
                vm.categorias.push(result);
                vm.item.categoriaNovedad = result;
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);


    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('actividad', {
                parent: 'public',
                url: '/actividades',
                redirectTo: 'actividades/list',
                data: {
                    authorities: [],
                    pageTitle: 'actividades.titulo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/novedades/public/actividades/actividad-template.public.html',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/actividades');
                        $translatePartialLoader.addPart('componentes/novedades');
                    },
                    /* @ngInject */
                    categorias: function (CategoriaNovedad, Permisos, COMPONENTES) {
                        // Si no se tienen permisos, no se el menú de categorías
                        if (Permisos.tienePermisos('list', COMPONENTES.novedades.categoriasPublic)) {
                            return CategoriaNovedad.query({
                                sortProperty: 'nombre',
                                sortDirection: 'ASC'
                            }).$promise.then(function (data) {
                                return data;
                            });
                        }
                    },
                    /* @ngInject */
                    menu: function ($translate, categorias) {
                        if (categorias) {
                            var categoriasMenu = [{
                                "label": $translate.instant("novedades.categoriaNovedad.todas"),
                                "state": "novedad/list({categoriaUrl: null})"
                            }];
                            for (var i = 0; i < categorias.content.length; i++) {
                                categoriasMenu.push({
                                    "label": categorias.content[i].nombre,
                                    "state": "novedad/listByCategoria({categoriaUrl: '" + categorias.content[i].url + "', page: '1'})"
                                });
                            }
                            return categoriasMenu;
                        }
                    },
                    /* @ngInject */
                    rssUrl: function (Language, RutasService) {
                        return RutasService.getBaseUrl() + "/rss/novedades?idioma=" + Language.getCurrent();
                    }
                }
            })
            .state('actividades/list', {
                parent: 'actividad',
                url: '/p/{page}?etiqueta',
                params: {
                    categoriaUrl: 'actividades',
                    page: '1',
                    etiqueta: null
                },
                views: {
                    'contentNovedades': {
                        template: '<novedad-list-public novedades="$resolve.novedades" etiqueta="$resolve.etiqueta" categorias-novedad="$resolve.categoria"></novedad-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    novedades: function ($stateParams, Novedad, Language, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                        var filter = {
                            categoriaUrl: $stateParams.categoriaUrl,
                            page: $stateParams.page ? $stateParams.page - 1 : null,
                            idioma: Language.getCurrent(),
                            size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size,
                            sortProperty: 'n.fecha',
                            sortDirection: 'DESC',
                            etiqueta: $stateParams.etiqueta
                        };
                        return Novedad.findPublic(filter).$promise;
                    },
                    etiqueta: function($stateParams) {
                        return $stateParams.etiqueta;
                    },
                    categoria: function ($stateParams) {
                        return $stateParams.categoriaUrl;
                    }
                }
            })
            .state('actividades/details', {
                parent: 'actividad',
                url: '/{url}',
                views: {
                    'content@': {
                        template: '<h1 translate="actividades.ultimas"></h1>' +
                            '<novedad-details-public novedad="$resolve.novedad" ampliada="true"></novedad-details-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    novedad: function ($stateParams, Novedad, Language) {
                        return Novedad.getByUrl({
                            url: $stateParams.url,
                            idioma: Language.getCurrent()
                        }).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, CATEGORIA_NOVEDAD_FORM_ADMIN, COMPONENTES, PERMISOS) {
        var configCategorias = COMPONENTES.novedades.categoriasAdmin;
        if (configCategorias === 'none') return;

        var config = CATEGORIA_NOVEDAD_FORM_ADMIN();
        var base = "admin/categoriaNovedad";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "novedades.categoriaNovedad.admin.",
            templateList: '<categoria-novedad-list-admin permisos="$resolve.permisos"></categoria-novedad-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/novedades');
                }
            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                permisos: function () {
                    return configCategorias;
                }
            }
        });
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (CategoriaNovedad, $stateParams) {
                    return CategoriaNovedad.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados

        if (PERMISOS('list', configCategorias)) {
            $stateProvider
                .state(params.base, state.parent)
                .state(state.list.name, state.list);
        }
        if (PERMISOS('create', configCategorias)) {
            $stateProvider
                .state(state.create.name, state.create);
        }
        if (PERMISOS('edit', configCategorias)) {
            $stateProvider
                .state(state.edit.name, state.edit);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaNovedadListAdmin', {
            templateUrl: 'app/components/novedades/admin/categorianovedad/categoria-novedad-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, CategoriaNovedad, Permisos) {
        var vm = this;

        vm.item = CategoriaNovedad;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));

        if (Permisos.tienePermisos('create', vm.permisos)) {
            // Eliminar
            vm.showRemoveConfirmation = function (id) {
                ModalService.open({
                        templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                        controller: 'EntityDeleteModalController',
                        controllerAs: 'ctrl',
                        resolve: {
                            /* @ngInject */
                            item: function (CategoriaNovedad) {
                                return CategoriaNovedad.get({id: id}).$promise;
                            },
                            params: function () {
                                return {
                                    title: 'novedades.categoriaNovedad.admin.delete.title',
                                    body: 'novedades.categoriaNovedad.admin.delete.confirm',
                                    property: 'nombre'
                                };
                            }
                        }
                    }
                ).result.then(function () {
                    vm.tableParams.reload();
                });
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_NOVEDAD_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-novedad-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-novedad-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaNovedad) {
                        return new CategoriaNovedad();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaNovedadFormAdmin', {
            templateUrl: 'app/components/novedades/admin/categorianovedad/categoria-novedad-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/categoriaNovedad/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .component('imagenPerfilVer', {
            templateUrl: "app/components/form/archivos/imagenperfilver/imagen-perfil-ver.html",
            controllerAs: 'ctrl',
            bindings: {
                usuario: '<',
                mini: '<'
            }
        });

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:imagen
     * @description
     * Componente para la subida de imágenes.
     *
     * @param {Object} model Imagen
     * @param {String} carpeta Ruta a la carpeta de la imagen.
     * @param {Number} indice Necesario si las imágenes van dentro de un bucle, por ejemplo.
     * @param {Object} modelRadio En caso de que se quiera incluir un radio input para seleccionar una imagen principal.
     * @param {Function} onUploadedImage Función de callback que se llama cuando se selecciona una imagen.
     * @param {Function} onRemoveImage Función de callback que se llama cuando se elimina una imagen.
     * @param {Boolean} [edicion=true] Poner a false para no permitir la edición.
     *
     * @requires app.component:loading
     */
    angular.module('app')
        .component('imagen', {
            templateUrl: "app/components/form/archivos/imagen/imagen.html",
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                model: "=",
                carpeta: "@",
                indice: "<",
                modelRadio: "<",
                onUploadedImage: '&',
                onRemoveImage: '&',
                edicion: "<"
            }
        });

    /* @ngInject */
    function Controller($timeout, Upload, AlertService) {

        var vm = this;

        activate();

        function activate() {
            vm.model = vm.model || {};

            if (!vm.model.rutaImagen) {
                if (vm.model.path) {
                    vm.model.rutaImagen = vm.carpeta + "n_" + vm.model.path;
                } else {
                    vm.model.rutaImagen = null;
                }
            }

            if (vm.edicion === null || vm.edicion === undefined) {
                vm.edicion = true;
            }
        }

        function onUploaded() {
            vm.onUploadedImage();
        }

        vm.isSubmitted = function (form) {
            while (!!form) {
                if (form.$submitted) return true;
                form = form.$$parentForm;
            }
            return false;
        };

        vm.eliminarImagen = function () {
            vm.model.eliminar = true;
            vm.model.rutaImagen = null;
            vm.model.path = null;
            vm.model.archivoTemporal = null;

            // Llamamos al callback para eliminar el elemento de la lista
            vm.onRemoveImage({imagen: vm.model});
        };

        function generateThumb(file) {
            if (file != null) {
                if (file.type.indexOf('image') > -1) {
                    $timeout(function () {
                        var fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = function (e) {
                            $timeout(function () {
                                vm.model.rutaImagen = e.target.result;
                            });
                        }
                    });
                }
            }
        }

        vm.onImagenSelect = function (files) {
            vm.model.eliminar = false;
            if (files && files.length) {

                vm.model.path = null;
                vm.progresoImagen = true;

                // Previsualizamos imagen
                generateThumb(files[0]);

                // Subimos imagen
                Upload.upload({
                    url: "api/archivos-temporales",
                    data: {
                        file: files[0],
                        ext: "jpeg,png,gif,jpg"
                    },
                    method: 'POST'
                }).success(function (response) {
                    vm.progresoImagen = null;
                    vm.model.archivoTemporal = response.msg;
                    vm.model.path = files[0].name;
                    onUploaded();
                }).error(function (data) {
                    vm.progresoImagen = null;
                    vm.eliminarImagen();
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("error.invalidextension", {archivo: files[0].name});
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };

        vm.clickUpload = function () {
            document.getElementById('inputFoto' + vm.indice).click();
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:imagenCrop
     * @description
     * Componente para la subida de una imagen, permitiendo seleccionar un área de la misma.
     *
     * _Referencia:_ https://github.com/CrackerakiUA/ui-cropper/wiki/Options
     *
     * @param {Object} model Imagen
     * @param {String} carpeta Ruta a la carpeta de la imagen.
     * @param {Number} ratio Ratio que tiene que tener la imagen.
     * [1 = cuadrado; 1.x = horizontal; 0.x = vertical; null = sin restricciones.]
     * @param {String} [area=rectangle] Área de recorte. Si se indica un área diferente a `rectangle`, ratio tiene que ser null.
     * {rectangle|circle|square}
     * @param {Number} indice Necesario si las imágenes van dentro de un bucle, por ejemplo.
     * @param {Function} onUploadedImage Función de callback que se llama cuando se selecciona una imagen.
     * @param {Function} onRemoveImage Función de callback que se llama cuando se elimina una imagen.
     *
     * @requires app.component:loading
     */
    angular.module('app')
        .component('imagenCrop', {
            templateUrl: "app/components/form/archivos/imagencrop/imagen-crop.html",
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                model: "=",
                carpeta: "@",
                ratio: '<',
                area: '@',
                indice: "<",
                onUploadedImage: '&',
                onRemoveImage: '&'
            }
        });

    /* @ngInject */
    function Controller($ocLazyLoad, Upload, AlertService) {
        var vm = this;

        $ocLazyLoad.load({
            name: 'uiCropper',
            files: [
                'assets/bower/ui-cropper/ui-cropper.js',
                'assets/bower/ui-cropper/ui-cropper.css'
            ]
        }).then(function () {
            vm.editPreview = false;
            vm.myCroppedImage = '';
            vm.myImage = '';

            function init() {
                vm.model = vm.model || {};
                vm.area = vm.area || 'rectangle';

                if (!vm.model.rutaImagen) {
                    if (vm.model.path) {
                        vm.model.rutaImagen = vm.carpeta || "";
                        if (!vm.model.rutaImagen.endsWith("/")) {
                            vm.model.rutaImagen += "/";
                        }
                        vm.model.rutaImagen += "n_" + vm.model.path;

                        vm.myCroppedImage = vm.model.rutaImagen;
                    } else {
                        vm.model.rutaImagen = null;
                    }
                }
            }

            function onUploaded() {
                vm.onUploadedImage();
            }

            vm.isSubmitted = function (form) {
                while (!!form) {
                    if (form.$submitted) return true;
                    form = form.$$parentForm;
                }
                return false;
            };

            vm.eliminarImagen = function () {
                vm.model.eliminar = true;
                vm.model.rutaImagen = null;
                vm.model.path = null;
                vm.model.archivoTemporal = null;
                vm.myCroppedImage = '';

                // Llamamos al callback para eliminar el elemento de la lista
                vm.onRemoveImage({imagen: vm.model});
            };

            function blobToFile(theBlob, fileName) {
                // A Blob() is almost a File() - it's just missing the two
                // properties below which we will add
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            }

            function dataURItoBlob(dataURI, type) {
                // convert base64 to raw binary data held in a string
                var byteString = atob(dataURI.split(',')[1]);

                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
                return new Blob([ab], {type: type});
            }

            vm.onImagenSelect = function (files) {
                vm.editPreview = false;
                vm.model.eliminar = false;
                if (files && files.length) {

                    vm.model.path = null;
                    vm.progresoImagen = true;

                    // Subimos imagen
                    Upload.upload({
                        url: "api/archivos-temporales",
                        data: {
                            file: blobToFile(dataURItoBlob(files, 'image/png'), vm.myImage.name),
                            ext: "jpeg,png,gif,jpg"
                        },
                        method: 'POST'
                    }).success(function (response) {
                        vm.progresoImagen = null;
                        vm.model.archivoTemporal = response.msg;
                        vm.model.path = vm.myImage.name;
                        onUploaded();
                    }).error(function (data) {
                        vm.progresoImagen = null;
                        vm.eliminarImagen();
                        if (data && data.msg === 'invalid extension') {
                            AlertService.error("error.invalidextension", {archivo: vm.myImage.name});
                        } else {
                            AlertService.error("admin.form.error.fail");
                        }
                    });
                }
            };

            vm.clickUpload = function () {
                var indice = vm.indice || "";
                angular.element("#inputFoto" + indice).click();
            };

            vm.preview = function (files) {
                vm.myImage = files[0];
                vm.editPreview = true;
            };

            init();

        });

    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:fileUpload
     * @description
     * Componente para la subida de archivos. También permite la descarga de los mismos.
     *
     * Referencia: https://github.com/danialfarid/ng-file-upload
     *
     * @param {Object} model Objeto en el que se almacenará el resultado.
     * En `path` se almacenará el nombre del archivo, y en `archivoTemporal` irá el nombre del archivo .tmp
     * @param {String} id ID del input
     * @param {String} label Etiqueta.
     * @param {String} [accept=''] Extensiones que se aceptan. Si no se indica nada, no se establece ningún filtro.
     * Ej: `.pdf,.doc`, o `image/*`
     * @param {String} url URL de la carpeta en la que se encuentra el archivo. Si no se pasa, no se muestra el icono de descarga
     * @param {Number} size Número de bytes del archivo subido.
     * @param {String} [authorities=''] Lista de roles para los que será visible el botón de descarga. Si no se indica nada, no se establece ningún filtro.
     * Ej: `ROLE_ADMIN,ROLE_COLABORADOR`
     * @param {Function} onSelected Función llamada cuando se selecciona un archivo.
     * `vm.onSelected(vm.model.archivoTemporal, vm.model.path)`
     * @param {Boolean} [disableDrop=false] Booleano para indicar si se permite arrastrar un archivo desde fuera del navegador o no.
     * @param {Boolean} [required=false] Campo obligatorio.
     * @param {Boolean} [disabled=false] Selección deshabilitada.
     *
     * @requires app.component:download
     * @requires app.component:loading
     */
    angular.module('app')
        .component('fileUpload', {
            templateUrl: 'app/components/form/archivos/fileupload/file-upload.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                model: '=',
                id: '@',
                label: '@',
                tooltip: '@',
                accept: "@",
                url: "@",
                size: '<',
                authorities: "@",
                onSelected: "<",
                disableDrop: '<',
                required: '<',
                disabled: '<'
            }
        });

    /* @ngInject */
    function Controller(Upload, AlertService) {
        var vm = this;

        vm.onArchivoSelect = onArchivoSelect;
        vm.eliminarArchivo = eliminarArchivo;

        vm.model = vm.model || {};
        vm.subido = !!vm.model.path;

        function onArchivoSelect(files) {
            if (files && files.length) {
                vm.progresoArchivo = true;
                vm.model.path = files[0].name;
                vm.model.eliminar = false;

                Upload.upload({
                    url: "api/archivos-temporales",
                    data: {
                        file: files[0],
                        ext: vm.accept
                    },
                    method: 'POST'
                }).progress(function (evt) {
                    console.log(parseInt(100.00 * evt.loaded / evt.total) + '%');
                }).success(function (response) {
                    vm.progresoArchivo = false;
                    vm.subido = true;
                    vm.model.archivoTemporal = response.msg;

                    if (vm.onSelected) {
                        vm.onSelected(vm.model.archivoTemporal, vm.model.path);
                    }
                }).error(function (data) {
                    console.log("Error subiendo archivo");
                    vm.progresoArchivo = false;
                    vm.model.path = null;
                    // form.$setValidity('archivoSubido', true);
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("error.invalidextension", {archivo: files[0].name});
                    }
                    else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        }

        function eliminarArchivo() {
            vm.model.path = null;
            vm.model.eliminar = true;
            vm.subido = false;
        }

    }


})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:download
     * @description
     * Componente para la descarga de archivos.
     *
     * @param {Object} archivo Nombre del archivo
     * @param {String} url URL del directorio donde se encuentra el archivo
     * @param {Boolean} [showLabel=false] Booleano para mostrar u ocultar el nombre del archivo
     *
     */
    angular.module('app')
        .component('download', {
            templateUrl: 'app/components/form/archivos/download/download.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                archivo: "<",
                url: "@",
                showLabel: "<"
            }
        });

    function Controller() {
        var vm = this;

        vm.descargarArchivo = descargarArchivo;

        function descargarArchivo() {
            window.open(vm.url + vm.archivo, '_blank');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, FEED_RSS_FORM_ADMIN) {
        var config = FEED_RSS_FORM_ADMIN();
        var base = "admin/feedRss";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "feedsRss.feedRss.admin.",
            templateList: '<feed-rss-list-admin></feed-rss-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/feedsRss');
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (FeedRss, $stateParams) {
                    return FeedRss.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('feedRssListAdmin', {
            templateUrl: 'app/components/feedrss/admin/feedrss/feed-rss-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, FeedRss) {
        var vm = this;

        vm.item = FeedRss;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (FeedRss) {
                            return FeedRss.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'feedsRss.feedRss.admin.delete.title',
                                body: 'feedsRss.feedRss.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('FEED_RSS_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<feed-rss-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'permisos-categoria="' + resolve + 'permisosCategoria"' +
                'categorias="' + resolve + 'categorias"' +
                '></feed-rss-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (FeedRss) {
                        return new FeedRss();
                    },
                    /* @ngInject */
                    permisosCategoria: function (COMPONENTES) {
                        return COMPONENTES.feedsRss.categoriasAdmin;
                    },
                    /* @ngInject */
                    categorias: function (CategoriaRss) {
                        return CategoriaRss.query({sortProperty: 'nombre'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('feedRssFormAdmin', {
            templateUrl: 'app/components/feedrss/admin/feedrss/feed-rss-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                permisosCategoria: '<',
                categorias: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService, CATEGORIA_RSS_FORM_ADMIN) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/feedRss/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.openCategoriaModal = function () {
            ModalService.openComponent('feedsRss.categoriaRss.admin.create.title', CATEGORIA_RSS_FORM_ADMIN, {}).result.then(function (result) {
                // Asociamos el nuevo elemento a la entidad
                vm.categorias.push(result);
                vm.item.categoriaRss = result;
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, CATEGORIA_RSS_FORM_ADMIN, COMPONENTES, PERMISOS) {
        var configCategorias = COMPONENTES.feedsRss.categoriasAdmin;
        if (configCategorias === 'none') return;

        var config = CATEGORIA_RSS_FORM_ADMIN();
        var base = "admin/categoriaRss";
        var params = {
            base: base,
            baseUrl: "/" + base,
            translateBase: "feedsRss.categoriaRss.admin.",
            templateList: '<categoria-rss-list-admin permisos="$resolve.permisos"></categoria-rss-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/feedsRss');
                }
            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                permisos: function () {
                    return configCategorias;
                }
            }
        });
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (CategoriaRss, $stateParams) {
                    return CategoriaRss.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados

        if (PERMISOS('list', configCategorias)) {
            $stateProvider
                .state(params.base, state.parent)
                .state(state.list.name, state.list);
        }
        if (PERMISOS('create', configCategorias)) {
            $stateProvider
                .state(state.create.name, state.create);
        }
        if (PERMISOS('edit', configCategorias)) {
            $stateProvider
                .state(state.edit.name, state.edit);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaRssListAdmin', {
            templateUrl: 'app/components/feedrss/admin/categoriarss/categoria-rss-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, CategoriaRss, Permisos) {
        var vm = this;

        vm.item = CategoriaRss;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {id: 'asc'}
        }, NgTableHelper.settings(vm));

        if (Permisos.tienePermisos('create', vm.permisos)) {
            // Eliminar
            vm.showRemoveConfirmation = function (id) {
                ModalService.open({
                        templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                        controller: 'EntityDeleteModalController',
                        controllerAs: 'ctrl',
                        resolve: {
                            /* @ngInject */
                            item: function (CategoriaRss) {
                                return CategoriaRss.get({id: id}).$promise;
                            },
                            params: function () {
                                return {
                                    title: 'feedsRss.categoriaRss.admin.delete.title',
                                    body: 'feedsRss.categoriaRss.admin.delete.confirm',
                                    property: 'nombre'
                                };
                            }
                        }
                    }
                ).result.then(function () {
                    vm.tableParams.reload();
                });
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_RSS_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-rss-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-rss-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaRss) {
                        return new CategoriaRss();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaRssFormAdmin', {
            templateUrl: 'app/components/feedrss/admin/categoriarss/categoria-rss-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/categoriaRss/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('validar', {
                parent: 'public',
                url: '/validar?key',
                data: {
                    pageTitle: 'global.menu.activar'
                },
                views: {
                    'content@': {
                        template: '<h1 translate="enXogo.titulo"></h1>' +
                        '<validar></validar>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/enXogo');
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('validar', {
            templateUrl: 'app/components/aspg/usuarios/validar/validar.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($stateParams, Auth) {
                var vm = this;

                Auth.validateAccount($stateParams.key).then(function (result) {
                    vm.error = null;
                    vm.success = true;
                    vm.rol = result.data;
                }).catch(function () {
                    vm.error = 'ERROR';
                });
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('registro', {
                parent: 'public',
                url: '/registro',
                data: {
                    authorities: ['ROLE_ANONYMOUS'],
                    pageTitle: 'global.menu.registro'
                },
                views: {
                    'content@': {
                        template: '<h1 translate="registro.titulo"></h1>' +
                        '<registro mode="create"></registro>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/registro');
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('registro', {
            templateUrl: 'app/components/aspg/usuarios/registro/registro.html',
            controllerAs: 'ctrl',
            bindings: {
                mode: '@',
                usuario: '<'
            },
            /* @ngInject */
            controller: function ($rootScope, $timeout, $stateParams, UsuarioAspg) {
                var vm = this;

                $timeout(function () {
                    angular.element('.form-group>input:eq(0)').focus();
                });

                function initForm() {
                    if (vm.mode === 'create') {
                        vm.item = new UsuarioAspg();
                        vm.item.type = 'aspg';
                        vm.item.infoGeneral = false;
                        vm.item.infoJuegos = false;
                        vm.confirmPassword = "";
                    } else {
                        vm.item = vm.usuario;
                    }
                }

                initForm();

                // Guardar formulario
                vm.save = function () {
                    var accion;

                    switch (vm.mode) {
                        case 'edit':
                            accion = '$editar';
                            break;
                        case 'create':
                        default:
                            accion = '$save';
                    }

                    vm.item[accion]().then(function () {
                        vm.success = true;
                        initForm();
                    }).catch(function (response) {
                        $rootScope.mostrarErrores(response, vm.form);
                    });
                };
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('unsuscribe', {
                parent: 'public',
                url: '/unsuscribe?key',
                data: {
                    pageTitle: 'usuarios.unsuscribe.titulo'
                },
                views: {
                    'content@': {
                        template: '<unsuscribe></unsuscribe>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/usuarios');
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('unsuscribe', {
            templateUrl: 'app/components/aspg/usuarios/unsuscribe/unsuscribe.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($stateParams, Suscriptor) {
                var vm = this;

                vm.cancelarSuscripcion = function(){
                    var suscripcionId = $stateParams.key;
                    Suscriptor.cancelarSuscripcion({key: suscripcionId}).$promise.then(function(){
                        vm.success = true;
                    });
                };
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, RECURSO_EDUCATIVO_FORM_ADMIN) {
        var config = RECURSO_EDUCATIVO_FORM_ADMIN();
        var base = "admin/aulaDigital/recursoEducativo";
        var params = {
            parent: "admin/aulaDigital/tema",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{temaid}/recurso-educativo",
            translateBase: "aulaDigital.recursoEducativo.admin.",
            templateList: '<recurso-educativo-list-admin></recurso-educativo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                tema: function ($stateParams, Tema) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    return Tema.get({id: $stateParams.temaid}).$promise;
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (RecursoEducativo, $stateParams) {
                    return RecursoEducativo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('recursoEducativoListAdmin', {
            templateUrl: 'app/components/auladigital/admin/recursoeducativo/recurso-educativo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, RecursoEducativo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = RecursoEducativo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.temaid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (RecursoEducativo) {
                            return RecursoEducativo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.recursoEducativo.admin.delete.title',
                                body: 'aulaDigital.recursoEducativo.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('RECURSO_EDUCATIVO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<recurso-educativo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'temas="' + resolve + 'temas" ' +
                '></recurso-educativo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (RecursoEducativo) {
                        return new RecursoEducativo();
                    },
                    /* @ngInject */
                    temas: function ($stateParams, Tema) {
                        return Tema.query({
                            padreId: $stateParams.materiaid,
                            sortProperty: 'orden'
                        }).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('recursoEducativoFormAdmin', {
            templateUrl: 'app/components/auladigital/admin/recursoeducativo/recurso-educativo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                temas: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService, AulaDigitalUtil) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        function init() {
            vm.urlBaseArchivo = AulaDigitalUtil.getRutaRecursos(vm.item.id);

            if (!vm.item.tema) {
                vm.item.tema = {id: $stateParams.temaid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/aulaDigital/recursoEducativo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('recuperarInit', {
            templateUrl: 'app/components/aspg/usuarios/recuperar/recuperar-init.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($timeout, Auth) {
                var vm = this;

                $timeout(function () {
                    angular.element('[ng-model="ctrl.email"]').focus();
                });

                vm.recuperar = function (email) {
                    Auth.resetPasswordInit(email).then(function () {
                        vm.success = true;
                    });
                };
            }
        });
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('recuperarFinish', {
            templateUrl: 'app/components/aspg/usuarios/recuperar/recuperar-finish.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($timeout, Auth, $stateParams) {
                var vm = this;

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                vm.save = function () {
                    if (vm.newPassword === vm.confirmPassword) {
                        Auth.resetPasswordFinish({
                            email: $stateParams.email,
                            key: $stateParams.key,
                            newPassword: vm.newPassword
                        }).then(function () {
                            vm.success = true;
                        });
                    }
                };
            }
        });
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:login
     * @description
     * Componente que muestra un formulario para acceder al espacio de usuario.
     *
     */
    angular
        .module('app')
        .component('login', {
            templateUrl: 'app/components/aspg/usuarios/login/login.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($rootScope, $state, $timeout, Auth, Principal) {
                var vm = this;

                vm.user = {};
                vm.rememberMe = false;

                var stateXogos = "enXogo/base";

                Principal.identity().then(function (data) {
                    if (data) {
                        $state.go(stateXogos);
                    }
                });

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                vm.login = function () {
                    Auth.login({
                        username: vm.username,
                        password: vm.password,
                        rememberMe: vm.rememberMe
                    }).then(function () {
                        $state.go(stateXogos);
                    }).catch(function (response) {
                        $rootScope.mostrarErrores(response, vm.form);
                    });

                }
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, TEMA_FORM_ADMIN) {
        var config = TEMA_FORM_ADMIN();
        var base = "admin/aulaDigital/tema";
        var params = {
            parent: "admin/aulaDigital/materia",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{materiaid}/tema",
            translateBase: "aulaDigital.tema.admin.",
            templateList: '<tema-list-admin></tema-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                materia: function ($stateParams, Materia) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    if ($stateParams.materiaid) {
                        return Materia.get({id: $stateParams.materiaid}).$promise;
                    } else return {};
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Tema, $stateParams) {
                    return Tema.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('temaListAdmin', {
            templateUrl: 'app/components/auladigital/admin/tema/tema-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Tema, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Tema;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.materiaid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Tema) {
                            return Tema.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.tema.admin.delete.title',
                                body: 'aulaDigital.tema.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('TEMA_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<tema-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'materias="' + resolve + 'materias" ' +
                '></tema-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Tema) {
                        return new Tema();
                    },
                    /* @ngInject */
                    materias: function ($stateParams, Materia) {
                        return Materia.query({
                            padreId: $stateParams.nivelid,
                            sortProperty: 'orden'
                        }).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('temaFormAdmin', {
            templateUrl: 'app/components/auladigital/admin/tema/tema-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                materias: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        function init() {
            if (!vm.item.materia) {
                vm.item.materia = {id: $stateParams.materiaid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/aulaDigital/tema/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/usuario', {
                parent: 'admin',
                url: '/admin/usuarios',
                redirectTo: 'admin/usuario/juegos',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    hideBreadcrumb: true
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/aspg/usuarios/admin/usuarios-template.admin.html'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/usuarios');
                    }
                }
            })
            .state('admin/usuario/juegos', {
                parent: 'admin/usuario',
                url: '/juegos/:page',
                data: {
                    pageTitle: 'usuarios.admin.usuarios.titulo'
                },
                views: {
                    'contentUsuario': {
                        template: '<usuarios-list-admin></usuarios-list-admin>'
                    }
                }
            })
            .state('admin/usuario/suscriptor', {
                parent: 'admin/usuario',
                url: '/suscriptores/:page',
                data: {
                    pageTitle: 'usuarios.admin.suscriptores.titulo'
                },
                views: {
                    'contentUsuario': {
                        template: '<suscriptores-list-admin></suscriptores-list-admin>'
                    }
                }
            })
            .state('admin/usuario/email', {
                parent: 'admin/usuario',
                url: '/email',
                data: {
                    pageTitle: 'usuarios.admin.email.titulo'
                },
                views: {
                    'contentUsuario': {
                        template: '<enviar-mail suscriptores="$resolve.suscriptores"></enviar-mail>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    suscriptores: function (Suscriptor) {
                        return Suscriptor.query({infoGeneral: true, infoJuegos: true, infoTienda: true}).$promise;
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, MATERIA_FORM_ADMIN) {
        var config = MATERIA_FORM_ADMIN();
        var base = "admin/aulaDigital/materia";
        var params = {
            parent: "admin/aulaDigital/nivelEducativo",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{nivelid}/materia",
            translateBase: "aulaDigital.materia.admin.",
            templateList: '<materia-list-admin></materia-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                nivelEducativo: function ($stateParams, NivelEducativo) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    return NivelEducativo.get({id: $stateParams.nivelid}).$promise;
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Materia, $stateParams) {
                    return Materia.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('materiaListAdmin', {
            templateUrl: 'app/components/auladigital/admin/materia/materia-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Materia, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Materia;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.nivelid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Materia) {
                            return Materia.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.materia.admin.delete.title',
                                body: 'aulaDigital.materia.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('MATERIA_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<materia-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'niveles-educativos="' + resolve + 'nivelesEducativos" ' +
                '></materia-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Materia) {
                        return new Materia();
                    },
                    /* @ngInject */
                    nivelesEducativos: function (NivelEducativo) {
                        return NivelEducativo.query({sortProperty: 'orden'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('materiaFormAdmin', {
            templateUrl: 'app/components/auladigital/admin/materia/materia-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                nivelesEducativos: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        function init() {
            if (!vm.item.nivelEducativo) {
                vm.item.nivelEducativo = {id: $stateParams.nivelid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/aulaDigital/materia/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, NIVEL_EDUCATIVO_FORM_ADMIN, COMPONENTES, PERMISOS) {
        var permisos = COMPONENTES.aulaDigital.nivelesAdmin;

        var config = NIVEL_EDUCATIVO_FORM_ADMIN();
        var base = "admin/aulaDigital/nivelEducativo";
        var params = {
            base: base,
            view: 'contentChildren',
            baseUrl: "/" + base,
            translateBase: "aulaDigital.nivelEducativo.admin.",
            templateList: '<nivel-educativo-list-admin permisos="$resolve.permisos"></nivel-educativo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN'],
                hideBreadcrumb: true
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                breadcrumb: function ($breadcrumb) {
                    return $breadcrumb;
                },
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/aulaDigital');
                }
            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                permisos: function () {
                    return permisos;
                }
            }
        });
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (NivelEducativo, $stateParams) {
                    return NivelEducativo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados

        if (PERMISOS('list', permisos)) {
            $stateProvider
                .state(params.base, state.parent)
                .state(state.list.name, state.list);
        }
        if (PERMISOS('create', permisos)) {
            $stateProvider
                .state(state.create.name, state.create);
        }
        if (PERMISOS('edit', permisos)) {
            $stateProvider
                .state(state.edit.name, state.edit);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('nivelEducativoListAdmin', {
            templateUrl: 'app/components/auladigital/admin/niveleducativo/nivel-educativo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, NivelEducativo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = NivelEducativo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (NivelEducativo) {
                            return NivelEducativo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.nivelEducativo.admin.delete.title',
                                body: 'aulaDigital.nivelEducativo.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('NIVEL_EDUCATIVO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<nivel-educativo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></nivel-educativo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (NivelEducativo) {
                        return new NivelEducativo();
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('nivelEducativoFormAdmin', {
            templateUrl: 'app/components/auladigital/admin/niveleducativo/nivel-educativo-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/aulaDigital/nivelEducativo/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('museos', {
                parent: 'public',
                url: '/museos',
                redirectTo: 'museos/lista',
                data: {
                    authorities: [],
                    pageTitle: 'museos.titulo'
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/museos');
                    },
                    /* @ngInject */
                    museos: function (Museo) {
                        return Museo.findPublic({sortProperty: 'orden'}).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            })
            .state('museos/lista', {
                parent: 'museos',
                url: '',
                views: {
                    'content@': {
                        template: '<h1 translate="museos.titulo"></h1>' +
                        '<museo-list-public museos="$resolve.museos"></museo-list-public>'
                    }
                }
            })
            .state('museos/museo', {
                parent: 'museos',
                url: '/{url}',
                redirectTo: 'museos/museo/salas',
                params: {museo: null},
                views: {
                    'content@': {
                        templateUrl: 'app/components/aspg/museos/public/museos-template.public.html',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    url: function ($stateParams) {
                        return $stateParams.url;
                    },
                    /* @ngInject */
                    museo: function ($stateParams, Museo, url) {
                        if ($stateParams.museo !== null)
                            return $stateParams.museo;

                        return Museo.getByUrl({url: url});
                    }
                }
            })
            .state('museos/museo/salas', {
                parent: 'museos/museo',
                url: '',
                views: {
                    'seccionesMuseo': {
                        template: '<sala-list-public salas="$resolve.salas"></sala-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    salas: function ($stateParams, SalaMuseo) {
                        return SalaMuseo.findByMuseoUrl({url: $stateParams.url}).$promise.then(function (data) {
                            if (!data || !data.length) {
                                return [];
                            }
                            return data;
                        });
                    }
                }
            })
            .state('museos/museo/sala', {
                parent: 'museos/museo',
                url: '/{id}',
                params: {sala: null},
                views: {
                    'seccionesMuseo': {
                        template: '<obra-list-public obras="$resolve.obras" sala="$resolve.sala"></obra-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    obras: function ($stateParams, ObraMuseo) {
                        return ObraMuseo.findBySala({id: $stateParams.id}).$promise.then(function (data) {
                            return data;
                        });
                    },
                    sala: function ($stateParams, SalaMuseo) {
                        if ($stateParams.sala !== null) {
                            return $stateParams.sala;
                        }
                        else {
                            return SalaMuseo.query({id: $stateParams.id}).$promise.then(function (data) {
                                return data;
                            });
                        }
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('boletin', {
                parent: 'public',
                url: '/boletines',
                redirectTo: 'boletin/list',
                data: {
                    authorities: [],
                    pageTitle: 'boletines.titulo'
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/boletines');
                    }
                }
            })
            .state('boletin/list', {
                parent: 'boletin',
                url: '/p/{page}',
                params: {
                    page: '1'
                },
                views: {
                    'content@': {
                        template: '<h1 translate="boletines.titulo"></h1>' +
                        '<boletin-list-public boletines="$resolve.boletines"></boletin-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    boletines: function ($stateParams, Boletin, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                        return Boletin.query({
                            page: $stateParams.page ? $stateParams.page - 1 : null,
                            size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size,
                            sortProperty: 'numero',
                            sortDirection: 'DESC'
                        }).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('boletinListPublic', {
            templateUrl: 'app/components/aspg/boletin/public/boletin-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                boletines: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams) {
        var vm = this;

        vm.page = $stateParams.page;
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('boletinDetailsPublic', {
            templateUrl: 'app/components/aspg/boletin/public/boletin-details.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                boletin: '<'
            }
        });

    /* @ngInject */
    function Controller(BoletinUtil, ModalService) {
        var vm = this;

        vm.urlBaseImagen = BoletinUtil.getRutaImagen(vm.boletin.id);
        vm.urlBaseArchivo = BoletinUtil.getRutaArchivo(vm.boletin.id);

        vm.fecha = Date.parse(vm.boletin.mes + '/01/' + vm.boletin.ano);

        if (vm.boletin.imagenPath !== null) {
            vm.imagen = 'url("' + vm.urlBaseImagen + 'n_' + vm.boletin.imagenPath + '")';
        } else {
            vm.imagen = 'url("assets/images/boletines/boletin-electronico.jpg")';
        }

        vm.abrirImagen = function () {
            if (vm.boletin.imagenPath !== null) {
                ModalService.openImagen(vm.urlBaseImagen + vm.boletin.imagenPath);
            }
        };

        vm.abrirSeccion = function (seccion) {
            ModalService.open({
                templateUrl: 'app/components/aspg/boletin/public/seccion-boletin-details.public.html',
                size: 'lg',
                controllerAs: 'ctrl',
                /* @ngInject */
                controller: function (ModalService, boletin, seccion, fecha) {
                    var vm = this;
                    vm.boletin = boletin;
                    vm.seccion = seccion;
                    vm.fecha = fecha;
                    vm.dismiss = function () {
                        ModalService.dismiss();
                    };
                },
                resolve: {
                    boletin: function () {
                        return vm.boletin;
                    },
                    seccion: function () {
                        return seccion;
                    },
                    fecha: function () {
                        return vm.fecha;
                    }
                }
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('web', {
                parent: 'public',
                url: '/web',
                redirectTo: 'web/categorias',
                data: {
                    authorities: [],
                    pageTitle: 'web.titulo'
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/webs');
                    },
                    /* @ngInject */
                    categorias: function (CategoriaWeb) {
                        return CategoriaWeb.query({sortProperty: 'orden'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            })
            .state('web/categorias', {
                parent: 'web',
                url: '',
                views: {
                    'content@': {
                        template: '<h1 translate="web.titulo"></h1>' +
                        '<p translate="web.intro1"></p><p translate="web.intro2"></p>' +
                        '<categoria-web-list-public categorias="$resolve.categorias"></categoria-web-list-public>'
                    }
                }
            })
            .state('web/websByCategoria', {
                parent: 'web',
                url: '/{categoriaUrl}',
                views: {
                    'content@': {
                        templateUrl: 'app/components/web/public/web-list-template.public.html',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    webs: function ($stateParams, Web) {
                        return Web.findByCategoriaUrl({categoriaUrl: $stateParams.categoriaUrl}).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('webListPublic', {
            templateUrl: 'app/components/web/public/web-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                webs: '<'
            }
        });

    /* @ngInject */
    function Controller(RutasService, WebUtil) {
        var vm = this;

        vm.rutaBase = RutasService.getBaseUrl() + WebUtil.getRutaWebPublica();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaWebListPublic', {
            templateUrl: 'app/components/web/public/categoria-web-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                categorias: '<'
            }
        });

    /* @ngInject */
    function Controller() {

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('novedad', {
                parent: 'public',
                url: '/novedades',
                redirectTo: 'novedades/list',
                data: {
                    authorities: [],
                    pageTitle: 'novedades.titulo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/novedades/public/novedad-template.public.html',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/novedades');
                    },
                    /* @ngInject */
                    categorias: function (CategoriaNovedad, Permisos, COMPONENTES) {
                        // Si no se tienen permisos, no se el menú de categorías
                        if (Permisos.tienePermisos('list', COMPONENTES.novedades.categoriasPublic)) {
                            return CategoriaNovedad.query({
                                sortProperty: 'nombre',
                                sortDirection: 'ASC'
                            }).$promise.then(function (data) {
                                return data;
                            });
                        }
                    },
                    /* @ngInject */
                    menu: function ($translate, categorias) {
                        if (categorias) {
                            var categoriasMenu = [{
                                "label": $translate.instant("novedades.categoriaNovedad.todas"),
                                "state": "novedad/list({categoriaUrl: null})"
                            }];
                            for (var i = 0; i < categorias.content.length; i++) {
                                categoriasMenu.push({
                                    "label": categorias.content[i].nombre,
                                    "state": "novedad/listByCategoria({categoriaUrl: '" + categorias.content[i].url + "', page: '1'})"
                                });
                            }
                            return categoriasMenu;
                        }
                    },
                    /* @ngInject */
                    rssUrl: function (Language, RutasService) {
                        return RutasService.getBaseUrl() + "/rss/novedades?idioma=" + Language.getCurrent();
                    }
                }
            })
            .state('novedades/list', {
                parent: 'novedad',
                url: '/p/{page}?etiqueta',
                params: {
                    categoriaUrl: 'novedades',
                    page: '1',
                    etiqueta: null
                },
                views: {
                    'contentNovedades': {
                        template: '<novedad-list-public novedades="$resolve.novedades" etiqueta="$resolve.etiqueta" categorias-novedad="$resolve.categoria"></novedad-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    novedades: function ( $stateParams, Novedad, Language, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                        var filter = {
                            categoriaUrl: $stateParams.categoriaUrl,
                            page: $stateParams.page ? $stateParams.page - 1 : null,
                            idioma: Language.getCurrent(),
                            size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size,
                            sortProperty: 'n.fecha',
                            sortDirection: 'DESC',
                            etiqueta: $stateParams.etiqueta
                        };
                        return Novedad.findPublic(filter).$promise;
                    },
                    etiqueta: function ($stateParams){
                        return $stateParams.etiqueta;
                    },
                    categoria: function ($stateParams){
                        return $stateParams.categoriaUrl;
                    }

                }
            })
            .state('novedad/listByCategoria', {
                parent: 'novedad/list',
                url: '/categoria/:categoriaUrl'
            })
            .state('novedades/details', {
                parent: 'novedad',
                url: '/{url}',
                views: {
                    'content@': {
                        template: '<h1 translate="novedades.ultimas"></h1>' +
                        '<novedad-details-public novedad="$resolve.novedad" ampliada="true"></novedad-details-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    novedad: function ($stateParams, Novedad, Language) {
                        return Novedad.getByUrl({
                            url: $stateParams.url,
                            idioma: Language.getCurrent()
                        }).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('novedadListPublic', {
            templateUrl: 'app/components/novedades/public/novedad-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                categoriasNovedad: '<',
                novedades: '<',
                etiqueta: '<'
            }
        });

    /* @ngInject */
    function Controller($state, $stateParams) {
        var vm = this;

        vm.page = $stateParams.page;

        vm.search = function () {
            vm.filtro.categoriaNovedadId = vm.filtro.categoriaNovedad !== null ? vm.filtro.categoriaNovedad.id : null;
            $state.go($state.current, $state.params);
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('novedadDetailsPublic', {
            templateUrl: 'app/components/novedades/public/novedad-details.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                novedad: '<',
                ampliada: '<'
            }
        });

    /* @ngInject */
    function Controller(ModalService, NovedadUtil, Language) {
        var vm = this;

        vm.ruta = NovedadUtil.getRuta(vm.novedad.id);
        vm.lang = Language.getCurrent();

        if (vm.novedad.imagenPath !== null) {
            vm.imagen = 'url("' + vm.ruta + 'n_' + vm.novedad.imagenPath + '")';
        } else {
            vm.imagen = 'url("assets/images/novedades/novidades.jpg")';
        }

        vm.abrirImagen = function () {
            if (vm.novedad.imagenPath !== null) {
                ModalService.openImagen(vm.ruta + vm.novedad.imagenPath);
            }
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:tooltip
     *
     * @param {String} label Texto a internacionalizar que se mostrará en el tooltip
     * @param {String} [position=right] Posición del tooltip. Valores: _top_, _top-left_, etc.
     *
     * @description
     * Referencia: {@link https://angular-ui.github.io/bootstrap/#tooltip}
     *
     */
    angular
        .module('app')
        .component('tooltip', {
            templateUrl: 'app/components/form/tooltip/tooltip.html',
            bindings: {
                label: '@',
                position: '@'
            },
            controllerAs: 'ctrl'
        });

})();

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:sameAs
     * @description
     * Directiva para comprobar que dos campos son iguales.
     *
     * Utilizada, por ejemplo, cuando hay que comprobar que le usuario introdujo la misma contraseña dos veces.
     *
     * @param {Object} sameAs Elemento con el que se va a comparar
     *
     */
    angular.module('app')
        .directive('sameAs', directive);

    function directive() {
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ngModel) {
                ngModel.$parsers.unshift(validate);

                scope.$watch(attrs.sameAs, function () {
                    ngModel.$setViewValue(ngModel.$viewValue);
                });

                function validate(value) {
                    var isValid = scope.$eval(attrs.sameAs) === value;
                    ngModel.$setValidity('sameAs', isValid);
                    return isValid ? value : undefined;
                }
            }
        };
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:textArea
     * @description
     * Componente que añade un editor de texto enriquecido.
     *
     * Referencia: {@link https://docs.ckeditor.com/ckeditor4/docs/}.
     *
     * @param {Object} model Campo que se modificará
     * @param {String} id Identificador del elemento
     * @param {String} name Nombre del elemento. En caso de no indicarse nada, se utilizará el ID
     * @param {String} label Etiqueta
     * @param {Boolean} [disabled=false] Editor deshabilitado
     * @param {Boolean} [required=false] Campo obligatorio
     * @param {String} [tipo=basico] Tipo de editor. Tipos existentes: basico, normal, completo|estatica
     * @param {Number} [height=250] Altura del editor
     * @param {Number} [max=-1] Número máximo de caracteres
     * @param {String} clase Clase que aplicará al contenido del editor de texto.
     *
     * @requires app.directive:ckEditor
     *
     */
    angular
        .module('app')
        .component('textArea', {
            template: '<label-form key="{{ctrl.label}}" for="{{ctrl.id}}" required="ctrl.required"></label-form>' +
            '<textarea ck-editor id="{{ctrl.id}}" ng-model="ctrl.model" clase="{{ctrl.clase}}"' +
            ' tipo="{{ctrl.tipo}}" height="{{ctrl.height}}" max="{{ctrl.max}}"' +
            ' ng-required="ctrl.required" ng-disabled="ctrl.disabled"></textarea>',
            bindings: {
                model: '=',
                id: '@',
                name: '@',
                label: '@',
                disabled: '<',
                required: '<',
                tipo: '@',
                height: '@',
                max: '@',
                clase: '@'
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller() {
        var vm = this;

        vm.tipo = vm.tipo || 'basico';
        vm.height = vm.height || 250;
        vm.max = vm.max || -1;
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:tesauro
     * @description
     * Componente que incluye un campo autocompletable.
     *
     * __Nota:__ `restricted` debería ser siempre true, ya que se desaconseja crear tesauros de manera dinámica en base de datos.
     * También se aconseja poner a true el campo `eliminable`.
     *
     * Referencia: {@link https://angular-ui.github.io/bootstrap/#typeahead}
     *
     * @param {Object} ngModel Objeto en el que se almacenará el resultado
     * @param {String} id ID del input
     * @param {String} label Etiqueta
     * @param {String} placeholder Placeholder del input
     * @param {String} tooltip Etiqueta del tooltip
     * @param {String} [key='id'] Clave única para el track by
     * @param {String} [display='nombre'] Propiedad que se va a mostrar
     * @param {Object} resource Servicio de tipo $resource sobre el que se ejecutará la operación de búsqueda
     * @param {String} [method='query'] Método del servicio (resource) que se utilizará en las búsquedas
     * @param {String} [queryParam='query'] Atributo en el que va a ir el texto de búsqueda al realizar la petición
     * @param {Object} parameters Parámetros que se enviarán en la petición. Útil para paginar resultados o obtenerlos ordenados
     * @param {Boolean} [required=false] Indica si el campo es obligatorio
     * @param {Boolean} [eliminable=false] Muestra el botón de eliminar junto al input
     * @param {Boolean} [restricted=false] Solo permite añadir elementos que están en el autocompletado. Si no está, se vaciará de manera automática
     * @param {Boolean} [disabled=false] Permite deshabilitar los inputs
     * @param {Number} [minLength=1] Número de caracteres requeridos para iniciar el autocompletado
     * @param {String} templateUrl URL a un archivo HTML, o nombre del ID del HTML.
     * En `app/templates/tesauro.templates.html` se pueden definir las que se utilicen más de una vez
     * @param {Array} excluidos Lista de elementos que se van a excluir.
     * La exclusión se hace en el lado cliente, por lo que el número de elementos mostrados puede no coincidir con la paginación.
     * Por lo tanto, si se utiliza este campo no se aconseja hacer uso de la paginación.
     * @param {Boolean} [simpleListForm=false] Booleano para indicar si el tesauro está dentro del componente ListForm, siempre y cuando no sea un objeto compuesto.
     * En este caso la manera de limpiar el objeto es diferente. Ejemplo en `agente-form.admin.html`.
     *
     * @requires app.component:labelForm
     */
    angular
        .module('app')
        .component('tesauro', {
            controller: Controller,
            controllerAs: 'ctrl',
            templateUrl: 'app/components/form/tesauro/tesauro.html',
            bindings: {
                ngModel: '=',
                id: '@',
                label: '@',
                placeholder: '@',
                tooltip: '@',
                key: '@',
                display: '@',
                resource: '<',
                method: '@',
                queryParam: '@',
                parameters: '<',
                required: '<',
                eliminable: '<',
                restricted: '<',
                disabled: '<',
                minLength: '@',
                templateUrl: '@',
                excluidos: '<',
                simpleListForm: '<'
            }
        });

    function Controller() {
        var vm = this;

        // Valores por defecto
        vm.key = vm.key || "id";
        vm.display = vm.display || "nombre";
        vm.method = vm.method || "query";
        vm.queryParam = vm.queryParam || "query";
        vm.minLength = vm.minLength || 1;

        //

        vm.clear = function () {
            if (!vm.simpleListForm) {
                vm.ngModel = null;
            } else {
                // En los casos en los que se trate de una lista de elementos se eliminan las propiedades del objeto para no perder la referencia.
                cleanJson(vm.ngModel);
            }
        };

        vm.onBlur = function () {
            // Cuando se pierde el foco se comprueba si se ha vaciado el input.
            // Si es así y además es restricted, se eliminan el resto de datos.
            if ((!vm.ngModel || !vm.ngModel[vm.display]) && vm.restricted) {
                vm.clear();
            }
        };

        vm.setElement = function (item) {
            if (item.id) {
                angular.extend(vm.ngModel, item);
            }
        };

        vm.loadTags = function (query) {
            var params = !vm.parameters ? {} : vm.parameters;
            params[vm.queryParam] = query;
            return vm.resource[vm.method](params).$promise.then(function (data) {
                var lista;
                if (Array.isArray(data)) {
                    lista = data;
                } else {
                    lista = data.content;
                }
                return excluir(lista);
            });
        };

        // Excluimos de la lista de resultados los elementos que ya han sido seleccionados
        function excluir(lista) {
            if (vm.excluidos && vm.excluidos[0][vm.key]) {
                for (var i = 0; i < vm.excluidos.length; i++) {
                    for (var j = 0; j < lista.length; j++) {
                        if (vm.excluidos[i][vm.key] === lista[j][vm.key]) {
                            lista.splice(j, 1);
                            j = lista.length;
                        }
                    }
                }
            }
            return lista;
        }

    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:tags
     * @description
     * Componente para incluir un componente de etiquetas. Similar al componente tesauro pero en un mismo input.
     *
     * __Nota:__ `restricted` debería ser siempre true, ya que se desaconseja crear elementos de manera dinámica en base de datos.
     *
     * Referencia: {@link http://mbenford.github.io/ngTagsInput/}
     *
     * @param {Object} ngModel Objeto en el que se almacenará el resultado
     * @param {String} id ID del input
     * @param {String} label Etiqueta
     * @param {String} placeholder Placeholder del input
     * @param {String} tooltip Etiqueta del tooltip
     * @param {String} [key='id'] Clave única para el track by
     * @param {String} [display='nombre'] Propiedad que se va a mostrar
     * @param {Object} resource Servicio de tipo $resource sobre el que se ejecutará la operación de búsqueda
     * @param {String} [method='query'] Método del servicio (resource) que se utilizará en las búsquedas
     * @param {String} [queryParam='query'] Atributo en el que va a ir el texto de búsqueda al realizar la petición
     * @param {Object} parameters Parámetros que se enviarán en la petición. Útil para paginar resultados o obtenerlos ordenados
     * @param {Boolean} [required=false] Indica si el campo es obligatorio
     * @param {Boolean} [restricted=false] Solo permite añadir elementos que están en el autocompletado. Si no está, se vaciará de manera automática
     * @param {Boolean} [disabled=false] Permite deshabilitar los inputs
     * @param {Number} [minLength=1] Número de caracteres requeridos para iniciar el autocompletado
     * @param {Boolean} [asList=false] Añade la clase `as-list` a los elementos para mostrarlos uno debajo de otro en lugar de en línea
     *
     * @requires app.component:labelForm
     */
    angular
        .module('app')
        .component('tags', {
            controller: Controller,
            controllerAs: 'ctrl',
            templateUrl: 'app/components/form/tags/tags.html',
            bindings: {
                ngModel: '=',
                id: '@',
                label: '@',
                placeholder: '@',
                tooltip: '@',
                key: '@',
                display: '@',
                resource: '<',
                method: '@',
                queryParam: '@',
                parameters: '<',
                required: '<',
                restricted: '<',
                disabled: '<',
                minLength: '@',
                asList: '<'
            }
        });

    function Controller() {
        var vm = this;

        // Valores por defecto
        vm.key = vm.key || "nombre";
        vm.display = vm.display || "nombre";
        vm.method = vm.method || "query";
        vm.queryParam = vm.queryParam || "query";
        vm.minLength = vm.minLength || 1;

        if (!vm.ngModel) {
            vm.ngModel = [];
        }

        //

        vm.setElement = function (item) {
            if (item.id && !vm.multiple) {
                vm.ngModel.id = item.id;
            }
        };

        vm.loadTags = function (query) {
            var params = !vm.parameters ? {} : vm.parameters;
            params[vm.queryParam] = query;
            return vm.resource[vm.method](params).$promise.then(function (data) {
                if (Array.isArray(data)) {
                    return data;
                } else {
                    return data.content;
                }
            });
        };
    }

})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
            '<small translate="password.strength"></small>' +
            '<ul id="strengthBar">' +
            '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
            '</ul>' +
            '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return {idx: idx + 1, col: this.colors[idx]};
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({'background-color': '#DDD'})
                        .slice(0, c.idx)
                        .css({'background-color': c.col});
                }
            });
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:selectForm
     * @description
     * Componente para incluir un select de elementos.
     *
     * __Nota sobre el formateado:__ Se acepta dar un formato especial a los selects.
     * Para esto habrá que pasar listas de elementos, separadas por comas, en display y base, además del campo format.
     * Este campo tendrá un _ en cada variable que se quiera rellenar (uno por cada display).
     *
     * Ejemplo: `display="nombre,id" format="_ (_)"`, producirá una lista de elementos de la siguiente forma: `Cervantes (1)`.
     *
     * @param {Object} model Objeto en el que se almacenará el resultado
     * @param {Array} options Lista de opciones
     * @param {String} id ID del input
     * @param {String} label Etiqueta
     * @param {String} tooltip Etiqueta del tooltip
     * @param {String} [empty=""] Etiqueta cuando no hay elementos seleccionados
     * @param {String} [display="nombre"] Propiedad que se mostrará al seleccionar. Permite recibir una lista de propiedades separados por comas
     * @param {String} [format="_"] Formato que tendrá el select. Se pondrá un _ por cada variable indicada en el display.
     * @param {Boolean} [required=false] Campo requerido
     * @param {Boolean} [disabled=false] Select deshabilitado
     * @param {String} base Texto base del enumerado. Con este String se sabe si se está mostrando un enumerado o un objeto. Ej: `enum.idiomas.`
     * @param {Function} change Función que se llama al seleccionar un elemento
     *
     * @requires app.component:labelForm
     */
    angular
        .module('app')
        .component('selectForm', {
            templateUrl: 'app/components/form/select/select-form.html',
            controllerAs: 'ctrl',
            bindings: {
                model: '=', // required
                options: '<', // required
                id: '@',
                label: '@',
                tooltip: '@',
                empty: '@',
                display: '@',
                format: '@',
                required: '<',
                disabled: '<',
                base: '@',
                change: '='
            },
            /* @ngInject */
            controller: function ($translate) {
                var vm = this;

                // Valores por defecto
                vm.display = vm.display || "nombre";
                vm.format = vm.format || "_";
                vm.base = vm.base || "";

                var list = vm.display.split(",");

                var base = vm.base.split(",");

                // FIXME: Esta operación se llama cada vez que se interactúa con un select para recalcular el valor de TODOS los options de todos los selects.
                vm.formatElement = function (element) {
                    var formated = vm.format;
                    angular.forEach(list, function (elementDisplay, index) {
                        var baseText = base[index] ? base[index].trim() : "";
                        var translated = $translate.instant(baseText + element[elementDisplay.trim()]);
                        formated = formated.replace("_", translated);
                    });
                    return formated;
                }
            }
        });

})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('radio', radio);

    function radio() {
        return {
            restrict: 'E',
            scope: {
                id: '@',
                name: '@',
                model: '=',
                change: '=',
                value: '=',
                disabled: '=',
                label: '@',
                text: '='
            },
            template: '' +
            '<label ng-click="disabled || (model=value)" for="{{id}}">' +
            '<input type="radio" id="{{id}}" name="{{name}}" ng-model="model" ng-value="value"' +
            ' ng-checked="model==value" ng-click="model=value" ng-change="change(model)" ng-disabled="disabled"/>' +
            '<span class="texto" ng-if="label">{{label | translate}}</span>' +
            '<span class="texto" ng-if="text" ng-bind-html="text"></span>' +
            '</label>',

            compile: function (tElt) {
                // tElt.addClass('sm-radio');
            }
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:multiSelect
     * @description
     * Componente para incluir un componente de etiquetas. Similar al componente tesauro pero en un mismo input.
     *
     * __Nota sobre el rendimiento:__ Hasta 50 no se nota ningún tiempo de espera. Sin embargo, a partir de 100 se nota que le cuesta abrir, pero es asumible.
     * Con 1000 elementos ya tarda varios segundos.
     *
     * Referencia: {@link http://dotansimha.github.io/angularjs-dropdown-multiselect/docs}
     *
     * @param {Object} model Objeto en el que se almacenará el resultado
     * @param {String} id ID del input
     * @param {String} label Etiqueta
     * @param {String} tooltip Etiqueta del tooltip
     * @param {String} [empty='multiselect.default'] Etiqueta cuando no hay elementos seleccionados
     * @param {Array} options Lista de opciones
     * @param {String} [display="nombre"] Propiedad que se mostrará al seleccionar
     * @param {String} template Información que se va a mostrar. Tiene que ir entre comillas
     * Ej: `'{{option.nombre}} <span ng-if=\'option.pais.nombre\'>({{option.pais.nombre}})</span>'`
     * @param {String} enumBase Texto base del enumerado. Con este String se sabe si se está mostrando un enumerado o un objeto. Ej: `enum.idiomas.`
     * @param {Object} extra Propiedades para sobreescribir en formato json. Sobreescriben las indicadas anteriormente
     *
     * @requires app.component:labelForm
     */
    angular
        .module('app')
        .component('multiSelect', {
            templateUrl: 'app/components/form/multiselect/multi-select.html',
            bindings: {
                model: '=',
                id: '@',
                label: '@',
                tooltip: '@',
                empty: '@',
                options: '<',
                display: '@',
                template: '<',
                enumBase: '@',
                extra: '<'

            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($translate) {
        var vm = this;

        // Valores por defecto
        vm.display = vm.display || "nombre";

        if (!vm.model) {
            vm.model = [];
        }

        //

        vm.extraSettings = {
            smartButtonMaxItems: 4,

            enableSearch: true,
            clearSearchOnClose: true,

            selectedToTop: true,
            showUncheckAll: false,
            showCheckAll: false
        };

        if (!vm.enumBase) {
            angular.merge(vm.extraSettings, {
                displayProp: vm.display,
                searchField: vm.display,
                idProperty: 'id'
            });
        } else {
            // Enumerados
            angular.merge(vm.extraSettings, {
                // Función para personalizar el texto que se muestra en el botón
                smartButtonTextProvider: function (selectionArray) {
                    var text = "";
                    selectionArray.forEach(function (element, index) {
                        text += $translate.instant(vm.enumBase + element);
                        if (index + 1 < selectionArray.length) {
                            text += ", ";
                        }
                    });
                    return text;
                }
            });
        }

        if (vm.template) {
            vm.extraSettings.template = vm.template;
        }

        if (vm.extra) {
            angular.merge(vm.extraSettings, vm.extra);
        }

        // Traducciones de los textos
        vm.translations = {
            buttonDefaultText: vm.empty ? $translate.instant(vm.empty) : $translate.instant("multiselect.default"),
            searchPlaceholder: $translate.instant("multiselect.search"),
            selectionCount: $translate.instant("multiselect.selectioncount")
        };

        // Elemento seleccionado
        vm.onItemSelect = function (item) {

        };

    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:labelForm
     *
     * @param {String} key Texto a internacionalizar
     * @param {String} for ID del input asociado
     * @param {Boolean} [puntos=false] Añadir dos puntos al final de la etiqueta
     * @param {String} [tooltip=undefined] Mensaje del tooltip
     * @param {String} [tooltipPosition='bottom'] Posición del tooltip
     * @param {Boolean} [required=false] Campo obligatorio
     *
     * @requires app.component:tooltip
     */
    angular
        .module('app')
        .component('labelForm', {
            template: '<label ng-if="ctrl.key" class="control-label" ng-class="{\'required\' : ctrl.required}" for="{{ctrl.for}}">' +
            '{{ctrl.key | translate}}<span ng-if="ctrl.required">*</span><span ng-if="ctrl.puntos">:</span>' +
            '</label><tooltip ng-if="ctrl.tooltip" label="{{ctrl.tooltip}}" position="{{ctrl.tooltipPosition}}"></tooltip>',
            bindings: {
                key: '@', // required
                for: '@',
                puntos: '<',
                tooltip: '@',
                tooltipPosition: '@',
                required: '<'
            },
            controllerAs: 'ctrl'
        });

})();

(function () {
    'use strict';

    // TODO: Añadir un botón para crear un nuevo elemento del tesauro para cuando es una lista simple de entidades: "Crear y asignar"
    // TODO: Poner ejemplo de acordeon

    /**
     * @ngdoc component
     * @name app.component:listForm
     * @description
     * Este componente permite la gestión (añadir y eliminar) elementos de una lista de manera dinámica.
     *
     * __Nota:__ Dentro de la plantilla (templateUrl) hay que utilizar la variable `element`, ya que será así como se llame a cada objeto sobre el que se itere en el array.
     *
     * Ejemplo: `original-form.admin.html`.
     *
     * @param {String} label Texto para la etiqueta
     * @param {String} tooltip Texto para el tooltip
     * @param {Array} list Lista de elementos que se modificará
     * @param {Object} resolve Información del controller desde donde es invocado el componente.
     * Ej: `{agenteService: ctrl.agenteService, openAgenteModal: ctrl.openAgenteModal}`
     * @param {String} templateUrl ID de la plantilla HTML que se mostrará, con los diferentes inputs
     * @param {Boolean} [required=false] Si es true, siempre habrá al menos un elemento en la lista
     * @param {Boolean} [acordeon=false] Indica si cada elemento se incluye en un acordeón. Se usa para ajustar el botón de eliminar
     * @param {Boolean} [noLabels=false] Indica que las filas no incluyen etiquetas, por lo que hay que ajustar la posición del botón de eliminar
     *
     * @requires app.component:labelForm
     *
     */
    angular
        .module('app')
        .component('listForm', {
            templateUrl: 'app/components/form/listform/list-form.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                label: '@',
                tooltip: '@',
                list: '=',
                resolve: '<',
                templateUrl: '@',
                required: '<',
                acordeon: '<',
                noLabels: '<'
            }
        });

    /* @ngInject */
    function Controller() {
        var vm = this;

        function initList() {
            if (!vm.list) {
                vm.list = [];
                if (vm.required) {
                    vm.list.push({});
                }
            } else if (!vm.list.length && vm.required) {
                vm.list.push({});
            }
        }

        vm.addElement = function () {
            vm.list.push({desplegado: true});
        };

        vm.removeElement = function (element) {
            vm.list.splice(vm.list.indexOf(element), 1);
            initList();
        };

        initList();
    }

})();

(function () {
    'use strict';

    // Componente que mete en una variable el día, mes y año de nacimiento/muerte/fecha genérica.
    // Es importante que las variables en el modelo se llamen prefijoX para que se pueda utilizar este componente.

    // model: Campo que se modificará.
    // prefijo: String. nacimiento | muerte | fecha. Se concatena este prefijo con el campo. Ej: nacimientoDia.

    angular
        .module('app')
        .component('fecha', {
            templateUrl: 'app/components/form/fecha/fecha.html',
            bindings: {
                model: '=',
                prefijo: '@',
                label: '@'
            },
            controllerAs: 'ctrl'
        });

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:filterInput
     * @description
     * Componente que incluye un input sobre las tablas para permitir el filtrado.
     *
     * @param {Object} filter Variable en la que se almacenará el texto del input
     *
     */
    angular
        .module('app')
        .component('filterInput', {
            templateUrl: 'app/components/form/filter/filter.input.html',
            bindings: {
                filter: '='
            },
            controllerAs: 'ctrl'
        });

})();

(function () {
    'use strict';

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // base: Clave base para los enumerados.
    // display: Propiedad del objeto que se usará para internacionalizar el contenido.
    // empty: Clave de mensaje para mostrar en la opción vacía

    // Nota: Para utilizar como un campo booleano (Null/Sí/No), pasar como options: [true, false].

    angular
        .module('app')
        .component('enumSelect', {
            templateUrl: 'app/components/form/enum/enum-select.html',
            bindings: {
                id: '@',
                label: '@',
                model: '=',
                change: '=',
                display: '@',
                empty: '@',
                disabled: '=',
                required: '=',
                options: '=',
                base: '@'
            },
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function () {
                var vm = this;

                vm.onChange = function (item) {
                    // Si el valor es "", se pone a null
                    if (!item) {
                        vm.model = null;
                    }

                    if (vm.change) {
                        vm.change(item);
                    }
                }
            }
        });

})();

(function () {
    'use strict';

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // empty: Clave de mensaje para mostrar en la opción vacía

    // Nota: Para utilizar como un campo booleano (Null/Sí/No), pasar como options: [true, false].

    angular
        .module('app')
        .component('enumSelectBoolean', {
            templateUrl: 'app/components/form/enum/enum-select-boolean.html',
            controllerAs: 'ctrl',
            bindings: {
                id: '@',
                label: '@',
                model: '=',
                change: '=',
                empty: '@',
                disabled: '=',
                required: '='
            }
        });

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('EntityDeleteModalController', Controller);

    /* @ngInject */
    function Controller(item, params, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;
        vm.params = params;

        vm.confirmRemove = function () {
            vm.item.$remove({id: vm.item.id, borradoFisico: vm.params.borradoFisico}).then(function () {
                ModalService.close(vm.item);
            });
        };
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:datePicker
     * @description
     * Componente para la selección de una fecha.
     *
     * Referencia: https://angular-ui.github.io/bootstrap/#datepicker
     *
     * @param {String} id Identificador del select
     * @param {String} label Mensaje de la etiqueta
     * @param {Object} model Campo que se modificará
     * @param {Boolean} [disabled=false] Campo deshabilitado
     * @param {Boolean} [required=false] Campo obligatorio
     * @param {Object} [options={datepickerMode: 'year', formatYear: 'yyyy', maxDate: new Date(), startingDay: 1, showWeeks: false}]
     * Opciones para configurar el calendario. Ej: `{datepickerMode: 'day', maxDate: ''}`
     * @param {Boolean} [hoy=false] Si es true, en caso de que model sea null y además, required, se pondrá a día de hoy (`new Date()`)
     * @param {String} [format=dd/MM/yyyy] Formato de la fecha
     * @param {Function} change Función que se llamará al cambiar el input
     * @param {Boolean} [showBar=true] Booleano para mostrar u ocultar la barra inferior del DatePicker
     * @param {Boolean} [readonly=false] Booleano para deshabilitar el input
     *
     * @requires app.component:labelForm
     * @requires app.service:DateUtils
     *
     */
    angular
        .module('app')
        .component('datePicker', {
            templateUrl: 'app/components/form/date/date-picker.html',
            bindings: {
                id: '@',
                label: '@',
                model: '=', // required
                disabled: '<',
                required: '<',
                options: '<',
                hoy: '<',
                format: '@',
                change: '<',
                showBar: '<?', // opcional
                readonly: '<?' // opcional
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller(DateUtils) {
        var vm = this;

        function init() {
            // Si recibimos la fecha del servidor, convertimos segundos a milisegundos
            vm.model = DateUtils.convertDateTimeFromServer(vm.model);

            if (!vm.model && vm.required && vm.hoy) {
                vm.model = new Date();
            }
        }

        vm.opened = false;
        if (!vm.format) {
            vm.format = 'dd/MM/yyyy';
        }

        if (typeof(vm.showBar) === 'undefined') {
            vm.showBar = true;
        }

        if (typeof(vm.readonly) === 'undefined') {
            vm.readonly = false;
        }

        if (vm.options && vm.options.minDate === 'today') {
            vm.options.minDate = new Date();
        }

        vm.dateOptions = {
            datepickerMode: 'year',
            formatYear: 'yyyy',
            maxDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        angular.merge(vm.dateOptions, vm.options);

        vm.openDatePicker = function () {
            vm.opened = true;
        };

        init();
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:captcha
     * @description
     * Componente para la verificación de los usuarios mediante un captcha de Google (reCAPTCHA).
     *
     * Hay que definir en `apis.recaptcha` (en el archivo `config.js`) la clave de Google reCAPTCHA.
     * __Si no se define la clave__, este componente no se mostrará.
     *
     * Nota: Si no se quiere mostrar el mensaje de "Campo obligatorio", se puede deshabilitar el botón de submit en el formulario:
     * `ng-disabled="ctrl.form.$invalid"`.
     *
     * Referencia:
     *
     * https://github.com/VividCortex/angular-recaptcha
     *
     * https://www.google.com/recaptcha
     *
     *
     */
    angular
        .module('app')
        .component('captcha', {
            templateUrl: 'app/components/form/captcha/captcha.html',
            bindings: {
                onSuccess: '&'
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller(APIS) {
        var vm = this;

        vm.apiKey = APIS.recaptcha;

        vm.success = function (response) {
            vm.onSuccess({response: response});
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name app.controller:ConfirmModalController
     * @description
     * Controller que, asociado al archivo confirm.modal.html, permite abrir una ventana modal de confirmación que lanzará una acción.
     *
     * Es obligatorio indicar en el Resolve cada uno de los campos listados a continuación.
     *
     * @param {Object} item  Elemento del que se muestra información
     * @param {Object} params JSON de la forma {title: '', body: '', property: ''}
     * @param {Object} tipo Resource que tiene la función que se llamará
     * @param {String} funcion Nombre de la función
     * @param {Object} parametros Parameteros que se enviará la a función de confirmación
     */
    angular.module('app')
        .controller('ConfirmModalController', Controller);

    /* @ngInject */
    function Controller(item, params, tipo, funcion, parametros, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;
        vm.params = params;

        vm.confirm = function () {
            tipo[funcion](parametros).$promise.then(function () {
                ModalService.close(vm.item);
            });
        };
    }
})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:ckEditor
     * @description
     * Directiva que incluye un editor de texto CKEditor.
     *
     * __Nota: No utilizar directamente. Usar el componente {@link app.component:textArea}.
     *
     * @requires app.component:textArea
     */
    angular.module('app')
        .directive('ckEditor', directive);

    /* @ngInject */
    function directive($ocLazyLoad, $window, Language, RutasService) {
        $window.CKEDITOR_BASEPATH = RutasService.getContext() + '/assets/ckeditor/';

        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ngModel) {
                // Ocultamos el textarea mientras no se carga el editor
                elm[0].hidden = true;

                // Cargamos el JS de CKEditor sólo cuando es necesario
                $ocLazyLoad.load({
                    name: 'CKEditor',
                    files: [
                        'assets/ckeditor/ckeditor.js'
                    ]
                }).then(function () {
                    link(scope, elm, attr, ngModel);
                });
            },
            scope: {
                tipo: '@',
                height: '@',
                max: '@',
                clase: '@'
            }
        };

        function link(scope, elm, attr, ngModel) {
            // Ponemos el timestamp a null, porque si no añade un parámetro a los CSS y elementos y devuelven un 404.
            CKEDITOR.timestamp = null;

            // Instanciamos el editor
            var ck = CKEDITOR.replace(elm[0], {
                extraPlugins: 'find,justify,wordcount,html5video,html5audio'
            });

            if (!ngModel) return;
            ck.on('instanceReady', function () {
                ck.setData(ngModel.$viewValue);
            });

            function updateModel() {
                scope.$apply(function () {
                    ngModel.$setViewValue(ck.getData());
                });
            }

            ck.on('change', updateModel);
            ck.on('key', updateModel);
            ck.on('dataReady', updateModel);

            ngModel.$render = function () {
                ck.setData(ngModel.$viewValue);
            };

            // Configuración de la Toolbar

            ck.config.toolbar_basico = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo']
            ];

            ck.config.toolbar_normal = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Link'],
                ['RemoveFormat'],
                ['Maximize']
            ];

            ck.config.toolbar_completo = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['Cut', 'Copy', 'Find'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Blockquote'],
                ['Link', 'Image', 'Html5video', 'Html5audio'],
                ['Format', 'RemoveFormat'],
                ['Maximize']
            ];

            // ck.config.toolbar_completo = [
            //     ['Bold', 'Italic', 'Underline', 'StrikeThrough', '-', 'Undo', 'Redo', '-', 'Cut', 'Copy', 'Paste',
            //         'PasteFromWord', 'Find', 'Replace', '-', 'Outdent', 'Indent'],
            //     ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
            //     '/',
            //     ['Styles', 'Format', 'Font', 'FontSize'],
            //     ['Image', 'Table', 'HorizontalRule', '-', 'Link', 'TextColor', 'BGColor', 'Source'],
            //     ['Maximize']
            // ];

            // Otras configuraciones

            ck.config.toolbar = scope.tipo;
            ck.config.height = scope.height + 'px';
            ck.config.bodyClass = scope.clase;

            ck.config.wordcount = {
                showParagraphs: false,
                showCharCount: true,
                maxCharCount: scope.max
            };

            ck.config.language = Language.getCurrent();

            // TODO: CKFINDER. Añadir a la URL el tipo de documento que se quiere mostrar...? ?type=img,doc
            ck.config.filebrowserBrowseUrl = RutasService.getBaseUrl(true) + '/explorador-archivos';
        }
    }
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:buttons
     * @description
     * Componente que añade los botones de guardar/editar y de cancelar en los formularios.
     *
     * @param {Boolean} canSave Si es false, se deshabilita el botón de guardar
     * @param {String} mode Modos permitidos: `create`, `edit`
     * @param {Function} validar Función de validación al pulsar sobre el botón de submit. Opcional
     *
     */
    angular
        .module('app')
        .component('buttons', {
            templateUrl: 'app/components/form/buttons/buttons-form.template.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                canSave: '<',
                mode: '<',
                validar: '<'
            }
        });

    function Controller($rootScope, ModalService) {
        var vm = this;

        // Si hay una ventana modal abierta, se cierra
        vm.back = function () {
            if (ModalService.isOpen()) {
                ModalService.dismiss();
            } else {
                $rootScope.back();
            }
        };

    }

})();

(function () {
    'use strict';

    // Botón para la creación de entidades dentro de otras. Usado para los formularios dentro de ventanas modales.

    // click: Función que se va a llamar al pulsar el botón.
    // params: Parámetros que se enviará a la función.

    // Ejemplo de uso: FILO1701, traduccion-form.admin.*

    angular
        .module('app')
        .component('buttonCreate', {
            template: '<a ng-click="ctrl.click(ctrl.params)" class="button-create"' +
            ' title="{{\'admin.form.button.create\' | translate}}"><i class="fa fa-plus-square"></i></a>',
            controllerAs: 'ctrl',
            bindings: {
                click: '<',
                params: '<'
            }
        });

})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:rss
     * @description
     * Componente que muestra una lista de Feeds RSS agrupados por categoría.
     *
     * @param {Number} categoriaId ID de la categoría de la que se obtendrán los feedsRSS.
     *
     */
    angular
        .module('app')
        .component('rss', {
            templateUrl: 'app/components/feedrss/rss/rss.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                categoriaId: '@',
                imagen: '@'
            }
        });

    /* @ngInject */
    function Controller(Rss, CategoriaRss, $translatePartialLoader) {
        var vm = this;
        vm.loading = true;

        $translatePartialLoader.addPart('componentes/feedsRss');

        CategoriaRss.get({id: vm.categoriaId}).$promise.then(function (data) {
            vm.categoria = data;
        });

        Rss.query({categoriaId: vm.categoriaId}).$promise.then(function (data) {
            vm.loading = false;
            vm.entradas = data;
        });
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/estaticas', {
                parent: 'admin',
                url: '/admin/estaticas/:nombre',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'estaticas.titulo'
                },
                views: {
                    'content@': {
                        template: '<estatica-form item="$resolve.item" idiomas="$resolve.idiomas"></estatica-form>',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/estaticas');
                    },
                    /* @ngInject */
                    item: function (Estatica, $stateParams) {
                        return Estatica.get({nombre: $stateParams.nombre}).$promise.then(function (data) {
                            return data;
                        });
                    },
                    /* @ngInject */
                    idiomas: function (Language) {
                        return Language.getList();
                    }
                },
                ncyBreadcrumb: {
                    label: 'estaticas.titulo'
                }
            });
    }
})();

(function (angular) {
    'use strict';

    // estatica: Objeto a modificar.
    // idiomas: Idiomas en los que pueden estar las páginas estáticas.

    angular
        .module('app')
        .component('estaticaForm', {
            bindings: {
                item: '<',
                idiomas: '<'
            },
            templateUrl: 'app/components/estaticas/admin/estatica-form.admin.html',
            controllerAs: 'ctrl',
            controller: function ($rootScope, Estatica) {
                var vm = this;

                vm.mode = 'edit';
                vm.canSave = true;

                vm.validar = function () {
                    for (var i = 0; i < vm.idiomas.length; i++) {
                        var idioma = vm.idiomas[i];
                        var estaticaI18n = vm.item.descripciones[idioma];
                        if (estaticaI18n.titulo === undefined) {
                            vm.active = i;
                            i = vm.idiomas.length;
                            break;
                        }
                    }
                };

                vm.save = function () {
                    Estatica.save(vm.item).$promise.then(function (data) {
                        vm.item = data;
                    }).catch(function (response) {
                        $rootScope.mostrarErrores(response, vm.form);
                    });

                };
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .component('temaListPublic', {
            templateUrl: 'app/components/auladigital/public/tema-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                temas: '<'
            }
        });

    /* @ngInject */
    function Controller(AulaDigitalUtil) {
        var vm = this;

        vm.urlBaseArchivo = AulaDigitalUtil.getRutaRecursosBase();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('nivelEducativoListPublic', {
            templateUrl: 'app/components/auladigital/public/nivel-educativo-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                niveles: '<'
            }
        });

    /* @ngInject */
    function Controller() {

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('aulaDigital', {
                parent: 'public',
                url: '/aula-digital',
                redirectTo: 'aulaDigital/nivelesEducativos',
                data: {
                    authorities: [],
                    pageTitle: 'aulaDigital.titulo'
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/aulaDigital');
                    },
                    /* @ngInject */
                    nivelesEducativos: function (NivelEducativo) {
                        return NivelEducativo.query({sortProperty: 'orden'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            })
            .state('aulaDigital/nivelesEducativos', {
                parent: 'aulaDigital',
                url: '',
                views: {
                    'content@': {
                        template: '<h1 translate="aulaDigital.titulo"></h1>' +
                        '<p translate="aulaDigital.intro1"></p><p translate="aulaDigital.intro2"></p>' +
                        '<nivel-educativo-list-public niveles="$resolve.nivelesEducativos"></nivel-educativo-list-public>'
                    }
                }
            })
            .state('aulaDigital/materiasByNivel', {
                parent: 'aulaDigital',
                url: '/{nivelUrl}',
                redirectTo: 'aulaDigital/temasByMateria',
                views: {
                    'content@': {
                        templateUrl: 'app/components/auladigital/public/aula-digital-template.public.html',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    nivelUrl: function ($stateParams) {
                        return $stateParams.nivelUrl;
                    },
                    /* @ngInject */
                    materias: function ($stateParams, Materia) {
                        return Materia.findByNivelUrl({url: $stateParams.nivelUrl}).$promise.then(function (data) {
                            if (!data || !data.length) {
                                return [];
                            }
                            return data;
                        });
                    }
                }
            })
            .state('aulaDigital/temasByMateria', {
                parent: 'aulaDigital/materiasByNivel',
                url: '/{materiaUrl}',
                /* @ngInject */
                onEnter: function ($state, $stateParams, materias, materiaUrl) {
                    if (!$stateParams.materiaUrl && materias.length) {
                        $state.go("aulaDigital/temasByMateria", {
                            nivelUrl: $stateParams.nivelUrl,
                            materiaUrl: materiaUrl
                        });
                    }
                },
                views: {
                    'contentAula': {
                        template: '<tema-list-public temas="$resolve.temas"></tema-list-public>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    materiaUrl: function ($stateParams, materias) {
                        if (!$stateParams.materiaUrl) {
                            if (materias.length) {
                                return materias[0].url;
                            }
                        } else return $stateParams.materiaUrl;
                    },
                    /* @ngInject */
                    temas: function ($stateParams, Tema, materiaUrl) {
                        if (!materiaUrl) {
                            return [];
                        }
                        return Tema.findByMateriaUrl({url: materiaUrl}).$promise.then(function (data) {
                            if (!data || !data.length) {
                                return [];
                            }
                            return data;
                        });
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('UsuarioAspg', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "usuario-aspg";
        return ResourceHelper.getResource(entidad, {}, {
            recover: {
                method: 'GET',
                url: 'api/' + entidad + '/recover',
                params: {
                    id: null
                }
            },
            getAutenticado: {
                method: 'GET',
                url: 'api/' + entidad + '/getAutenticado',
                params: {
                    username: null
                }
            },
            editar: {
                method: 'POST',
                url: 'api/' + entidad + '/edit'
            },
            changePassword: {
                method: 'POST',
                url: 'api/' + entidad + '/change_password'
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Suscriptor', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "suscriptor";
        return ResourceHelper.getResource(entidad, {}, {
            enviarEmail: {
                method: 'POST',
                url: 'api/' + entidad + '/enviar-email'
            },
            cancelarSuscripcion: {
                method: 'GET',
                url: 'api/' + entidad + '/unsuscribe',
                params: {
                    key: null
                }
            }
        });
    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('socialMenu', {
            templateUrl: 'app/components/aspg/socialmenu/social-menu.html',
            controllerAs: 'ctrl',
            controller: Controller
        });

    function Controller($window) {
        var vm = this;

        vm.abrir = function (url) {
            $window.open(
                url,
                '_blank'
            );
        }

    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('headerMenu', {
            templateUrl: 'app/components/aspg/headermenu/header-menu.html',
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('ManagerLogin', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "manager-login";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('admin/managerLogin', {
            parent: 'admin',
            url: '/admin/administrar-webs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'managerLogin.titulo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/aspg/managerlogin/manager-login.admin.html'
                }
            },
            ncyBreadcrumb: {
                label: 'managerLogin.titulo'
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/managerLogin');
                },
                /* @ngInject */
                datos: function (ManagerLogin) {
                    return ManagerLogin.get().$promise;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('InfoTienda', Service);

    /* @ngInject */
    function Service($resource) {
        var urlBase = "api/tienda";
        return $resource(urlBase, {}, {
            getDestacados: {
                method: 'GET',
                url: urlBase + '/destacados',
                isArray: true,
                ignoreLoadingBar: true
            },
            getPromocion: {
                method: 'GET',
                url: urlBase + '/promocion',
                ignoreLoadingBar: true
            }
        });
    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('infoTienda', {
            templateUrl: 'app/components/aspg/infotienda/info-tienda.html',
            controller: infoTiendaController,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function infoTiendaController(InfoTienda) {
        var vm = this;

        InfoTienda.getPromocion().$promise.then(function (data) {
            if (data.id){
                vm.promocion = data;
                var hoy = new Date();
                hoy.setHours(0);
                hoy.setMinutes(0);
                hoy.setSeconds(0);
                hoy.setMilliseconds(0);
                vm.diasPromocion = Math.floor(((vm.promocion.data_fin_vixencia - hoy)/1000/60/60)/24);
            } else {
                vm.promocion = null;
                InfoTienda.getDestacados().$promise.then(function (data) {
                    vm.destacados = data;
                });
            }
        }).catch(function(){
            vm.destacados = [];
            vm.promocion = null;
        });
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('SalaMuseo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "sala-museo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findByMuseoUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/findByMuseoUrl',
                params: {
                    url: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('ObraMuseo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "obra-museo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findBySala: {
                method: 'GET',
                url: 'api/' + entidad + '/findBySala',
                params: {
                    id: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('MuseosUtil', Service);

    /* @ngInject */
    function Service(NgImageGalleryHelper) {
        return {
            getRutaMuseosBase: getRutaMuseosBase,
            getRutaMuseos: getRutaMuseos,
            getRutaSalas: getRutaSalas,
            getRutaObras: getRutaObras,
            obtenerImagen: obtenerImagen,
            obtenerImagenesNgGallery: obtenerImagenesNgGallery,
            obtenerThumbnail: getUrlThumbnail
        };

        function getRutaMuseosBase() {
            return '/upload/museos/';
        }

        function getRutaMuseos(id) {
            return getRutaMuseosBase() + 'museos/' + id + '/';
        }

        function getRutaSalas(id) {
            return getRutaMuseosBase() + 'salas/' + id + '/';
        }

        function getRutaObras(id) {
            return getRutaMuseosBase() + 'obras/' + id + '/';
        }

        // Devuelve el elemento 'url()' con la ruta de la imagen si esta es distinta de null o
        // con la ruta de la imágen por defecto en caso contrario
        function obtenerImagen(urlBaseImagen, imagenPath) {
            var tieneImagen = imagenPath !== null;

            if (tieneImagen) {
                return 'url("' + getUrlThumbnail(urlBaseImagen, imagenPath) + '")';
            } else {
                return 'url("assets/images/static/museo/sin-imagen.png")';
            }
        }

        function obtenerImagenesNgGallery(items) {
            var imagenesGallery = [];

            items.forEach(function (item) {
                var urlImagen = getUrlImagen(getRutaObras(item.id), item.imagenPath);
                var urlThumbnail = getUrlThumbnail(getRutaObras(item.id), item.imagenPath);
                var titulo = "<h1>" + item.titulo + "</h1>";
                if (item.descripcion !== null) {
                    titulo += "<p>" + item.descripcion + "</p>";
                }

                imagenesGallery.push(NgImageGalleryHelper.toNgImageGalleryImagen(item.id, urlImagen, urlThumbnail, titulo));
            });

            return imagenesGallery;
        }

        function getUrlImagen(urlBaseImagen, pathImagen) {
            return urlBaseImagen + pathImagen;
        }

        function getUrlThumbnail(urlBaseImagen, pathImagen) {
            return urlBaseImagen + 'n_' + pathImagen;
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Museo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "museo";
        return ResourceHelper.getResource(entidad, {}, {
            findPublic: {
                method: 'GET',
                url:
                'api/' + entidad + '/findPublic'
            },
            getByUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/getByUrl',
                params: {
                    url: null
                }
            },
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            }
        });
    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('xogos', {
            templateUrl: 'app/components/aspg/enxogo/xogos.html',
            controllerAs: 'ctrl',
            bindings: {
                xogos: '<'
            }
        });

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Xogo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "xogo";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('enXogo', {
                parent: 'public',
                url: '/en-xogo',
                redirectTo: 'enXogo/login',
                data: {
                    pageTitle: 'enXogo.titulo'
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/enXogo');
                    }
                }
            })
            .state('enXogo/login', {
                parent: 'enXogo',
                url: '/entrar',
                data: {
                    authorities: ['ROLE_ANONYMOUS']
                },
                views: {
                    'content@': {
                        template: '<h1 translate="enXogo.titulo"></h1>' +
                        '<login></login>'
                    }
                }
            })
            .state('enXogo/recuperar/init', {
                parent: 'enXogo',
                url: '/recuperar-contrasena',
                data: {
                    authorities: ['ROLE_ANONYMOUS'],
                    pageTitle: 'recuperar.title'
                },
                views: {
                    'content@': {
                        template: "<recuperar-init></recuperar-init>"
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/recuperar');
                    }
                }
            })
            .state('recuperar/finish', {
                parent: 'enXogo',
                url: '/nueva-contrasena?key&email',
                data: {
                    authorities: ['ROLE_ANONYMOUS'],
                    pageTitle: 'recuperar.title'
                },
                views: {
                    'content@': {
                        template: "<recuperar-finish></recuperar-finish>"
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/recuperar');
                        $translatePartialLoader.addPart('admin');
                    }
                }
            })

            // === Estados que requieren que el usuario esté autenticado ===

            .state('enXogo/base', {
                parent: 'enXogo',
                redirectTo: 'enXogo/xogos',
                data: {
                    authorities: ['ROLE_USUARIO']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/aspg/enxogo/en-xogo.template.html'
                    }
                },
                resolve: {
                    /* @ngInject */
                    nombre: function(Principal){
                        return Principal.identity().then(function(identity){
                            return identity.nombre;
                        });
                    }
                }
            })
            .state('enXogo/xogos', {
                parent: 'enXogo/base',
                url: '/xogos',
                views: {
                    'contentXogos': {
                        template: '<xogos xogos="$resolve.xogos"></xogos>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    xogos: function (Xogo) {
                        return Xogo.get().$promise;
                    },
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/managerLogin');
                    }
                }
            })
            .state('enXogo/perfil', {
                parent: 'enXogo/base',
                url: '/perfil',
                data: {
                    pageTitle: 'enXogo.perfil.titulo'
                },
                views: {
                    'contentXogos': {
                        template: '<h2 translate="enXogo.perfil.titulo"></h2>' +
                        '<registro mode="edit" usuario="$resolve.usuarioAspg"></registro>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    usuarioAspg: function (UsuarioAspg) {
                        return UsuarioAspg.getAutenticado().$promise.then(function (data) {
                            return data;
                        });
                    },
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/registro');
                    }
                }
            })
            .state('enXogo/cambiar-contrasena', {
                parent: 'enXogo/base',
                url: '/cambiar-contrasena',
                data: {
                    pageTitle: 'enXogo.cambiarcontrasena.titulo'
                },
                views: {
                    'contentXogos': {
                        template: '<h2 translate="enXogo.cambiarcontrasena.titulo"></h2>' +
                        '<change-password></change-password>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    usuarioAspg: function (UsuarioAspg) {
                        return UsuarioAspg.getAutenticado().$promise.then(function (data) {
                            return data;
                        });
                    },
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/changepassword');
                        $translatePartialLoader.addPart('admin');
                    }
                }
            })
            .state('enXogo/salir', {
                parent: 'enXogo/base',
                views: {
                    'contentXogos': {
                        controller: 'LogoutController'
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('cursos', {
            templateUrl: 'app/components/aspg/cursos/cursos.html',
            controller: cursosController,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function cursosController(Curso) {
        var vm = this;

        Curso.getUltimos().$promise.then(function (data) {
            vm.cursos = data;
        }).catch(function () {
            vm.cursos = [];
        });
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Curso', Service);

    /* @ngInject */
    function Service($resource) {
        var urlBase = "api/cursos";
        return $resource(urlBase, {}, {
            getUltimos: {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Boletin', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "boletin";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('BoletinUtil', Service);

    /* @ngInject */
    function Service() {
        return {
            getRutaImagen: getRutaImagen,
            getRutaArchivo: getRutaArchivo
        };

        function getRutaBase() {
            return '/upload/boletines/';
        }

        function getRutaImagen(id) {
            return getRutaBase() + id + '/';
        }

        function getRutaArchivo(id) {
            return getRutaBase() + id + '/';
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Actualidad', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "actualidad";
        return $resource('api/' + entidad);
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('actualidad', {
            templateUrl: 'app/components/aspg/actualidad/actualidad.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                categoriaRssId: '<'
            }
        });

    /* @ngInject */
    function Controller(Rss) {
        var vm = this;

        vm.loading = true;

        Rss.query({categoriaId: vm.categoriaRssId}).$promise.then(function (data) {
            vm.loading = false;
            vm.entradas = data;
        });

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Asociarse', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "asociarse";
        return $resource('api/' + entidad);
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('asociarseForm', {
            templateUrl: 'app/components/aspg/asociarseform/asociarse-form.html',
            controllerAs: 'ctrl',
            controller: Controller
        });

    /* @ngInject */
    function Controller($rootScope, $translate, Asociarse, Permisos, COMPONENTES, vcRecaptchaService) {
        var vm = this;
        vm.captcha = {
            resuelto: false,
            response: undefined
        };

        vm.mostrarCaptcha = Permisos.tienePermisos('all', COMPONENTES.contacto.captcha);

        function init() {
            vm.item = new Asociarse();
            vm.item.situacion = $translate.instant('asociarse.form.situacion.activo');
            vm.terminos = false;
        }

        vm.init = init;

        // Guardar formulario
        vm.save = function () {
            vm.item.captchaToken = vm.captcha.response;

            vm.item.$save().then(function () {
                init();
                vm.form.$setPristine();
                vcRecaptchaService.reload();
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.captchaSuccess = function(response) {
            vm.captcha.resuelto = true;
            vm.captcha.response = response.response;
        };

        init();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('logout', {
            parent: 'public',
            data: {
                authorities: ['ROLE_AUTHENTICATED']
            },
            views: {
                'content@': {
                    controller: 'LogoutController'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('LogoutController', LogoutController);

    /* @ngInject */
    function LogoutController($state, Auth) {
        Auth.logout();

        $state.go('home');
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, ADMIN_FORM_ADMIN) {
        var config = ADMIN_FORM_ADMIN();
        var base = "admin/admin";
        var params = {
            base: base,
            baseUrl: "/admin/administrador",
            translateBase: "admin.admin.",
            templateList: '<admin-list-admin></admin-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Administrador, $stateParams) {
                    return Administrador.getById({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('adminListAdmin', {
            templateUrl: 'app/admin/user/admin/admin-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, Administrador) {
        var vm = this;

        vm.item = Administrador;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {login: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (user) {
            ModalService.open({
                templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                controller: 'EntityDeleteModalController',
                controllerAs: 'ctrl',
                resolve: {
                    item: function () {
                        return Administrador.getUser({login: user.login}).$promise;
                    },
                    params: function () {
                        return {
                            title: 'admin.list-users.delete.title',
                            body: 'admin.list-users.delete.confirm',
                            property: 'login'
                        };
                    }
                }
            }).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('ADMIN_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<admin-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams" ' +
                'roles="' + resolve + 'roles"' +
                '></admin-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Administrador) {
                        return new Administrador();
                    },
                    /* @ngInject */
                    roles: function (EnumService) {
                        return EnumService.get("rol-admin");
                    }
                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('adminFormAdmin', {
            templateUrl: 'app/admin/user/admin/admin-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                roles: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, Auth, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input')[0].focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // TODO: Permitir la edición de administradores

        vm.save = function () {
            vm.item.rol = "ROLE_ADMIN";
            Auth.createAccount(vm.item).then(function () {
                ModalService.closeComponent(vm.item, 'admin/admin/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Web', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "web";
        return ResourceHelper.getResource(entidad, {}, {
            'findByCategoriaUrl': {
                method: 'GET',
                url: 'api/' + entidad + '/findByCategoriaUrl',
                params: {
                    categoriaUrl: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('WebUtil', Service);

    /* @ngInject */
    function Service() {
        return {
            getRutaWebsBase: getRutaWebsBase,
            getRutaWebs: getRutaWebs,
            getRutaWebPublica: getRutaWebPublica
        };

        function getRutaWebsBase() {
            return '/upload/webs/';
        }

        function getRutaWebs(id) {
            return getRutaWebsBase() + id + '/';
        }

        function getRutaWebPublica() {
            return '/webs/';
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('CategoriaWeb', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "categoria-web";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .service('ParseLinks', ParseLinks);

    /* @ngInject */
    function ParseLinks() {
        this.parse = function (header) {
            if (angular.isUndefinedOrNull(header)) {
                return {};
            }

            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function ($0, $1, $2, $3) {
                        queryString[$1] = $3;
                    }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        };
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('ellipsis', ['$timeout', function ($timeout) {
            return function (scope, element, attrs) {
                var lineas = attrs.ellipsis;
                var truncar_palabra = attrs.ellipsisTruncarPalabra;

                var ellipsis = new Ellipsis({lines: lineas, break_word: truncar_palabra});

                // Esperamos a que los elementos sean renderizados para que tengan
                // seteados los tamaños
                $timeout(function(){
                    ellipsis.add(element);
                });
            };
        }]);
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('compile', ['$compile', function ($compile) {
            return function (scope, element, attrs) {
                scope.$watch(
                    function (scope) {
                        // watch the 'compile' expression for changes
                        return scope.$eval(attrs.compile);
                    },
                    function (value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);
                    }
                );
            };
        }])
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .component('socialWidget', {
            templateUrl: 'app/components/socialwidget/social-widget.html',
            controller: function ($timeout, $cookies) {
                var vm = this;
                vm.cookiesAccepted = false

                if ($cookies.getObject("cc_cookie") !== undefined &&
                    $cookies.getObject("cc_cookie").level.includes('third_party_cookies')) {
                    vm.cookiesAccepted = true;
                    $timeout(function () {
                        FB.XFBML.parse();
                        twttr.widgets.createTimeline(
                            {
                                sourceType: "profile",
                                screenName: "asocpedagoxica"
                            },
                            document.getElementById("tweets")
                        );
                        twttr.widgets.load();
                    }, 500);
                } else {
                    vm.cookiesAccepted = false
                }
            },
            controllerAs: 'ctrl'
        });
})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:socialShare
     * @description
     * Compartir contenido en redes sociales.
     *
     * Para añadir Google+ habría que añader etiquetas <meta> a la página. El crawler de Google sí interpreta javascript (no como el de Twitter y Facebook).
     *
     * Para Facebook incluimos el SDK. La carga se hace en el archivo `assets/js/facebook-sdk.service.js`.
     *
     * Referencia: {@link https://github.com/720kb/angular-socialshare}
     *
     * @param {String} url URL que se va a compartir. Si es relativa (empieza por "/") se le concatenará la url base.
     * @param {Boolean} [mini=false] Booleano para saber si mostrar botones más grandes o pequeños.
     * @param {Boolean} [textos=false] Booleano para saber si se muestran los nombres de las redes sociles o sólo los iconos.
     * @param {Boolean} [twitter=false] Compartir en Twitter.
     * @param {Boolean} [facebook=false] Compartir en Facebook.
     * @param {String} titulo Título que se mostrará en Facebook. Obligatorio.
     * @param {String} descripcion Descripción que se mostrará en Facebook.
     * @param {String} [imagen='/assets/images/logo_img.png'] Imagen que se mostrará en facebook. Si no se indica ninguna, se usará el logo de la aplicación.
     * @param {String} tweet Texto del tweet.
     * @param {String} twHashtags Hashtags que se añadirá al tweet. (Creo que hay un problema cuando se quiere añadir un número o símbolos)
     * @param {String} twVia Nombre de la cuenta (vía @cuenta)
     *
     */
    angular
        .module('app')
        .component('socialShare', {
            bindings: {
                url: '@',
                mini: '<',
                textos: '<',
                twitter: '<',
                facebook: '<',
                titulo: '@',
                descripcion: '@',
                imagen: '@',
                tweet: '@',
                twHashtags: '@',
                twVia: '@'
            },
            templateUrl: 'app/components/socialshare/social-share.html',
            /* @ngInject */
            controller: function ($scope, $location, $translate, RutasService, FacebookSdkService) {
                var vm = this;

                // Descargamos el SDK de Facebook
                FacebookSdkService.config();

                if (!vm.imagen) {
                    // La imagen por defecto debería ser cuadrada para que se muestre correctamente
                    vm.imagenUrl = RutasService.getBaseUrl() + "/assets/images/static/aspg_logo_cuadrado.png";
                } else {
                    vm.imagenUrl = RutasService.getBaseUrl() + vm.imagen;
                }

                if (vm.url.indexOf("/") === 0) {
                    vm.fullUrl = RutasService.getBaseUrl() + vm.url;
                } else {
                    vm.fullUrl = vm.url;
                }

                vm.compartirEnFacebook = function () {
                    var datos = {
                        'og:title': vm.titulo,
                        'og:url': vm.fullUrl
                    };
                    if (vm.descripcion) {
                        if (/<[a-z][\s\S]*>/i.test(vm.descripcion)) {
                            datos["og:description"] = jQuery(vm.descripcion).text();
                        } else {
                            datos["og:description"] = vm.descripcion;
                        }
                    }
                    if (vm.imagenUrl) {
                        datos["og:image"] = vm.imagenUrl;
                    }

                    FB.ui({
                        method: 'share_open_graph',
                        action_type: 'og.shares',
                        action_properties: JSON.stringify({
                            object: datos
                        })
                    }, function (response) {
                        console.log("Facebook response: ", response);
                    });
                }

            },
            controllerAs: 'ctrl'
        });

})(angular);

(function (angular) {
    'use strict';

    angular.module('app')
        .service('FacebookSdkService', Service);

    /* @ngInject */
    function Service(APIS) {
        return {
            config: config
        };

        function config() {
            window.fbAsyncInit = function () {
                FB.init({
                    appId: APIS.facebookId,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: APIS.facebookVersion
                });
                FB.AppEvents.logPageView();
            };

            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasNoAuthority', hasNoAuthority);

    function hasNoAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasNoAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            console.log("Result: " + result);
                            if (result) {
                                setHidden();
                            } else {
                                setVisible();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    // TODO: Documentar

    /**
     * @ngdoc directive
     * @name app.directive:hasAnyAuthority
     * @description
     *
     */
    angular
        .module('app')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            if (attrs.hasAnyAuthority === "") {
                return;
            }

            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAnyAuthorityOrState', hasAnyAuthorityOrState);

    function hasAnyAuthorityOrState(Principal, $state) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            replace: false,
            scope: {
                authorities: "=",
                states: "="
            }
        };
        return directive;

        function linkFunc(scope, element) {

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                element.addClass('hidden');
            };

            var defineVisibility = function (reset) {
                var result = true;

                if (reset) {
                    setVisible();
                }

                if (scope.authorities) {
                    var authorities = scope.authorities.replace(/\s+/g, '').split(',');
                    result = result && Principal.hasAnyAuthority(authorities);

                }
                if (scope.states) {
                    var states = scope.states.replace(/\s+/g, '').split(',');
                    var results = states.filter(function (state) {
                        return $state.includes(state);
                    });
                    result = result && results.length;
                }

                if (result) {
                    setVisible();
                } else {
                    setHidden();
                }
            };

            if (scope.authorities) {
                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }

            if (scope.states) {
                scope.$on('$stateChangeSuccess',
                    function () {
                        defineVisibility(true);
                    }
                );
            }

            if (scope.authorities || scope.states) {
                defineVisibility(true);
            }
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:tienePermisos
     * @description
     * Directiva para ocultar elementos en caso de que no tengan los permisos suficientes.
     *
     * @param {String} permisoElemento Permiso que tiene el elemento para mostrarse.
     * @param {String} permisoConfig Permiso con el que se va a comparar (establecido de manera global en el archivo `config.js`).
     *
     * @requires app.service:Permisos
     */
    angular
        .module('app')
        .directive('tienePermisos', directive);

    /* @ngInject */
    function directive(Permisos) {
        return {
            restrict: 'AE',
            link: linkFunc,
            replace: false,
            scope: {
                permisoElemento: '<',
                permisoConfig: '<'
            }
        };

        function linkFunc(scope, element) {

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                element.addClass('hidden');
            };
            console.log("Elem:", scope.permisoElemento);
            console.log("Conf:", scope.permisoConfig);

            var tienePermisos = Permisos.tienePermisos(scope.permisoElemento, scope.permisoConfig);
            console.log("Tiene:", tienePermisos);

            if (!tienePermisos) {
                setHidden();
            } else {
                setVisible();
            }
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:Permisos
     * @description
     * Operaciones para tratar con los permisos configurables en la aplicación (en `config.js`).
     *
     */
    angular.module('app')
        .factory('Permisos', Service);

    /* @ngInject */
    function Service(PERMISOS) {
        return {
            /**
             * @ngdoc function
             * @name tienePermisos
             * @methodOf app.service:Permisos
             * @description
             * Esta operación calcula si se tiene permisos para hacer una acción.
             *
             * Jerarquía:
             * - 'none'
             * - 'list'
             * - 'edit'
             * - 'create'
             * - 'all'
             *
             * Es decir, el permiso 'create' implica también el permiso 'list' y 'edit'.
             *
             * Si se puede crear, también se puede eliminar.
             *
             * En algunas ocasiones simplemente se utilizará 'none' para ocultar un elemento, y 'all' (o null) para que se muestre siempre.
             *
             * Si no se define la propiedad en config, no se establecerá ninguna restricción.
             *
             * @param {String} actual Permiso que tiene el elemento (o acción) actual.
             * @param {String} config Permiso global de la aplicación con el que se va a comparar.
             * @returns {Boolean} True si tiene permiso, false en caso contrario.
             *
             * @requires app.object:permisos_constants
             */
            tienePermisos: tienePermisos
        };

        function tienePermisos(actual, config) {
            return PERMISOS(actual, config);
        }

    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name app.object:permisos_constants
     *
     * @description
     * Función para calcular si se tienen permisos para realizar una acción.
     *
     * Se incluye aquí (a parte de en el servicio) para que se pueda utilizar al definir los estados.
     *
     * @requires app.service:Permisos
     *
     */
    angular
        .module('app')
        // Nº de elementos por página en las tablas
        .constant('PERMISOS', function (actual, config) {
            if (!actual) {
                return true;
            }

            if (config === 'none') {
                return false;
            } else if (config === 'all') {
                return true;
            } else if (config === 'list') {
                return actual === 'list';
            } else if (config === 'edit') {
                return actual === 'list' || actual === 'edit';
            } else if (config === 'create') {
                return actual === 'list' || actual === 'edit' || actual === 'create';
            }
            return true;
        })
    ;
})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:submenu
     * @description
     * Directiva que construye un submenú a partir de un JSON.
     *
     * @requires app.directive:menuItem
     *
     */
    angular
        .module('app')
        .directive('submenu', submenuDirective);

    submenuDirective.$inject = [];

    function submenuDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                menu: '=',
                onClick: '&'
            },
            templateUrl: 'app/components/menu/submenu.html'
        };
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:Menu
     * @description
     * Servicio con operaciones para el uso de MiMenu.
     *
     * Referencia: {@link https://angular-ui.github.io/bootstrap/#modal}
     *
     */
    angular
        .module('app')
        .factory('Menu', Menu);

    Menu.$inject = ['$q', '$http'];

    function Menu($q, $http) {
        return {
            /**
             * @ngdoc function
             * @name getMenu
             * @methodOf app.service:Menu
             *
             * @param {String} name Nombre del archivo. Ej: `menu-main`
             *
             * @returns {Object} Promesa que devolverá el contenido del archivo JSON.
             */
            getMenu: getMenu
        };

        function getMenu(name) {
            var deferred = $q.defer();
            $http.get('menu/' + name + '.json').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:miMenu
     * @description
     * Componente que construye un menú a partir de un json.
     *
     * Parámetros para definir cada entrada del menú:
     * - label: Etiqueta
     * - icon: Clase del icono que se mostrará junto al texto
     * - state: Estado al que redirige
     * - link: Enlace al que redirige. No se puede definir `state` y `link` al mismo tiempo
     * - target: Target en caso de que se indique un link
     * - authorities: Roles que pueden ver la entrada del menú. Ej: `authorities: ROLE_ADMIN, ROLE_COLABORADOR`
     * - states: Lista de estados en los cuales se muestra la entrada del menú
     * - actives: Lista de estados en los cuales la entrada del menú se marcará como activa
     * - modal: Permite abrir una ventana modal estática pasándole el ID
     * - componente: Componente HTML.
     * - subtree: Definición del submenú.
     *    - label: Etiqueta que se mostrará. Si se quiere definir como una línea separadora, hay que indicar el texto: `divider`
     *    - icon: Clase del icono
     *    - state: Estado
     *    - link: Enlace
     *    - target: Target en caso de que se indique un link
     *
     * Referencia: {@link https://angular-ui.github.io/bootstrap/#dropdown}
     *
     * @param {Object} menu Objeto que contiene todas las entradas del menú y sus propiedades.
     * @param {Boolean} navCollapsed Booleano para mostrar la barra colapsada o expandida.
     * Es necesario porque si se pone siempre a true, cuando es en escritorio hace una transición que queda mal, ocultándose y mostrándose.
     * Tiene que ir a true sólo en dispositivos móviles.
     * @param {Boolean} lateral Booleano para indicar si es un menú lateral o normal.
     *
     * @requires app.directive:submenu
     * @requires app.directive:hasAnyAuthority
     * @requires app.service:EstaticaModal
     */
    angular
        .module('app')
        .component('miMenu', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu.html',
            /* @ngInject */
            controller: function ($window, $state, EstaticaModal) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state)) {
                                active = true;
                            } else {
                                var estadoActualString = $state.current.name + '(' + JSON.stringify($state.params) + ')';
                                if (state === estadoActualString) {
                                    active = true;
                                }
                            }
                        });
                    }
                    return active;
                };

                vm.modal = function (id) {
                    EstaticaModal.open(id);
                };

                vm.collapse = function () {
                    if ($window.innerWidth < 992) {
                        vm.navCollapsed = !vm.navCollapsed;
                    }
                }
            },
            controllerAs: 'ctrl'
        });
})(angular);

/**
 * Based on:
 *
 * The MIT License (MIT)
 * Copyright (c) 2015 Eugenio Lentini
 * https://github.com/blackat/ui-navbar
 */
(function (angular) {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:menuItem
     * @description
     * Directiva que construye una entrada de menú a partir de un JSON.
     *
     */
    angular
        .module('app')
        .directive('menuItem', menuItemDirective);

    menuItemDirective.$inject = ['$compile'];

    function menuItemDirective($compile) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/menu/menu-item.html',
            link: function (scope, element, attrs) {
                if (angular.isArray(scope.leaf.subtree)) {
                    element.append('<submenu menu="leaf.subtree"></submenu>');

                    // find the parent of the element
                    var parent = element.parent();
                    var classFound = false;

                    // check if in the hierarchy of the element exists a dropdown with class navbar-right
                    while (parent.length > 0 && !classFound) {
                        // check if the dropdown has been push to right
                        if (parent.hasClass('navbar-right')) {
                            classFound = true;
                        }
                        parent = parent.parent();
                    }

                    // add a different class according to the position of the dropdown
                    if (classFound) {
                        element.addClass('dropdown-submenu-right');
                    } else {
                        element.addClass('dropdown-submenu');
                    }

                    $compile(element.contents())(scope);
                }
            },
            scope: {
                leaf: '=',
                onClick: '&'
            }
        };
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:pagination
     * @description
     * Componente para la paginación. Se modifica el parámetro :page del estado.
     *
     * El nº de elementos por página va en una constante ({@link app.object:public_constants}).
     *
     * @param {number} currentPage Página activa
     * @param {number} totalElements Número total de elementos
     * @param {boolean} separador Se añade un div con clase `separador`.
     *
     */
    angular
        .module('app')
        .component('pagination', {
            bindings: {
                currentPage: '<',
                totalElements: '<',
                separador: '<'
            },
            templateUrl: 'app/components/pagination/pagination.html',
            controller: function ($state, $stateParams, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                var vm = this;

                vm.itemsPerPage = NG_LIST_DEFAULT_PARAMS_PUBLIC.size;

                vm.pageChanged = function () {
                    var params = angular.copy($stateParams);
                    params.page = vm.currentPage;
                    $state.go($state.current, params);
                };
            },
            controllerAs: 'ctrl'
        });

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('NgTableHelper', NgTableHelper);

    /* @ngInject */
    function NgTableHelper($state) {
        return {
            settings: settings
        };

        function settings(vm) {
            var firstLoad = true;

            // Valores por defecto
            vm.function = vm.function || "query";
            vm.counts = vm.counts || [5, 10, 25, 50];

            return {
                defaultSort: 'asc',
                counts: vm.counts,
                getData: function (params) {
                    if (firstLoad || vm.reload) {
                        vm.loading = true;
                    }
                    firstLoad = false;

                    var sortProperty = null;
                    var sortDir = null;
                    if (params.orderBy()[0]) {
                        sortProperty = params.orderBy()[0].replace("-", "").replace("+", "");
                        sortDir = params.sorting()[sortProperty].toUpperCase();
                    }

                    var request = {
                        size: params.count(),
                        page: params.page() - 1,
                        sortProperty: sortProperty,
                        sortDirection: sortDir,
                        query: vm.filter.key
                    };

                    angular.extend(request, vm.filter);

                    // Modificamos la URL con el nuevo número de página
                    $state.go('.', {page: params.page()}, {notify: false});

                    return vm.item[vm.function](request).$promise.then(function (data) {
                        vm.loading = false;
                        if (Array.isArray(data)) {
                            params.total(data.length);
                            params.count(data.length);
                            vm.empty = !data || data.length === 0;
                            return data;
                        } else {
                            params.total(data.totalElements);
                            vm.empty = !data.content || data.content.length === 0;
                            return data.content;
                        }
                    });
                }
            }
        }
    }
})
();

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:ordenable
     * @description
     * Componente que añade dos botones (subir/bajar) para poder reordenar una lista de elementos.
     *
     * @param {Number} id Identificador de la entidad que se quiere reordenar.
     * @param {Object} resource Servicio que contiene las operaciones de `bajar` y `subir`.
     * @param {Function} onChange Función de callback que se llama una vez se hace la modificación.
     * Ejemplo: `ctrl.tableParams.reload()`
     *
     */
    angular
        .module('app')
        .component('ordenable', {
            bindings: {
                id: '<',
                resource: '<',
                onChange: '&'
            },
            templateUrl: 'app/components/ordenable/ordenable.html',
            controller: function () {
                var vm = this;

                vm.bajar = function () {
                    vm.resource.bajar({id: vm.id}).$promise.then(function () {
                        vm.onChange();
                    });
                };

                vm.subir = function () {
                    vm.resource.subir({id: vm.id}).$promise.then(function () {
                        vm.onChange();
                    });
                };
            },
            controllerAs: 'ctrl'
        });

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Novedad', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "novedad";
        return ResourceHelper.getResource(entidad, {}, {
            getByUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/getByUrl',
                params: {
                    url: null,
                    idioma: null
                }
            },
            findPublic: {
                method: 'GET',
                url: 'api/' + entidad + '/findPublic'
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('NovedadUtil', Service);

    /* @ngInject */
    function Service() {
        return {
            getRuta: getRuta
        };

        function getRuta(id) {
            return '/upload/novedades/' + id + '/';
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('CategoriaNovedad', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "categoria-novedad";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:ModalService
     * @description
     * Gestión de ventanas modales.
     *
     * Permite tener varias abiertas e ir cerrándolas por orden inverso de apertura.
     *
     * Es importante que todas las ventanas modales se abran y se cierren utilizando este servicio.
     *
     * Referencia: {@link https://angular-ui.github.io/bootstrap/#modal}
     *
     */
    angular.module('app')
        .service('ModalService', ModalService);

    /* @ngInject */
    function ModalService($state, $uibModal, AlertService) {
        var opened = 0;
        var modals = [];

        return {
            /**
             * @ngdoc function
             * @name isOpen
             * @methodOf app.service:ModalService
             *
             * @returns {Boolean} Booleano para saber si hay alguna ventana modal abierta
             */
            isOpen: function () {
                return opened;
            },
            /**
             * @ngdoc function
             * @name open
             * @methodOf app.service:ModalService
             * @description
             * Abrir ventana modal.
             *
             * @param {Object} params Campos necesarios para constuir una ventana modal
             *
             * @returns {Object} Ventana modal
             */
            open: open,
            /**
             * @ngdoc function
             * @name openComponent
             * @methodOf app.service:ModalService
             * @description
             * Abrir componente en una ventana modal.
             *
             * @param {String} title Título de la ventana modal
             * @param {Object} configEntity Constante de donde se obtendrá el component y el resolve. (Ej: AGENTE_FORM_ADMIN)
             * @param {Object} [params={size: 'lg', backdrop: 'static'}] Parámetros adicionales
             *
             * @returns {Object} Ventana modal
             */
            openComponent: openComponent,
            /**
             * @ngdoc function
             * @name closeComponent
             * @methodOf app.service:ModalService
             * @description
             * Submit del componente. Se cierra la ventana modal o se cambia de estado.
             *
             * @param {Object} result Resultado de la operación.
             * @param {String} state Estado al que se va a dirigir.
             * @param {Object} [params={}] Parámetros del estado.
             */
            closeComponent: closeComponent,
            /**
             * @ngdoc function
             * @name openImagen
             * @methodOf app.service:ModalService
             * @description
             * Abrir una imagen en una ventana modal.
             *
             * El css relacionado está en `comun.scss` (clase `.imagen-modal`).
             *
             * @param {String} path URL a la imagen
             * @param {Object} [params={}] Parámetros adicionales
             *
             * @returns {Object} Ventana modal
             */
            openImagen: openImagen,
            /**
             * @ngdoc function
             * @name close*
             * @methodOf app.service:ModalService
             *
             * @param {Object} data Resultado de la operación.
             *
             */
            close: close,
            /**
             * @ngdoc function
             * @name dismiss
             * @methodOf app.service:ModalService
             *
             * @param {Object} data Resultado de la operación.
             *
             */
            dismiss: dismiss
        };

        function open(params) {
            opened = opened + 1;
            var modal = $uibModal.open(params);
            modals.push(modal);

            // En caso de que se pulse fuera de la modal, hacemos un dismiss
            modal.result.catch(function (data) {
                if (data === 'backdrop click') {
                    dismiss(data);
                }
            });

            AlertService.clear();
            return modal;
        }

        function openComponent(title, configEntity, params) {
            if (!params) params = {};

            var config = configEntity(true);
            params.resolve = config.resolve;
            params.resolve.component = function () {
                return config.component;
            };

            return open(angular.merge({}, {
                backdrop: 'static',
                size: 'lg',
                component: 'entityModal',
                resolve: {
                    title: function () {
                        return title;
                    }
                }
            }, params));
        }

        function closeComponent(result, state, params) {
            if (opened) {
                AlertService.clear();
                close(result);
            } else {
                $state.go(state, params);
            }
        }

        function openImagen(path, params) {
            if (!params) params = {};

            return open(angular.extend({}, {
                template: '<a ng-click="ctrl.close()"><img src="' + path + '" /></a>',
                windowClass: 'imagen-modal',
                controllerAs: 'ctrl',
                /* @ngInject */
                controller: function (ModalService) {
                    this.close = function () {
                        ModalService.close();
                    }
                }
            }, params));
        }


        function close(data) {
            subOpened();
            modals[modals.length - 1].close(data);
            modals.pop();
        }

        function dismiss(data) {
            subOpened();
            modals[modals.length - 1].dismiss(data);
            modals.pop();
        }

        function subOpened() {
            opened = opened - 1;
            if (opened < 0) {
                opened = 0;
            }
        }
    }

})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:entityModal
     * @description
     * Este componente permite establecer una estructura básica para abrir un formulario o cualquier otro componente dentro de una ventana modal.
     *
     * @param {object} [resolve={component: '', title: '', ...}]
     *
     * `resolve.title`: Título de la ventana modal.
     *
     * `resolve.component`: String que se convertirá en el componente (Ej: <pais-form-admin item=\'ctrl.resolve.item\'></pais-form-admin>).
     *
     * `resolve.`: Información que tiene que recibir el componente. En el componente se accederá a través de `ctrl.resolve.`.
     *
     * @requires app.service:ModalService
     *
     */
    angular
        .module('app')
        .component('entityModal', {
            templateUrl: 'app/components/modal/entity.modal.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                resolve: '<'
            }
        });

    /* @ngInject */
    function Controller(ModalService) {
        var vm = this;

        vm.dismiss = function () {
            ModalService.dismiss();
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('NgImageGalleryHelper', NgImageGalleryHelper);

    /* @ngInject */
    function NgImageGalleryHelper() {
        return {
            toNgImageGalleryImagen: toNgImageGalleryImagen
        };

        function toNgImageGalleryImagen(id, urlImagen, urlThumbnail, titulo) {
            return {id: id, url: urlImagen, thumbUrl: urlThumbnail, title: titulo};
        }
    }
})
();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:loading
     *
     * @param {Boolean} isLoading Booleano para saber si se muestra o no
     * @param {String} [class=''] Clase a mayores de la que tiene por defecto (_loading_)
     * @param {String} [img=loading.svg] Ruta al icono de carga
     *
     */
    angular
        .module('app')
        .component('loading', {
            template: '<img ng-show="$ctrl.isLoading" ' +
            'ng-src="{{$ctrl.img || \'assets/images/loading.svg\'}}" ' +
            'class="loading {{$ctrl.class}}"/>',
            bindings: {
                isLoading: '<',
                class: '@',
                img: '@'
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'admin',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    template: '<login-admin></login-admin>'
                }
            },
            ncyBreadcrumb: {
                skip: true
            }
        });
    }
})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:loginAdmin
     * @description
     * Componente que muestra un formulario para acceder a la administración.
     *
     * Es específico de la adiministración porque a la administración se suele acceder con un nombre de usuario, y no con un email.
     *
     */
    angular
        .module('app')
        .component('loginAdmin', {
            templateUrl: 'app/components/loginadmin/login-admin.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($rootScope, $state, $timeout, Auth, Principal, ADMIN_PRINCIPAL) {
                var vm = this;

                vm.user = {};
                vm.rememberMe = false;

                Principal.identity().then(function (data) {
                    if (data) {
                        $state.go(ADMIN_PRINCIPAL);
                    }
                });

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                vm.login = function () {
                    Auth.login({
                        username: vm.username,
                        password: vm.password,
                        rememberMe: vm.rememberMe
                    }).then(function () {
                        $state.go(ADMIN_PRINCIPAL);
                    }).catch(function (response) {
                        $rootScope.mostrarErrores(response, vm.form);
                    });

                }
            }
        });
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:idiomas
     * @description
     * Componente para el cambio de idioma de la aplicación.
     *
     * Permite elegir entre la lista de idiomas existentes en la configuración de la aplicación (`/gulp/config.js`).
     *
     * Muestra los idiomas en el formato: `es | en`.
     *
     * La internacionalización de los nuevos idiomas hay que añadirla en `componentes.json`.
     *
     * Tiene dependencias con métodos definidos en app.module.js y `app.config.js`.
     *
     * @requires app.service:Language
     *
     */
    angular
        .module('app')
        .component('idiomas', {
            templateUrl: 'app/components/idiomas/idiomas.html',
            /* @ngInject */
            controller: function ($rootScope, $state, $localStorage, Language) {
                var vm = this;

                vm.idiomas = Language.getList();

                vm.changeLanguage = function (lang) {
                    if (lang) {
                        lang = lang.toLowerCase();
                        $rootScope.changeLanguage(lang);
                        $state.reload();
                    }
                    vm.lang = $localStorage.lang;
                };

                // Obtenemos el idioma activo
                vm.changeLanguage();

            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:unsafe
     * @description
     * Cuando se utiliza la directiva `ngBindHtml`, al HTML se le eliminan las etiquetas _style_.
     * Añadiendo el filtro `unsafe`, el HTML se muestra tal cual es.
     *
     * @returns {String} Se marca el HTML como que es de confianza, por lo que no sufre modificaciones.
     */
    angular
        .module('app')
        .filter('unsafe', filter);

    /* @ngInject */
    function filter($sce) {
        return filter;

        function filter(input) {
            return $sce.trustAsHtml(input);
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:unique
     *
     * @description
     * Filters out all duplicate items from an array by checking the specified key
     * @param {String} key The name of the attribute of each object to compare for uniqueness
     * if the key is empty, the entire object will be compared
     * if the key === false then no filtering will be performed
     *
     * Acepta dos niveles de filtrado.
     *
     * Ejemplo de uso en SIEL1601 (fuentes.form.modal.html).
     *
     * @return {array} Elementos únicos
     */
    angular
        .module('app')
        .filter('unique', function () {

            return function (items, filterOn, filterOnSecondLevel) {

                if (filterOn === false) {
                    return items;
                }

                if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                    var hashCheck = {}, newItems = [];

                    var extractValueToCompare = function (item) {
                        if (angular.isObject(item) && angular.isString(filterOn)) {
                            if (filterOnSecondLevel && angular.isString(filterOnSecondLevel)) {
                                if (item[filterOn]) {
                                    return item[filterOn][filterOnSecondLevel];
                                } else {
                                    return item[filterOn];
                                }
                                // FIXME: Creo que está añadiendo los elementos vacíos también
                            } else {
                                return item[filterOn];
                            }
                        } else {
                            return item;
                        }
                    };

                    angular.forEach(items, function (item) {
                        var valueToCheck, isDuplicate = false;

                        for (var i = 0; i < newItems.length; i++) {
                            if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (!isDuplicate) {
                            newItems.push(item);
                        }

                    });
                    items = newItems;
                }
                return items;
            };
        });
})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:trustUrl
     * @description
     * Permite utilizar URLs en actions directamente.
     *
     * @returns {String} Se indica que la URL es de confianza.
     */
    angular
        .module('app')
        .filter('trustUrl', filter);

    /* @ngInject */
    function filter($sce) {
        return filter;

        function filter(url) {
            return $sce.trustAsResourceUrl(url);
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:num
     *
     * @description
     * Convierte un String en un Int.
     *
     * @returns {int} Devuelve el String convertido en entero
     */
    angular
        .module('app')
        .filter('num', function () {
            return function (input) {
                return parseInt(input, 10);
            }
        });

})();

(function () {
    'use strict';

    // Podría ser interesante utilizar Moment para que sea más genérico... https://github.com/jsmreese/moment-duration-format

    /**
     * @ngdoc filter
     * @name app.filter:minutos
     *
     * @description
     * Filtro para convertir minutos a: Xh Ym
     *
     * @returns {String} Minutos con el formato Xh Ym
     */
    angular
        .module('app')
        .filter('minutos', minutos);

    function minutos() {
        return calcular;

        function calcular(time) {
            time = Math.floor(time);
            if (time < 60) {
                return (time) + 'm';
            } else if (time % 60 == 0) {
                return (time - time % 60) / 60 + 'h';
            } else {
                return ((time - time % 60) / 60 + 'h' + ' ' + time % 60 + 'm');
            }
        }

    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:fileSize
     * @description
     * Devuelve el tamaño de un archivo redondeando a su unidad más próxima.
     * Si la unidad es de MB o superior, se mostrará con dos decimales.
     *
     * Ej: '156663 Bytes' = '153 KB'
     *
     * @returns {Number} Número de bytes de un archivo.
     */
    angular
        .module('app')
        .filter('fileSize', filter);

    function filter() {
        return calcular;

        function calcular(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            var value = bytes / Math.pow(1024, i);
            if (i > 1) {
                value = value.toFixed(2);
                if (value % 1 == 0) {
                    value = Math.round(value, 2);
                }
            } else {
                value = Math.round(value, 2);
            }

            return value + ' ' + sizes[i];
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:capitalize
     *
     * @returns {String} Devuelve un string con la primera letra de cada palabra en mayúscula
     */
    angular
        .module('app')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter(input) {
            if (input && input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('exploradorArchivos', {
            url: '/explorador-archivos',
            data: {
                pageTitle: 'exploradorArchivos.title',
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'filemanager@': {
                    template: '<explorador-archivos></explorador-archivos>'
                }
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = true;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:exploradorArchivos
     * @description
     * Componente que muestra un explorador de archivos.
     *
     * Se integra con CKEditor y permite seleccionar archivos.
     *
     * También permite edición de ciertos archivos y previsualización.
     *
     * Referencia: https://github.com/joni2back/angular-filemanager
     *
     * __Requiere__ AngularFilemanager y ocLazyLoad.
     */
    angular
        .module('app')
        .component('exploradorArchivos', {
            template: '<span oc-lazy-load="FileManagerApp">' +
            '<angular-filemanager></angular-filemanager>' +
            '</span>',
            controllerAs: 'ctrl',
            controller: Controller
        });

    /* @ngInject */
    function Controller($injector, $ocLazyLoad) {
        // Cargamos los archivos necesarios de angular-filemanager y CKEditor.
        $ocLazyLoad.load({
            name: 'FileManagerApp',
            files: [
                'assets/bower/angular-filemanager/angular-filemanager.min.js',
                'assets/bower/angular-filemanager/angular-filemanager.min.css',
                'assets/ckeditor/ckeditor.js',
                'assets/js/file-manager.service.js'
            ]
        }).then(function () {
            var FileManagerService = $injector.get('FileManagerService');

            // TODO: Se puede parametrizar la configuración para recibir información. Ejemplo: tipo de elementos que hay que mostrar
            FileManagerService.config();
        });

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Rss', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "rss";
        return $resource('api/' + entidad, {}, {
            query: {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('FeedRss', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "feed-rss";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('CategoriaRss', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "categorias-rss";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:descargar
     * @description
     * Componente que permite la descarga de un archivo, mostrando un icono u otro en función de la extensión del mismo.
     *
     * @param {Object} archivo Nombre del archivo
     * @param {String} url URL del directorio donde se encuentra el archivo
     * @param {String} [texto=ctrl.archivo] Texto que se mostrará.
     * Si no se indica ninguno, se mostrará el nombre del archivo. Si se indica cadena vacía, no se mostrará ningún texto.
     * @param {String} [titulo='descargar.titulo'] Texto que se muestra al poner el ratón sobre el enlace
     * @param {Boolean} [mostrarBoton=false] Booleano para indicar si el elemento se muestra en formato botón o como un link
     *
     */
    angular.module('app')
        .component('descargar', {
            templateUrl: 'app/components/descargar/descargar.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                archivo: '<',
                url: '@',
                texto: '@',
                titulo: '@',
                mostrarBoton: '<',
                size: '<'
            }
        });

    function Controller() {
        var vm = this;

        // Valores por defecto
        // Si se envía un string vacío, entonces no se mostrará texto.
        if (vm.texto === undefined) {
            vm.texto = vm.archivo;
        }
        vm.titulo = vm.titulo || "descargar.titulo";

        //

        vm.descargarArchivo = function () {
            window.open(vm.url + vm.archivo, '_blank');
        };

        vm.getClase = function () {
            var extension = vm.archivo.split('.').pop();
            switch (extension) {
                // Documentos
                case 'pdf':
                    return 'fa fa-file-pdf-o';
                case 'txt':
                case 'text':
                    return 'fa fa-file-text-o';
                case 'doc':
                case 'docx':
                    return 'fa fa-file-word-o';
                case 'xls':
                case 'xlsx':
                    return 'fa fa-file-excel-o';
                case 'ppt':
                case 'pptx':
                    return 'fa fa-file-powerpoint-o';
                case 'html':
                    return 'fa fa-file-code-o';
                // Vídeos
                case 'mp4':
                case 'webm':
                case 'avi':
                    return 'fa fa-file-video-o';
                // Audios
                case 'mp3':
                case 'ogg':
                    return 'fa fa-file-audio-o';
                // Imágenes
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'bmp':
                case 'gif':
                    return 'fa fa-file-image-o';
                // Otros
                case 'zip':
                    return 'fa fa-file-archive-o';
                default:
                    return 'fa fa-download';
            }
        }
    }

})();

(function (angular) {
    'use strict';

    angular.module('app').config(config);

    // TODO: Este estado sólo vale para páginas estáticas en HTML, pero no para BD.
    /* @ngInject */
    function config($stateProvider) {
        $stateProvider.state('estatica', {
            parent: 'site',
            url: '/estatica/:id',
            params: {
                language: ['Language',
                    function (Language) {
                        return Language.getCurrent();
                    }
                ]
            },
            data: {
                authorities: []
            },
            // FIXME: Se puede comprobar si existe la página? En caso de que no exista, apuntar a una que sí. Si no, la página se queda en blanco sin dar error.
            views: {
                'content@': {
                    templateUrl: function (params) {
                        return 'estaticas/' + params.id + '/' + params.id + '.' + params.language + '.html';
                    }
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/estaticas');
                }
            }
        });
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Estatica', Service);

    /* @ngInject */
    function Service($resource) {
        var url = "api/estaticas";
        return $resource(url + '/:nombre', {}, {
            'getByNombreIdioma': {
                method: 'GET',
                url: url + '/getByNombreIdioma'
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:EstaticaModal
     *
     * @requires app.service:ModalService
     *
     */
    angular.module('app')
        .service('EstaticaModal', EstaticaModal);

    // TODO: Mejora: Se podría refactorizar haciendo que la plantilla fuese el header y footer del modal y el contenido un include de la página en concreto.
    // TODO: Sólo acepta páginas estáticas

    /* @ngInject */
    function EstaticaModal(ModalService, Language) {
        return {
            open: open
        };

        /**
         * @param id nombre del archivo
         */
        function open(id) {
            ModalService.open({
                    templateUrl: function () {
                        return 'estaticas/' + id + '/' + id + '.' + Language.getCurrent() + '.html';
                    },
                    /* @ngInject */
                    controller: function Controller(ModalService, title) {
                        var vm = this;

                        vm.title = title;
                        vm.close = function () {
                            ModalService.dismiss();
                        };
                    },
                    controllerAs: 'ctrl',
                    resolve: {
                        title: function () {
                            return 'estatica.' + id + ".title"
                        }
                    }
                }
            );
        }
    }

})();

(function (angular) {
    'use strict';

    // id: Identificador de la página estática. (Nombre del archivo o identificador de BD).
    // carpeta: Ruta a la página en caso de que haya alguna carpeta intermedia.
    // bd: Boolean. Si se obtiene de BD, se carga el archivo estatica.html y se muestra el contenido.
    // sinTitulo: Boolean. Si es true, el título de la sección se ocultará.

    angular
        .module('app')
        .component('estatica', {
            bindings: {
                id: '@', // required
                carpeta: '@',
                bd: '<',
                sinTitulo: '<',
                clase: '@'
            },
            /* @ngInject */
            templateUrl: function ($element, $attrs, Language) {
                if ($attrs.bd === "true") {
                    return 'app/components/estaticas/estatica.html';
                } else {
                    var carpeta = "";
                    if ($attrs.carpeta) {
                        carpeta = $attrs.carpeta + "/";
                    }
                    return 'estaticas/' + carpeta + $attrs.id + '/' + $attrs.id + '.' + Language.getCurrent() + '.html';
                }
            },
            /* @ngInject */
            controller: function (Estatica, Language) {
                var vm = this;
                if (vm.bd) {
                    Estatica.getByNombreIdioma({
                        'nombre': vm.id,
                        'idioma': Language.getCurrent()
                    }).$promise.then(function (data) {
                        vm.estaticai18n = data;
                    });
                }
            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:enumerado
     *
     * @param {String} value Valor del enumerado
     * @param {String} base Clave base para el fichero de mensajes
     */
    angular
        .module('app')
        .component('enumerado', {
            template: '<span ng-if="ctrl.value">{{ctrl.base + "." + ctrl.value | translate}}</span>',
            controllerAs: 'ctrl',
            bindings: {
                value: '@',
                base: '@'
            }
        });

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:date
     * @description
     * Componente para mostrar una fecha en un formato concreto.
     *
     * @param {Object} model Valor de la fecha a mostrar
     * @param {String} [format=dd/MM/yyyy, HH:mm] Formato que tendrá la fecha
     * @param {Boolean} [fecha=false] Booleano para indicar si se tiene que incluir la fecha
     * @param {Boolean} [hora=false] Booleano para indicar si se tiene que incluir la hora
     *
     */
    angular
        .module('app')
        .component('date', {
            template: '{{ctrl.result | date:ctrl.format}}',
            bindings: {
                model: '<', // required
                format: '@',
                fecha: '<',
                hora: '<'
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($scope) {
        var vm = this;
        if (!vm.format) {
            if (vm.fecha) {
                vm.format = 'dd/MM/yyyy';
            } else {
                if (vm.hora) {
                    vm.format = 'HH:mm';
                } else {
                    vm.format = 'dd/MM/yyyy, HH:mm';
                }
            }
        }

        function init() {
            // Si recibimos la fecha del servidor, convertimos segundos a milisegundos
            if (angular.isNumber(vm.model)) {
                vm.result = vm.model * 1000;
            }
        }

        $scope.$watch(function () {
            return vm.model;
        }, function () {
            init();
        });
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:contactoMap
     * @description
     * Mapa con un punto de contacto.
     *
     * Pensado únicamente a modo contacto, no para añadir más marcadores.
     *
     * Pasos:
     * - Obtener una clave.
     * - Ponerla en `apis.googleMaps`, en el archivo de Gulp `config.js`.
     *
     * __Referencia:__ https://developers.google.com/maps/documentation/javascript/
     * https://developers.google.com/maps/documentation/javascript/3.exp/reference
     *
     * @param {Number} lat Latitud del punto.
     * @param {Number} lng Longitud del punto.
     * @param {Number} [zoom=15] Zoom por defecto al cargar el mapa.
     * @param {String} icono Imagen del marcador. Si no se indica ninguna, el icono es de Google Maps.
     *
     */
    angular
        .module('app')
        .component('contactoMapa', {
            templateUrl: 'app/components/contactomapa/contacto-mapa.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                lat: '<',
                lng: '<',
                zoom: '<',
                titulo: '@',
                icono: '<'
            }
        });

    /* @ngInject */
    function Controller($sce, $ocLazyLoad, APIS) {
        var vm = this;

        vm.clave = APIS.googleMaps;

        $ocLazyLoad.load('js!https://maps.googleapis.com/maps/api/js?key=' + vm.clave).then(function () {
            vm.initMap();
        });

        vm.initMap = function () {
            var posicion = {lat: vm.lat, lng: vm.lng};

            // Create a map object and specify the DOM element for display.
            var map = new google.maps.Map(document.getElementById('mapa'), {
                center: posicion,
                zoom: vm.zoom || 15,
                fullscreenControl: false
            });

            // Create a marker and set its position.
            new google.maps.Marker({
                map: map,
                position: posicion,
                icon: vm.icono,
                title: vm.titulo
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Contacto', Service);

    /* @ngInject */
    function Service($resource) {
        var entidad = "contacto";
        return $resource('api/' + entidad);
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:contactoForm
     * @description
     * Formulario de contacto que envía un email al administrador de la plataforma (el email es configurable).
     *
     */
    angular
        .module('app')
        .component('contactoForm', {
            templateUrl: 'app/components/contactoform/contacto-form.html',
            controllerAs: 'ctrl',
            controller: Controller
        });

    /* @ngInject */
    function Controller($rootScope, Contacto, Permisos, COMPONENTES, vcRecaptchaService) {
        var vm = this;
        vm.captcha = {
            resuelto: false,
            response: undefined
        };

        vm.mostrarCaptcha = Permisos.tienePermisos('all', COMPONENTES.contacto.captcha);

        function init() {
            vm.item = new Contacto();
            vm.terminos = false;
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.captchaToken = vm.captcha.response;

            vm.item.$save().then(function () {
                init();
                vm.form.$setPristine();
                vcRecaptchaService.reload();
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.captchaSuccess = function(response) {
            vm.captcha.resuelto = true;
            vm.captcha.response = response.response;
        };

        init();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('contacto', {
            parent: 'public',
            url: '/contacto',
            data: {
                pageTitle: 'componentes.menu.contacto.titulo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/contacto/contacto.html'
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/contacto');
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:changePassword
     * @description
     * Componente para modificar la contraseña del usuario autenticado.
     *
     */
    angular
        .module('app')
        .component('changePassword', {
            templateUrl: 'app/components/changepassword/change-password.html',
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function ($rootScope, $timeout, Auth) {
                var vm = this;

                $timeout(function () {
                    angular.element('.form-group:eq(0) input').focus();
                });

                vm.save = function () {
                    Auth.changePassword(vm.item).then(function () {
                        vm.confirmPassword = "";
                        vm.item = {};
                        vm.form.$setPristine();
                    }).catch(function (response) {
                        $rootScope.mostrarErrores(response, vm.form);
                    });
                };
            }

        });

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Configuracion', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "configuracion";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('admin/configuracion', {
            parent: 'admin',
            url: '/configuracion',
            redirectTo: 'admin/configuracion/edit',
            data: {
                pageTitle: 'configuracion.titulo'
            },
            ncyBreadcrumb: {
                label: 'configuracion.titulo'
            }
        }).state('admin/configuracion/edit', {
            parent: 'admin/configuracion',
            url: '/editar',
            views: {
                'content@': {
                    template: '<configuracion-form-admin configuraciones="$resolve.configuraciones"></configuracion-form-admin>'
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/configuracion');
                },
                /* @ngInject */
                configuraciones: function (Configuracion) {
                    return Configuracion.query().$promise.then(function (data) {
                        return data.content;
                    });
                }
            },
            ncyBreadcrumb: {
                skip: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('configuracionFormAdmin', {
            templateUrl: 'app/components/configuracion/configuracion-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                configuraciones: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, Configuracion) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        // Guardar formulario
        vm.save = function () {
            Configuracion.save(vm.configuraciones).$promise.catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:booleano
     * @description
     * Componente para mostrar el texto Sí/No
     *
     * @param {String} value Valor booleano (true/false -> Sí/No).
     *
     */
    angular
        .module('app')
        .component('booleano', {
            template: '{{"enum.boolean." + ctrl.value | translate}}',
            controllerAs: 'ctrl',
            bindings: {
                value: '@'
            }
        });

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:buttonTop
     * @description
     * Componente que añade un botón flotante para ir arriba.
     *
     */
    angular
        .module('app')
        .component('buttonTop', {
            template: '<button id="button-top" ng-click="ctrl.topFunction()"><span class="glyphicon glyphicon-arrow-up"></span></button>',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($window) {
        var vm = this;

        // Botón ir arriba
        $window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.getElementById("button-top") != undefined) {
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    document.getElementById("button-top").style.display = "block";
                } else {
                    document.getElementById("button-top").style.display = "none";
                }
            }
        }

        vm.topFunction = function () {
            $("html, body").animate({scrollTop: "0px"}, 1000);
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Tema', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "tema";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findByMateriaUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/findByMateriaUrl',
                params: {
                    url: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('RecursoEducativo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "recurso-educativo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findByMateriaUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/findByMateriaUrl',
                params: {
                    url: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('NivelEducativo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "nivel-educativo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Materia', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "materia";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findByNivelUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/findByNivelUrl',
                params: {
                    url: null
                },
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('AulaDigitalUtil', Service);

    /* @ngInject */
    function Service() {
        return {
            getRutaRecursosBase: getRutaRecursosBase,
            getRutaRecursos: getRutaRecursos
        };

        function getRutaRecursosBase() {
            return '/upload/recursoseducativos/';
        }

        function getRutaRecursos(id) {
            return getRutaRecursosBase() + id + '/';
        }
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:AlertService
     * @description
     * Servicio para trabajar con alertas.
     *
     */
    angular
        .module('app')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService($timeout, $sce, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                clearPermanent: clearPermanent,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            };

            /**
             * @ngdoc function
             * @name isToast
             * @methodOf app.service:AlertService
             * @returns {boolean} `true` if _floating_ alert, `false` otherwise
             */
            function isToast() {
                return toast;
            }

            /**
             * @ngdoc function
             * @name clear
             * @methodOf app.service:AlertService
             * @description
             * Removes all alerts
             */
            function clear() {
                alerts.splice(0, alerts.length);
            }

            /**
             * @ngdoc function
             * @name clearPermanent
             * @methodOf app.service:AlertService
             * @description
             * Each alert will close itself when if timeout is 0 (permanent alert)
             */
            function clearPermanent() {
                // Ocultamos alertas permanentes y las de error también
                alerts.forEach(function (alert, index) {
                    if (alert.timeout == 0) {
                        alerts.splice(index, 1);
                    }
                    if (alert.type === 'danger') {
                        alerts.splice(index, 1);
                    }
                });
            }

            /**
             * @ngdoc function
             * @name get
             * @methodOf app.service:AlertService
             * @returns {object} Alerts
             */
            function get() {
                return alerts;
            }

            /**
             * @ngdoc function
             * @name success
             * @methodOf app.service:AlertService
             * @description
             * Adds a success message
             *
             * @param {string} msg    Message key
             * @param {string} [params=null] JSON with the properties to be included in the message. Example: <br>
             *                 Message: `The cost is {{value}}` <br>
             *                 Param: `{value: 16}` <br>
             *                 Generated message: _The cost is 16_
             * @param {number} [time=null] Time in ms that the message will be displayed, `null` means permanent.
             * @param {string} [position=null] Message location. Available only when _toast_ mode is set.
             */
            function success(msg, params, time, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            /**
             * @ngdoc function
             * @name error
             * @methodOf app.service:AlertService
             * @description
             * Adds an error message
             *
             * @param {string} msg    Message key
             * @param {string} [params=null] JSON with the properties to be included in the message. Example: <br>
             *                 Message: `The cost is {{value}}` <br>
             *                 Param: `{value: 16}` <br>
             *                 Generated message: _The cost is 16_
             * @param {number} [time=null] Time in ms that the message will be displayed, `null` means permanent.
             * @param {string} [position=null] Message location. Available only when _toast_ mode is set.
             */
            function error(msg, params, time, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            /**
             * @ngdoc function
             * @name warning
             * @methodOf app.service:AlertService
             * @description
             * Adds a warning message
             *
             * @param {string} msg    Message key
             * @param {string} [params=null] JSON with the properties to be included in the message. Example: <br>
             *                 Message: `The cost is {{value}}` <br>
             *                 Param: `{value: 16}` <br>
             *                 Generated message: _The cost is 16_
             * @param {number} [time=null] Time in ms that the message will be displayed, `null` means permanent.
             * @param {string} [position=null] Message location. Available only when _toast_ mode is set.
             */
            function warning(msg, params, time, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            /**
             * @ngdoc function
             * @name info
             * @methodOf app.service:AlertService
             * @description
             * Adds an info message
             *
             * @param {string} msg    Message key
             * @param {string} [params=null] JSON with the properties to be included in the message. Example: <br>
             *                 Message: `The cost is {{value}}` <br>
             *                 Param: `{value: 16}` <br>
             *                 Generated message: _The cost is 16_
             * @param {number} [time=null] Time in ms that the message will be displayed, `null` means permanent.
             * @param {string} [position=null] Message location. Available only when _toast_ mode is set.
             */
            function info(msg, params, time, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            /**
             * @ngdoc function
             * @name success
             * @methodOf app.service:AlertService
             * @description
             * Adds a success message
             *
             * @param {string} msg    Message key
             * @param {string} [params=null] JSON with the properties to be included in the message. Example: <br>
             *                 Message: `The cost is {{value}}` <br>
             *                 Param: `{value: 16}` <br>
             *                 Generated message: _The cost is 16_
             * @param {number} [time=null] Time in ms that the message will be displayed, `null` means permanent.
             * @param {string} [position=null] Message location. Available only when _toast_ mode is set.
             */
            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            /**
             * @ngdoc function
             * @name closeAlert
             * @methodOf app.service:AlertService
             * @description
             * Removes the alert with specified id from the alerts array
             * @param {number} id Alert id
             * @param {object} [extAlerts=null] Array of alerts
             */
            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            /**
             * @ngdoc function
             * @name closeAlertByIndex
             * @methodOf app.service:AlertService
             * @description
             * Removes the alert at index position
             * @param {number} index Alert position in the alerts array
             * @param {object} thisAlerts Array of alerts
             */
            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }

            // -----------------
            // Private functions
            // -----------------

            function getTimeout(time) {
                if (time == null) return timeout;
                return time;
            }

            function factory(alertOptions) {
                if (!alertOptions.params) {
                    alertOptions.params = {};
                }
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.params.toast ? alertOptions.params.toast : alertOptions.toast,
                    position: alertOptions.params.position ? alertOptions.params.position : 'bottom right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(alertServiceConfig);

    /* @ngInject */
    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:alert
     *
     * @param {Boolean} [modal=false] Booleano que indica si el componente se está mostrando en una modal o no.
     *
     */
    angular
        .module('app')
        .component('alert', {
            template: '<div class="alerts" ng-cloak="" ng-show="!$ctrl.modalService() || ($ctrl.modal && $ctrl.modalService())">' +
            '<div ng-repeat="alert in $ctrl.alerts track by alert.id" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<div uib-alert ng-cloak="" type="{{alert.type}}" ng-class="\'alert-\' + alert.type" close="alert.close($ctrl.alerts)">' +
            '<span ng-bind-html="alert.msg"></span></div>' +
            '</div>' +
            '</div>',
            controller: alertController,
            bindings: {
                modal: '<'
            }
        });

    /* @ngInject */
    function alertController($scope, AlertService, ModalService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = AlertService.get();
        vm.modalService = ModalService.isOpen;

        function addErrorAlert(message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );

            // Si se produce un error, y no se está en una ventana modal, se sube al principio de la página para ver el alert.
            if (!vm.modal && !AlertService.isToast()) {
                angular.element("html, body").animate({scrollTop: 0}, "slow");
            }
        }

        var cleanHttpErrorListener = $rootScope.$on('app.httpError', function (event, httpResponse) {

            if (!!vm.modalService() !== vm.modal) {
                return;
            }
            var i;
            event.stopPropagation();

            var errorHeader = httpResponse.headers('X-app-error');
            var entityKey = httpResponse.headers('X-app-params');

            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.servernotreachable');
                    break;

                case 400:
                    // Bad Request

                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {entityName: entityName});

                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('jhipsterJwtApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }

                    } else if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.errors) {
                            // TODO: Meter en un bucle.
                            // Estos errores nunca deberían llegar a mostrarse a no ser que se salten las restricciones del cliente
                            if (httpResponse.data.errors[0].code === 'NotNull') {
                                addErrorAlert("error.notnulls", null, null);
                            } else if (httpResponse.data.errors[0].code === 'Size') {
                                addErrorAlert("error.size", null, null);
                            }
                        } else {
                            addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                        }
                    }
                    break;

                case 401:
                    // Unauthorized
                    break;
                case 403:
                    // Forbidden
                    addErrorAlert('Access is denied', 'error.accessdenied.title');
                    break;
                case 404:
                    // Not Found
                    if (errorHeader) {
                        addErrorAlert('Not found', errorHeader);
                    } else {
                        addErrorAlert('Not found', 'error.notfound');
                    }
                    break;
                case 500:
                    // Internal Server Error
                    addErrorAlert('Internal server error', 'error.internalservererror');
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.error === 'Internal Server Error') {
                            addErrorAlert('Internal server error', 'error.internalservererror');
                        } else {
                            addErrorAlert(httpResponse.data.message);
                        }
                    }
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            vm.alerts = [];
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('Principal', Principal);

    /* @ngInject */
    function Principal($q, Account, $rootScope) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
            $rootScope.$broadcast('changedIdentity');
        }

        function hasAnyAuthority(authorities) {
            if (authorities.indexOf("ROLE_ANONYMOUS") >= 0 && !_authenticated && !_identity) {
                return true;
            }

            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            if (authorities.indexOf("ROLE_AUTHENTICATED") >= 0
                && _identity.authorities && _identity.authorities.length > 0) {
                return true;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force, login) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get({login: login}).$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                $rootScope.$broadcast('changedIdentity');
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
                $rootScope.$broadcast('changedIdentity');
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function (angular) {
    'use strict';

    angular.module('app')
        .factory('Auth', Auth);

    /* ngInject */
    function Auth($rootScope, $state, $sessionStorage, $q, $http, AuthServerProvider, Principal, Administrador, UsuarioAspg) {
        return {
            login: login,
            loginWithToken: loginWithToken,
            logout: logout,
            authorize: authorize,
            createAccount: createAccount,
            validateAccount: validateAccount,
            changePassword: changePassword,
            resetPasswordInit: resetPasswordInit,
            resetPasswordFinish: resetPasswordFinish
        };

        function validateAccount(key) {
            return $http({
                method: 'GET',
                url: 'api/usuario-aspg/validar',
                params: {key: key}
            });
        }

        function login(credentials, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            var login = credentials.username;

            AuthServerProvider.login(credentials).then(function (jwt) {
                // retrieve the logged account information
                Principal.identity(true, login).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration

                    // $translate.use(account.langKey);
                    deferred.resolve(account);
                });
                return cb();
            }).catch(function (err) {
                this.logout();
                deferred.reject(err);
                return cb(err);
            }.bind(this));

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function authorize(force, authorities) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account'
                    && ($rootScope.toState.name === 'login'
                        || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth'
                        || $rootScope.toState.name === 'recuperar/init' || $rootScope.toState.name === 'recuperar/finish')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && (!$rootScope.fromState || !$rootScope.fromState.name) && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if (($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0
                        && !Principal.hasAnyAuthority($rootScope.toState.data.authorities))
                    || (authorities && authorities.length > 0 && !Principal.hasAnyAuthority(authorities))) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $sessionStorage.previousStateName = $rootScope.toState.name;
                        $sessionStorage.previousStateParams = $rootScope.toStateParams;

                        if ($rootScope.toState.name.startsWith("admin/")) {
                            // now, send them to the signin state so they can log in
                            $state.go('login');
                        } else {
                            $state.go('enXogo/login');
                        }
                    }
                }
            }
        }

        function createAccount(account, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;

            return Administrador.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    // this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Principal.identity().then(function(usuario){
                var entidad;
                if (usuario.rol === 'ROLE_ADMIN'){
                    entidad = Administrador;
                } else {
                    entidad = UsuarioAspg;
                }

                var deferred = $q.defer();
                deferred.resolve(entidad);

                return deferred.promise;
            }).then(function(entidad){
                return entidad.changePassword(newPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            });
        }

        function resetPasswordInit(email) {
            return $http({
                method: 'GET',
                url: 'api/usuario-aspg/reset-contrasena/init',
                params: {email: email}
            });
        }

        function resetPasswordFinish(keyAndPassword) {
            return $http({
                method: 'GET',
                url: 'api/usuario-aspg/reset-contrasena/finish',
                params: {
                    email: keyAndPassword.email,
                    key: keyAndPassword.key,
                    newPassword: keyAndPassword.newPassword
                }
            });
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken() {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/account/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess(data) {
                var status = data.status;
                var headers = data.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (true) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Account', Account);

    /* @ngInject */
    function Account($resource) {
        return $resource('api/account/account', {}, {
            'get': {
                method: 'GET',
                params: {login: '@login'},
                isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('accessdenied', {
                parent: 'public',
                url: '/acceso-denegado',
                data: {
                    authorities: [],
                    pageTitle: 'error.accessdenied.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:ResourceHelper
     * @description
     * Clase de ayuda para generar un `$resource` de una entidad.
     *
     */
    angular.module('app')
        .factory('ResourceHelper', ResourceHelper);

    /* @ngInject */
    function ResourceHelper($resource) {

        return {
            getResource: getResource
        };

        /**
         * @ngdoc function
         * @name getResource
         * @methodOf app.service:ResourceHelper
         * @param {String} entidad Nombre de la endidad. Coincide con el nombre que se le de en la API REST
         * @param {Object} params Parámetros adicionales que se pasan al $resource
         * @param {Object} newFunctions Objecto que define las nuevas funciones o las que hay que sobreescribir
         * @returns {Object} `$resource`
         */
        function getResource(entidad, params, newFunctions) {
            var functions = {
                'query': {
                    isArray: false
                }
            };
            angular.extend(functions, newFunctions);

            return $resource('api/' + entidad + '/:id', params, functions);
        }
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderController', Controller);

    /* @ngInject */
    function Controller() {
        var vm = this;

    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('admin/changepassword', {
            parent: 'admin',
            url: '/admin/modificar-contrasena',
            data: {
                authorities: ['ROLE_AUTHENTICATED'],
                pageTitle: 'admin.changepassword.title'
            },
            views: {
                'content@': {
                    template: '<div class="row"><div class="col-md-8 col-md-offset-2">' +
                    '<change-password></change-password>' +
                    '</div></div>'
                }
            },
            ncyBreadcrumb: {
                label: 'admin.changepassword.title'
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/changepassword');
                    $translatePartialLoader.addPart('admin');
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/',
            data: {
                pageTitle: 'global.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'ctrl'
                }
            }
        });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HomeController', Controller);

    /* @ngInject */
    function Controller() {
        var vm = this;

    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('asociarse', {
            parent: 'public',
            url: '/asociarse',
            data: {
                pageTitle: 'global.menu.asociarse'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/asociarse/asociarse.html'
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/asociarse');
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['AlertService'];

    function notificationInterceptor(AlertService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {
            var alertKey = response.headers('X-app-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, {param: response.headers('X-app-params')});
            }
            return response;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        return {
            responseError: responseError
        };

        function responseError(response) {
            if (!(response.status === 401 && response.data &&
                    (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account/account') === 0)))) {
                $rootScope.$emit('app.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$localStorage', '$sessionStorage'];

    function authInterceptor($localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }

            return config;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:RutasService
     * @description
     * Operaciones relacionadas con las rutas de la aplicación.
     *
     */
    angular.module('app')
        .factory('RutasService', RutasService);

    /* @ngInject */
    function RutasService($location, $window, CONTEXT, DEBUG_INFO_ENABLED) {
        var cacheUrl = "";

        return {
            /**
             * @ngdoc function
             * @name getBaseUrl
             * @methodOf app.service:RutasService
             * @param {Boolean} [cliente=false] Booleano para saber si queremos la ruta del lado cliente o del lado servidor.
             * @returns {String} Ruta base de la aplicación.
             */
            getBaseUrl: getBaseUrl,
            /**
             * @ngdoc function
             * @name getUrlParam
             * @methodOf app.service:RutasService
             * @param {String} paramName Nombre del parámetro.
             * @returns {String} Valor del parámetro de la URL.
             */
            getUrlParam: getUrlParam,
            /**
             * @ngdoc function
             * @name getContext
             * @methodOf app.service:RutasService
             * @returns {String} Contexto de la aplicación.
             */
            getContext: getContext,

            // TODO: Mover a un servicio particular de la aplicación.
            getAgenteCvUrl: getAgenteCvUrl,
            getAgenteImagenUrl: getAgenteImagenUrl
        };

        function getBaseUrl(cliente) {
            // En desarrollo utilizamos la de pre porque si no hay problemas al compartir con Facebook
            if (!cacheUrl) {
                if (DEBUG_INFO_ENABLED) {
                    if (cliente) {
                        cacheUrl = "http://localhost:9000/#";
                    } else {
                        cacheUrl = "http://localhost:8080";
                    }
                } else {
                    cacheUrl = $location.protocol() + "://" + $location.host();
                    if ($location.port() !== 80) {
                        cacheUrl = cacheUrl + ":" + $location.port();
                    }
                }
                cacheUrl = cacheUrl + getContext();
            }
            return cacheUrl;
        }

        function getUrlParam(paramName) {
            var reParam = new RegExp('(?:[\?&]|&)' + paramName + '=([^&]+)', 'i');
            var match = $window.location.href.match(reParam);

            return (match && match.length > 1) ? match[1] : null;
        }

        function getContext() {
            var context = CONTEXT;
            if (CONTEXT) {
                context = "/" + CONTEXT;
            }
            return context;
        }

        function getAgenteCvUrl(id) {
            return '/upload/agentes/' + id + '/cv/';
        }

        function getAgenteImagenUrl(id) {
            return '/upload/agentes/' + id + '/imagen/';
        }

    }

})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:Language
     * @description
     * Operaciones relacionadas con el idioma de la aplicación.
     *
     */
    angular.module('app')
        .factory('Language', factory);

    /* @ngInject */
    function factory($translate, LANGUAGES) {
        return {
            /**
             * @ngdoc function
             * @name getCurrent
             * @methodOf app.service:Language
             * @returns {String} Idioma actual de la aplicación.
             */
            getCurrent: getCurrent,
            /**
             * @ngdoc function
             * @name getDefault
             * @methodOf app.service:Language
             * @returns {String} Idioma por defecto.
             */
            getDefault: getDefault,
            /**
             * @ngdoc function
             * @name getList
             * @methodOf app.service:Language
             * @returns {Array} Lista de idiomas disponibles.
             */
            getList: getList
        };

        function getCurrent() {
            if ($translate.use()) return $translate.use();
            return $translate.preferredLanguage();
        }

        function getDefault() {
            return LANGUAGES.default;
        }

        function getList() {
            return LANGUAGES.list;
        }
    }
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:JsonUtils
     * @description
     * Servicio con operaciones comunes para tratar con JSONs.
     *
     */
    angular
        .module('app')
        .factory('JsonUtils', Service);

    /* @ngInject */
    function Service() {

        return {
            /**
             * @ngdoc function
             * @name cleanJson
             * @methodOf app.service:JsonUtils
             * @param {Object} item Objeto cuyas propiedades se van a eliminar
             * @returns {Object} Elimina todas las propiedades de un objeto.
             * El objeto resultante está vacío (`{}`), pero mantiene la referencia.
             */
            cleanJson: cleanJson
        };

        function cleanJson(item) {
            // for enumerable properties
            var props = Object.keys(item);
            for (var i = 0; i < props.length; i++) {
                delete item[props[i]];
            }
        }
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:FormUtils
     * @description
     * Operaciones útiles para tratar con formularios.
     *
     */
    angular.module('app')
        .factory('FormUtils', Service);

    /* @ngInject */
    function Service() {
        return {
            /**
             * @ngdoc function
             * @name validarTabs
             * @methodOf app.service:FormUtils
             * @description
             * Método para validar los formularios que se encuentran dentro de pestañas (internacionalizados).
             * Comprueba si existen errores de validación y devuelve el índice de la pestaña que contiene al menos uno de estos errores.
             *
             * __Nota:__ Para que funcione correctamente, es necesario que los inputs tengan como ID un nombre y finalicen en `_idioma`.
             * Ej: `"titulo_{{idioma}}"` (que generaría el ID: _titulo_es_).
             *
             * @param {Object} form Formulario que contiene los errores (`$error`).
             * @param {Number} activa Pestaña activa actualmente.
             * @param {Array} idiomas Lista de idiomas de las pestañas.
             * @returns {Number} Índice de la pestaña que contiene al menos un error.
             * En caso de que no haya errores, se devuelve la misma.
             */
            validarTabs: validarTabs
        };

        function validarTabs(form, activa, idiomas) {
            if (form.$error) {
                var keys = Object.keys(form.$error);
                var i = 0;
                while (i < keys.length) {
                    var key = keys[i];

                    var inputErrorId = form.$error[key][0].$$element[0].id;

                    var activarIdioma = inputErrorId.substr(-2);
                    if (activarIdioma && idiomas.indexOf(activarIdioma) >= 0) {
                        activa = idiomas.indexOf(activarIdioma);
                        i = keys.length;
                    }
                    i++;
                }
            }
            return activa;
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:EnumService
     * @description
     * Operaciones para tratar con enumerados.
     *
     */
    angular.module('app')
        .factory('EnumService', EnumService);

    /* @ngInject */
    function EnumService($http, $q) {
        var cache = {};

        return {
            /**
             * @ngdoc function
             * @name get
             * @methodOf app.service:EnumService
             * @description
             * Esta operación cachea en la memoria del cliente los enumerados (si se recarga la página se pierden).
             * Todos las operaciones para obtener los enumerados deberían definirse en `EnumController.java`.
             *
             * @param {String} tipo Nombre de la operación definida en `EnumController`, que se corresponde con un enumerado. (Ej: rol-admin).
             * @returns {Array} Lista de enumerados obtenidos.
             */
            get: get
        };

        function get(tipo) {
            if (cache[tipo]) {
                var defered = $q.defer();
                var promise = defered.promise;
                defered.resolve(cache[tipo]);
                return promise;
            }

            // FIXME: Así sea cachea durante la sesión. Una vez se recarga la página la caché se pierde. Se puede también cachear la petición cambiando la URL base (lo que está en /api no se cachea)
            return $http.get('api/enum/' + tipo, {cache: true}).then(function (result) {
                cache[tipo] = result.data;
                return result.data;
            });
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:Descargas
     * @description
     * Servicio con operaciones útiles para la generación y descarga de archivos.
     *
     * Requires: FileSaver
     *
     */
    angular
        .module('app')
        .factory('Descargas', Service);

    /* @ngInject */
    function Service($http) {

        return {
            /**
             * @ngdoc function
             * @name descargar
             * @methodOf app.service:Descargas
             * @description
             * Método que inicia la descarga de un archivo haciendo una llamada al servidor (GET)
             * y prepara la respuesta para su descarga,
             * poniendo nombre de archivo lo que se haya indicado en el atributo `filename` de la cabecera `Content-Disposition`.
             *
             * @param {String} url URL de descarga.
             * @param {Object} [parametros={}] Parámetros necesarios para la operación GET.
             */
            descargar: descargar
        };

        function descargar(url, parametros) {
            $http({
                method: 'GET',
                url: url,
                data: parametros,
                responseType: "arraybuffer"
            }).then(function (result) {
                var file = new Blob([result.data]);
                var contentDisposition = result.headers("Content-Disposition");
                var filename = contentDisposition.split(";")[1].trim().split('=')[1].replace(/"/g, '');
                saveAs(file, filename);
            });
        }
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:DateUtils
     *
     */
    angular
        .module('app')
        .factory('DateUtils', Service);

    /* @ngInject */
    function Service($filter) {

        return {
            convertDateTimeFromServer: convertDateTimeFromServer,
            // TODO: Probar resto de métodos
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date * 1000);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Administrador', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "administradores";
        var url = "api/" + entidad;
        return ResourceHelper.getResource(entidad, {}, {
            'getById': {
                method: 'GET',
                url: url + '/getById/:id'
            },
            'getUser': {
                method: 'GET',
                url: url + '/:login'
            },
            'findAll': {
                method: 'GET',
                url: url + '/findAll'
            },
            'changePassword': {
                method: 'POST',
                url: url + '/change_password'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'site',
                views: {
                    'css@': {
                        templateUrl: 'app/admin/admin.css.html'
                    },
                    'navbar@': {
                        template: '<mi-menu menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed"></mi-menu>',
                        /* @ngInject */
                        controller: function (menuData, $window) {
                            this.menu = menuData;
                            this.navCollapsed = $window.innerWidth < 992;
                        },
                        controllerAs: '$ctrl'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.admin.html'
                    }
                },
                resolve: {
                    /* @ngInject */
                    isAdmin: function ($rootScope) {
                        $rootScope.isAdmin = true;
                    },
                    /* @ngInject */
                    menuData: function (Menu) {
                        return Menu.getMenu('menu-admin');
                    },
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('admin');
                    }
                }
            })
            .state('admin/login', {
                url: '/admin',
                parent: 'admin',
                redirectTo: 'login'
            });
    }
})();

(function () {
    'use strict';

    // Operaciones CRUD para la gestión de elementos en la administración.

    // PARÁMETROS DE CONFIGURACIÓN:

    // base: Estado base (Ej: 'admin/entity')
    // baseUrl: URL base que se va a mostrar en el navegador (Ej: '/admin/entity')
    // translateBase: Raíz de los ficheros de mensaje (Ej: 'admin.entity.')
    // parent: Indica si los nuevos estados van englobados dentro de otro. Útil para el breadcrumb.(Opcional)

    // v2: Formularios como componentes
    // templateList: Contiene un componente para los listados (Ej: '<entity-list></entity-list>')
    // templateForm: Contiene un componente para los formularios (Ej: '<entity-form></entity-form>')
    // Nota: A los componentes habrá que pasarle (con bindings) toda la información que se obtenga en el 'resolve' del estado.

    // v1: Formularios sin componentes (controladores y htmls)
    // controller: Controlador para el listado
    // controllerForm: Controlador para el formulario
    // templateUrlBase: Añade un prefijo a los archivos: .list.html o .form.html.

    // Ejemplo de uso: FILO1701. Organismos (/app/admin/organismo)

    angular.module('app')
        .constant('STATE_HELPER', function (params) {
            // Convertimos el CamelCase de las URLs en separaciones por guión
            params.baseUrl = params.baseUrl.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

            var states = {
                parent: {
                    name: params.base,
                    parent: params.parent ? params.parent : 'admin',
                    url: params.baseUrl,
                    redirectTo: params.base + '/list',
                    ncyBreadcrumb: {
                        skip: true
                    }
                    // Extend: data {authorities}
                },
                list: {
                    name: params.base + "/list",
                    parent: params.base,
                    url: '/listar/:page',
                    params: {
                        page: {value: '1', dynamic: true}
                    },
                    views: {},
                    data: {
                        pageTitle: params.translateBase + "list.title"
                    },
                    ncyBreadcrumb: {
                        label: params.translateBase + "list.title"
                    }
                },
                create: {
                    name: params.base + "/create",
                    parent: params.base,
                    url: '/crear',
                    data: {
                        pageTitle: params.translateBase + 'create.title',
                        mode: 'create'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "create.title",
                        parent: params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                },
                edit: {
                    name: params.base + "/edit",
                    parent: params.base,
                    url: '/:id/editar',
                    data: {
                        pageTitle: params.translateBase + 'edit.title',
                        mode: 'edit'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "edit.title",
                        parent: params.onlyEdit ? null : params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                }
            };

            if (!params.view) {
                params.view = 'content@';
            }

            // Listar
            states.list.views[params.view] = {
                templateUrl: params.templateUrlBase + '.list.html',
                template: params.templateList ? params.templateList : undefined,
                controllerAs: 'ctrl'
            };

            // Crear y editar
            states.create.views[params.view] = states.edit.views[params.view] = {
                templateUrl: params.templateUrlBase + '.form.html',
                template: params.templateForm ? params.templateForm : undefined,
                controllerAs: 'ctrl'
            };

            if (params.controller) {
                states.list.views[params.view].controller = params.controller;
            }
            if (params.controllerForm) {
                states.create.views[params.view].controller = params.controllerForm;
            }

            return states;
        });
})();

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name app.object:admin_constants
     *
     * @description
     * Constantes para la parte de administración:
     *
     * - ADMIN_PRINCIPAL: `"admin/admin"`
     * - NG_TABLE_DEFAULT_PARAMS: `{size: 10}`
     *
     */
    angular.module('app')
        .constant('ADMIN_PRINCIPAL', "admin/novedad")
        // Nº de elementos por página en las tablas
        .constant('NG_TABLE_DEFAULT_PARAMS', {size: 25});
})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'site',
            views: {
                'css@': {
                    templateUrl: 'app/public/public.css.html'
                },
                'navbar@': {
                    template: '<mi-menu menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed"></mi-menu>',
                    /* @ngInject */
                    controller: function (menuData, $window) {
                        this.menu = menuData;
                        this.navCollapsed = $window.innerWidth < 992;
                    },
                    controllerAs: '$ctrl'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html'
                }
            },
            resolve: {
                /* @ngInject */
                isAdmin: function ($rootScope) {
                    $rootScope.isAdmin = false;
                },
                /* @ngInject */
                menuData: function (Menu) {
                    return Menu.getMenu('menu-main');
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name app.object:public_constants
     *
     * @description
     * Constantes para la parte pública:
     *
     * - NG_TABLE_DEFAULT_PARAMS_PUBLIC: `{size: 20}`
     * - NG_LIST_DEFAULT_PARAMS_PUBLIC: `{size: 20}`
     *
     */
    angular
        .module('app')
        // Nº de elementos por página en las tablas
        .constant('NG_TABLE_DEFAULT_PARAMS_PUBLIC', {size: 20})
        .constant('NG_LIST_DEFAULT_PARAMS_PUBLIC', {size: 10})
    ;
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('privacidad', {
            parent: 'public',
            url: '/privacidade',
            data: {
                pageTitle: 'global.menu.privacidad'
            },
            views: {
                'content@': {
                    template: '<estatica id="privacidad" bd="false"></estatica>'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('cookies', {
            parent: 'public',
            url: '/cookies',
            data: {
                pageTitle: 'global.menu.cookies'
            },
            views: {
                'content@': {
                    template: '<estatica id="cookies" bd="false"></estatica>'
                }
            }
        })

    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('conoce', {
            parent: 'public',
            url: '/conece-a-aspg',
            data: {
                pageTitle: 'global.menu.conoce'
            },
            views: {
                'content@': {
                    template: '<estatica id="quensomos" bd="true"></estatica>'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    // Página temporal a la que se accede al pulsar en el email el email que se envió para notificar la nueva legistación (RGPD)

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('confirmacion-consentimento', {
            parent: 'public',
            url: '/confirmacion-consentimento',
            views: {
                'content@': {
                    template: '<estatica id="confirmacion-consentimento" bd="false"></estatica>'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory("ValidateConfig", factory);

    /* @ngInject */
    function factory($rootScope, $translate, bootstrap3ElementModifier, validator, defaultErrorMessageResolver, AlertService, Language) {
        return {
            initialize: initialize
        };

        function initialize() {
            // Mostrar iconos de validación
            bootstrap3ElementModifier.enableValidationStateIcons(true);
            // No resaltar elementos correctos
            validator.setValidElementStyling(false);
            // Validación sólo al hacer submit
            validator.defaultFormValidationOptions.validateOnFormSubmit = true;

            // Ubicación del fichero de mensajes de error
            defaultErrorMessageResolver.setI18nFileRootPath('i18n/auto-validate');
            defaultErrorMessageResolver.setCulture(Language.getCurrent());

            // Operación que añade errores en los campos correspondientes en un formulario
            $rootScope.mostrarErrores = function (response, form) {
                if (response.data && response.data.fieldErrors) {
                    var errores = false;
                    response.data.fieldErrors.forEach(function (error) {
                        console.log("Error de validación: ", error);
                        // FIXME: No se obtienen los mensajes de jcs-auto-validate .json
                        errores = form.setExternalValidation(error.field, error.code, $translate.instant(error.code));
                    });
                    if (errores) {
                        // Si se encuentran errores en el formulario, no se muestran las Alertas.
                        AlertService.clear();
                    }
                }
            };
        }
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .factory('TranslationHandler', factory);

    factory.$inject = ['$rootScope', '$translate', '$state', '$window', 'defaultErrorMessageResolver'];

    function factory($rootScope, $translate, $state, $window, defaultErrorMessageResolver) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // refresh translate when new parts loaded
            var deregistrationTranslateRefresh =
                $rootScope.$on('$translatePartialLoaderStructureChanged',
                    function () {
                        $translate.refresh();
                        defaultErrorMessageResolver.setCulture($translate.use());
                    }
                );
            $rootScope.$on('$destroy', deregistrationTranslateRefresh);

            // refresh title when translation changes
            var deregistrationTranslateChange =
                $rootScope.$on('$translateChangeSuccess',
                    function () {
                        updateTitle();
                    }
                );
            $rootScope.$on('$destroy', deregistrationTranslateChange);
        }

        function updateTitle(key) {
            $translate(key || $state.$current.data && $state.$current.data.pageTitle || 'global.title')
                .then(function (title) {
                    if (key !== 'global.title') {
                        title = $translate.instant('global.title') + " - " + title;
                    }
                    $window.document.title = title;
                });
        }
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .config(config);

    /* @ngInject */
    function config($translateProvider, $localStorageProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.useLoaderCache(true);
        $translateProvider.useSanitizeValueStrategy('escaped');
        // to use messageformat.js https://github.com/messageformat/messageformat.js
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        // FIXME: No se carga el archivo angular-locale
        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale/angular-locale_{{locale}}.js');

        // El idioma se guarda en localStorage en localstorage.config.js
    }


})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .factory('StateHandler', factory);

    /* @ngInject */
    function factory($state, $window, $timeout, $rootScope, $translate, Principal, Auth, TranslationHandler, AlertService) {
        var _states;

        return {
            stateExists: stateExists,
            initialize: initialize
        };

        function initialize() {
            $timeout(function () {
                _states = $state.get().map(function (item) {
                    return item.name;
                });
            }, 0);
            // in every HTML view we can check for a feature/state and prevent
            // showing a link if it's not enabled
            $rootScope.stateExists = stateExists;

            var deregistrationStateChangeStart = $rootScope.$on('$stateChangeStart',
                function (event, toState, toStateParams) {
                    AlertService.clearPermanent();

                    if (toState.redirectTo && navigator.onLine) {
                        event.preventDefault();
                        $state.go(toState.redirectTo, toStateParams);
                    }

                    $rootScope.toState = toState;
                    $rootScope.toStateParams = toStateParams;

                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }
                }
            );
            $rootScope.$on('$destroy', deregistrationStateChangeStart);

            var deregistrationStateChangeSuccess = $rootScope.$on('$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams) {
                    if ($window.ga) {
                        console.log("GoogleAnalytics. Sending: " + $location.path());
                        $window.ga('set', 'page', $location.path());
                        $window.ga('send', 'pageview');
                    }

                    if (!$rootScope.redirected && fromState.name !== 'logout' && fromState.name !== 'login') {
                        $rootScope.previousStateName = fromState.name;
                        $rootScope.previousStateParams = fromParams;
                    }

                    // Set the page title key to the one configured in state or use default one
                    var titleKey = (toState.data && toState.data.pageTitle) ? toState.data.pageTitle : 'global.title';
                    TranslationHandler.updateTitle(titleKey);

                    // Ocultamos el breadcrumb de administración
                    if (toState.data.hideBreadcrumb) {
                        angular.element(".breadcrumb-ocultable").hide();
                    } else {
                        angular.element(".breadcrumb-ocultable").show();
                    }

                    $("html, body").scrollTop(0);
                }
            );
            $rootScope.$on('$destroy', deregistrationStateChangeSuccess);

            var deregistrationStateChangeError = $rootScope.$on('$stateChangeError',
                function (event, toState, toParams, fromState, fromParams, error) {
                    console.error(error);
                });
            $rootScope.$on('$destroy', deregistrationStateChangeError);

            $rootScope.back = function () {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('home');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            };
        }

        function stateExists(state) {
            return _states.indexOf(state) !== -1;
        }
    }
})(angular);

(function ($) {
    /* Adjustments for Safari on Mac */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        $('body').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
    }
})(jQuery);

(function () {
    'use strict';

    angular
        .module('app')
        .config(localStorageConfig);

    /* @ngInject */
    function localStorageConfig($localStorageProvider, $sessionStorageProvider, $translateProvider, LANGUAGES) {
        // Si se utilizan estas líneas de código, no se podrá acceder a localstorage con $localStorageProvider al configurar la aplicación.

        $localStorageProvider.setKeyPrefix('ASPG-');
        $sessionStorageProvider.setKeyPrefix('ASPG-');

        // Obtenemos el idioma de localStorage
        var lang = $localStorageProvider.get('lang');
        if (!lang || LANGUAGES.list.indexOf(lang) === 0) {
            $translateProvider.preferredLanguage(LANGUAGES.default);
            $localStorageProvider.set('lang', LANGUAGES.default);
        } else {
            $translateProvider.preferredLanguage(lang);
        }
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name app.object:ieFix
     *
     * @description
     * Definición de las operaciones que no soporta Internet Explorer y que el resto de navegadores sí:
     *
     * - `String.prototype.startsWith`
     * - `String.prototype.endsWith`
     * - `String.prototype.inclues`
     * - `Array.prototype.startsWith`
     *
     */
    angular
        .module('app')
        .config(ieFix);

    /* @ngInject */
    function ieFix() {

        // *** Strings ***

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (search, pos) {
                return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
            };
        }

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
        if (!String.prototype.endsWith) {
            String.prototype.endsWith = function (search, this_len) {
                if (this_len === undefined || this_len > this.length) {
                    this_len = this.length;
                }
                return this.substring(this_len - search.length, this_len) === search;
            };
        }

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
        if (!String.prototype.includes) {
            String.prototype.includes = function (search, start) {
                'use strict';
                if (typeof start !== 'number') {
                    start = 0;
                }

                if (start + search.length > this.length) {
                    return false;
                } else {
                    return this.indexOf(search, start) !== -1;
                }
            };
        }

        // *** Arrays ***

        // https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Array/includes
        if (!Array.prototype.includes) {
            Array.prototype.includes = function (searchElement /*, fromIndex*/) {
                'use strict';
                var O = Object(this);
                var len = parseInt(O.length) || 0;
                if (len === 0) {
                    return false;
                }
                var n = parseInt(arguments[1]) || 0;
                var k;
                if (n >= 0) {
                    k = n;
                } else {
                    k = len + n;
                    if (k < 0) {
                        k = 0;
                    }
                }
                var currentElement;
                while (k < len) {
                    currentElement = O[k];
                    if (searchElement === currentElement ||
                        (searchElement !== searchElement && currentElement !== currentElement)) {
                        return true;
                    }
                    k++;
                }
                return false;
            };
        }

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .config(httpConfig);

    /* @ngInject */
    function httpConfig($urlRouterProvider, $httpProvider, $locationProvider, DEBUG_INFO_ENABLED, httpRequestInterceptorCacheBusterProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        // Elimina el ! de las URLs
        $locationProvider.hashPrefix('');

        // Elimina el # de las URLs de producción.
        if (!DEBUG_INFO_ENABLED) {
            $locationProvider.html5Mode(true);
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(appConfig);

    /* @ngInject */
    function appConfig($translateProvider, cfpLoadingBarProvider, $compileProvider, $breadcrumbProvider, $qProvider) {


        // Configuración de la barra de carga
        cfpLoadingBarProvider.latencyThreshold = 150;
        cfpLoadingBarProvider.includeSpinner = false;

        // Configuración Breadcrumb
        $breadcrumbProvider.setOptions({
            templateUrl: 'app/components/breadcrumb/breadcrumb.html'
        });

        // TODO: disable debug data on prod profile to improve performance. Por ahora siempre en modo debug
        $compileProvider.debugInfoEnabled(true);

        $compileProvider.preAssignBindingsEnabled(true);
        $qProvider.errorOnUnhandledRejections(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('site', {
            abstract: true,
            data: {
                authorities: []
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = false;
                },
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('componentes');
                    $translatePartialLoader.addPart('enum');
                    $translatePartialLoader.addPart('public');
                    // Necesario cargarlo para las entradas del menú personalizadas
                    $translatePartialLoader.addPart('componentes/estaticas');
                    // Necesario para la información del footer
                    $translatePartialLoader.addPart('componentes/contacto');
                }
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('app')
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('CONTEXT', "")
        .constant('LANGUAGES', {
	"default": "gl",
	"list": [
		"gl"
	]
})
        .constant('APIS', {
	"facebookId": "232480380858801",
	"facebookSecret": "72a301c8455c8fcbf0f7c127ba5a45c3",
	"facebookVersion": "v3.0",
	"facebookToken": "EAACEdEose0cBAH1eCaPD16JEdROIGVB1ZCFz66lILZB7gpvzHvKiMoO0OtirEscpRZCMv9W4QZBOckmL4AgBIzXdMg5S8RnpvEBWgYsxF50ZAuCnNAZBJkV0do88hmC3Jy5qlwZBWw1i4AmfozHbO2FTQSL97Rj90OGJKmtxKE8eMu56lJd6radUlb1x7eRMPjHh00aJTMJBD6rwgiArslf",
	"twitterKey": "lH6rO4oZwTWsqauTwBWSqRybP",
	"twitterSecret": "aHTWYgVQbai8GtvvJB6Go7enLQmp8hl1Br2EmSrAfIOdPFo8oJ",
	"googleMaps": "AIzaSyCa18a1ro6IL4AObCW4EqcxdTACWZdw_tg",
	"recaptcha": "6LfODVwUAAAAAMrSfGWvNMWD49IdvLJDonGyQK_r"
})
        .constant('COMPONENTES', {
	"aulaDigital": {
		"nivelesAdmin": "list"
	},
	"contacto": {
		"captcha": "all"
	},
	"feedsRss": {
		"categoriasAdmin": "edit"
	},
	"novedades": {
		"categoriasAdmin": "none",
		"categoriasPublic": "none"
	},
	"webs": {
		"categoriasAdmin": "all"
	}
})
;
})();
(function(){angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.css.html","<!-- build:css assets/css/admin.css -->\r\n<link rel=\"stylesheet\" href=\"assets/css/admin.css\">\r\n<!-- endbuild -->\r\n");
$templateCache.put("app/public/public.css.html","<!-- build:css assets/css/public.css -->\r\n<link rel=\"stylesheet\" href=\"assets/css/public.css\">\r\n<!-- endbuild -->\r\n");
$templateCache.put("app/templates/tesauro.templates.html","<script type=\"text/ng-template\" id=\"agentes.tesauro.html\">\r\n    <a>\r\n        {{match.model.nombre}} <span ng-if=\"match.model.pseudonimo\">({{match.model.pseudonimo}})</span>\r\n    </a>\r\n</script>\r\n");
$templateCache.put("app/components/breadcrumb/breadcrumb.html","<ol class=\"breadcrumb breadcrumb-admin breadcrumb-ocultable\" ng-show=\"steps.length\">\r\n    <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\">\r\n        <a ng-switch-when=\"false\" href=\"{{step.ncyBreadcrumbLink}}\" title=\"{{step.ncyBreadcrumbLabel | translate}}\">\r\n            {{step.ncyBreadcrumbLabel | translate}}</a>\r\n        <span ng-switch-when=\"true\">{{step.ncyBreadcrumbLabel | translate}}</span>\r\n    </li>\r\n</ol>\r\n");
$templateCache.put("app/components/configuracion/configuracion-form.admin.html","<form name=\"ctrl.form\" role=\"form\" class=\"configuracion-form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\" ng-repeat=\"configuracion in ctrl.configuraciones track by configuracion.clave\">\r\n            <div class=\"col-sm-6\">\r\n                <!--Valor-->\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"{{configuracion.claveMensaje}}\" for=\"config_{{$index}}\" required=\"configuracion.obligatorio\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"config_{{$index}}\" name=\"list[{{$index}}].valor\" ng-model=\"configuracion.valor\" ng-required=\"configuracion.obligatorio\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"submit\" class=\"btn btn-primary\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.save\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/changepassword/change-password.html","<div class=\"jumbotron jumbotron-thin\">\r\n<form name=\"ctrl.form\" ng-submit=\"ctrl.save()\" role=\"form\" autocomplete=\"off\" novalidate>\r\n\r\n    <div class=\"form-group\">\r\n        <label-form key=\"changepassword.oldpassword\" for=\"password\" required=\"true\"></label-form>\r\n        <input class=\"form-control\" id=\"password\" name=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.item.password\" required type=\"password\">\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label-form key=\"changepassword.newpassword\" for=\"newpassword\" required=\"true\"></label-form>\r\n        <input class=\"form-control\" id=\"newpassword\" name=\"newpassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.item.newpassword\" required type=\"password\">\r\n        <password-strength-bar password-to-check=\"ctrl.item.newpassword\"></password-strength-bar>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label-form key=\"changepassword.confirmpassword\" for=\"confirmPassword\" required=\"true\"></label-form>\r\n        <input class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.confirmPassword\" required type=\"password\" same-as=\"ctrl.item.newpassword\" same-as-err-type>\r\n    </div>\r\n\r\n    <!--Botones-->\r\n    <buttons can-save=\"true\" mode=\"\'edit\'\"></buttons>\r\n</form>\r\n</div>\r\n");
$templateCache.put("app/components/contacto/contacto.html","<section class=\"contacto\">\n    <h1 translate=\"contacto.titulo\"></h1>\n\n    <div class=\"row\">\n        <div class=\"col-sm-8\">\n            <div class=\"jumbotron jumbotron-thin\">\n                <div class=\"row\">\n                    <div class=\"info col-sm-offset-1\">\n                        <div class=\"col-sm-4\">\n                            <div class=\"info-item\">\n                                <img class=\"contacto-icon\" ng-src=\"assets/images/contacto/direccion.png\">\n                                <span id=\"dir\" ng-bind-html=\"\'contacto.info.direccion\' | translate\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"col-sm-3\">\n                            <div class=\"info-item\">\n                                <img class=\"contacto-icon\" ng-src=\"assets/images/contacto/telefono.png\">\n                                <span id=\"tlf\" translate=\"contacto.info.telefono\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"col-sm-5\">\n                            <div class=\"info-item\">\n                                <img class=\"contacto-icon\" ng-src=\"assets/images/contacto/mail.png\">\n                                <span id=\"mail\" translate=\"contacto.info.email\"></span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <contacto-form></contacto-form>\n\n            </div>\n        </div>\n\n        <div class=\"col-sm-4\">\n            <contacto-mapa lat=\"43.3623324\" lng=\"-8.421062\" titulo=\"{{\'contacto.info.direccionTexto\' | translate}}\" icono=\"\'/assets/images/mapa/marcador.png\'\"></contacto-mapa>\n        </div>\n    </div>\n</section>\n");
$templateCache.put("app/components/contactoform/contacto-form.html","<div class=\"contacto-form\">\r\n    <form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n        <div class=\"form-body\">\r\n            <!--Nombre-->\r\n            <div class=\"form-group\">\r\n                <label-form key=\"contacto.form.nombre\" for=\"nombre\"></label-form>\r\n                <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <!--Email-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"contacto.form.email\" for=\"email\"></label-form>\r\n                        <input class=\"form-control\" type=\"email\" id=\"email\" name=\"email\" ng-model=\"ctrl.item.email\" required>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-6\">\r\n                    <!--Teléfono-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"contacto.form.telefono\" for=\"telefono\"></label-form>\r\n                        <input class=\"form-control\" type=\"tel\" id=\"telefono\" name=\"telefono\" ng-model=\"ctrl.item.telefono\" required>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Propuesta-->\r\n            <div class=\"form-group\">\r\n                <label-form key=\"contacto.form.propuesta\" for=\"propuesta\"></label-form>\r\n                <textarea class=\"form-control\" id=\"propuesta\" name=\"propuesta\" ng-model=\"ctrl.item.propuesta\" rows=\"3\" required></textarea>\r\n            </div>\r\n\r\n            <!--Términos y condiciones-->\r\n            <span ng-bind-html=\"\'contacto.form.informacion\' | translate\"></span>\r\n            <div class=\"form-group no-error-label\">\r\n                <label class=\"noselect\">\r\n                    <input type=\"checkbox\" id=\"terminos\" ng-model=\"ctrl.terminos\" required>\r\n                    <span ng-bind-html=\"\'contacto.form.terminos\' | translate\"></span>\r\n                </label>\r\n            </div>\r\n            <div class=\"form-group no-error-label\">\r\n                <label class=\"noselect\">\r\n                    <input type=\"checkbox\" id=\"autorizacion\" ng-model=\"ctrl.item.autorizacion\">\r\n                    <span ng-bind-html=\"\'contacto.form.autorizacion\' | translate\"></span>\r\n                </label>\r\n            </div>\r\n\r\n            <captcha ng-if=\"ctrl.mostrarCaptcha\" on-success=\"ctrl.captchaSuccess({response: response})\"></captcha>\r\n        </div>\r\n\r\n        <button type=\"submit\" class=\"btn btn-primary\">\r\n            <span translate=\"contacto.form.send\"></span>\r\n        </button>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/components/contactomapa/contacto-mapa.html","<div class=\"contacto-mapa\">\r\n    <div id=\"mapa\"></div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/components/estaticas/estatica.html","<section class=\"{{ctrl.clase}}\">\r\n    <h1 ng-if=\"!ctrl.sinTitulo\">{{ctrl.estaticai18n.titulo}}</h1>\r\n\r\n    <div ng-bind-html=\"ctrl.estaticai18n.contenido | unsafe\"></div>\r\n</section>\r\n");
$templateCache.put("app/components/descargar/descargar.html","<a ng-click=\"ctrl.descargarArchivo()\" title=\"{{ctrl.titulo | translate}}\" ng-class=\"{\'btn btn-default\': ctrl.mostrarBoton}\" class=\"btn-descarga\">\r\n    <span ng-if=\"ctrl.archivo && ctrl.url\" class=\"icon {{ctrl.getClase()}}\"></span><span translate=\"{{ctrl.texto}}\"></span> <span class=\"size\" ng-if=\"ctrl.size\">({{ctrl.size | fileSize}})</span>\r\n</a>\r\n");
$templateCache.put("app/components/idiomas/idiomas.html","<div id=\"idiomas\" ng-if=\"ctrl.idiomas && ctrl.idiomas.length > 1\">\r\n\r\n    <span ng-repeat=\"idioma in ctrl.idiomas\" class=\"idioma\" ng-class=\"{\'seleccionado\': ctrl.lang === idioma.toLowerCase()}\">\r\n        <a ng-click=\"ctrl.changeLanguage(idioma)\" title=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\"><enumerado base=\"enum.idiomas-app.abrev\" value=\"{{idioma}}\"></enumerado></a>\r\n        <span class=\"separador\" ng-if=\"!$last\">|</span>\r\n    </span>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/loginadmin/login-admin.html","<div class=\"row\">\r\n    <div class=\"col-md-4 col-md-offset-4\">\r\n        <h1 translate=\"login.title\"></h1>\r\n\r\n        <form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n            <div class=\"form-group\">\r\n                <label-form key=\"login.form.username\" for=\"username\"></label-form>\r\n                <input class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"ctrl.username\" type=\"text\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label-form key=\"login.form.password\" for=\"password\"></label-form>\r\n                <input class=\"form-control\" id=\"password\" ng-model=\"ctrl.password\" type=\"password\">\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"rememberMe\">\r\n                    <input checked=\"true\" id=\"rememberMe\" ng-model=\"ctrl.rememberMe\" type=\"checkbox\">\r\n                    {{\'login.form.rememberme\' | translate}}</label>\r\n            </div>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"ctrl.login()\" translate=\"login.form.button\" type=\"submit\"></button>\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/menu/menu-item.html","<li ng-class=\"{divider: leaf.label == \'divider\'}\" ui-sref-active=\"active\" ng-click=\"onClick()\">\n\n    <a ng-if=\"leaf.label !== \'divider\' && !leaf.state && !leaf.link\">\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\n    </a>\n\n    <a ui-sref=\"{{leaf.state}}\" ng-if=\"leaf.state && leaf.label !== \'divider\'\">\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\n    </a>\n\n    <a href=\"{{leaf.link}}\" ng-if=\"leaf.link && leaf.label !== \'divider\'\" target=\"{{leaf.target}}\">\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\n    </a>\n</li>\n");
$templateCache.put("app/components/menu/menu.html","<script type=\"text/ng-template\" id=\"menuContent.html\">\n    <span class=\"{{leaf.icon}}\"></span>\n    <span>\n        <span translate>\n            {{leaf.label}}\n        </span>\n        <b ng-if=\"leaf.subtree\" class=\"caret\"></b>\n    </span>\n</script>\n\n<script type=\"text/ng-template\" id=\"menuItemContent.html\">\n    <span class=\"{{leaf.icon}}\"></span>\n    <span translate>\n        {{leaf.label}}\n    </span>\n</script>\n\n<script type=\"text/ng-template\" id=\"menuElementsContent.html\">\n    <ul ng-class=\"!ctrl.lateral ? \'nav navbar-nav navbar-right\' : \'list-group\'\" class=\"menu\">\n        <li\n            uib-dropdown\n            ui-sref-active=\"active\"\n            ng-repeat=\"leaf in ctrl.menu\"\n            ng-class=\"{\'divider-vertical\': leaf.label == \'divider\',\n                \'active\': leaf.actives && ctrl.checkActiveStates(leaf.actives),\n                \'list-group-item\' : ctrl.lateral,\n                \'{{leaf.class}}\' : true}\"\n            has-any-authority-or-state\n            authorities=\"leaf.authorities\"\n            states=\"leaf.states\">\n\n            <a ng-if=\"leaf.componente\" compile=\"leaf.componente\"></a>\n\n            <!--Ventana modal-->\n            <a ng-if=\"leaf.modal\" ng-click=\"ctrl.modal(leaf.modal)\">\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\n            </a>\n\n            <!--Dropdown-->\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.subtree && !leaf.link && !leaf.modal\"\n               uib-dropdown-toggle>\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\n            </a>\n\n            <!--Estado-->\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.state && !leaf.subtree\"\n               ui-sref=\"{{leaf.state}}\" ng-click=\"ctrl.collapse()\">\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\n            </a>\n\n            <!--Enlace-->\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.link && !leaf.subtree\"\n               href=\"{{leaf.link}}\" ng-click=\"ctrl.collapse()\" target=\"{{leaf.target}}\">\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\n            </a>\n\n            <submenu ng-if=\"leaf.subtree\" menu=\"leaf.subtree\" on-click=\"ctrl.collapse()\"></submenu>\n        </li>\n    </ul>\n</script>\n\n<nav class=\"navbar\" role=\"navigation\" ng-class=\"$root.isAdmin ? \'navbar-default\' : \'navbar-inverse\'\" ng-if=\"!ctrl.lateral\">\n    <div class=\"container\">\n        <div class=\"navbar-header\">\n            <a ui-sref=\"home\">\n                <img class=\"logo-movil\" src=\"assets/images/logo_img_movil.png\" ng-show=\"!$root.isAdmin\">\n            </a>\n            <button type=\"button\" class=\"navbar-toggle\" ng-click=\"ctrl.collapse()\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n\n            <a ng-if=\"$root.isAdmin\" class=\"navbar-brand\">\n                <span translate=\"admin.title\"></span>\n            </a>\n        </div>\n        <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"ctrl.navCollapsed\">\n            <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\n        </div>\n    </div>\n</nav>\n\n<div ng-if=\"ctrl.lateral\">\n    <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\n</div>\n");
$templateCache.put("app/components/menu/submenu.html","<ul class=\"dropdown-menu\">\n    <menu-item ng-repeat=\"leaf in menu\" leaf=\"leaf\" on-click=\"onClick()\">\n    </menu-item>\n</ul>\n");
$templateCache.put("app/components/modal/entity.modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{ctrl.resolve.title}}\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <div compile=\"ctrl.resolve.component\"></div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/pagination/pagination.html","<div class=\"separador\" ng-if=\"ctrl.itemsPerPage < ctrl.totalElements && ctrl.separador\"></div>\r\n\r\n<ul uib-pagination max-size=\"10\" total-items=\"ctrl.totalElements\" ng-model=\"ctrl.currentPage\" ng-change=\"ctrl.pageChanged()\" items-per-page=\"ctrl.itemsPerPage\" boundary-link-numbers=\"true\" next-text=\"»\" previous-text=\"«\" ng-if=\"ctrl.itemsPerPage < ctrl.totalElements\"></ul>\r\n");
$templateCache.put("app/components/ordenable/ordenable.html","<a class=\"button fa fa-caret-up\" ng-click=\"ctrl.subir(element)\" title=\"{{\'ordenable.subir\' | translate}}\"></a>\r\n\r\n<a type=\"button\" class=\"button fa fa-caret-down\" ng-click=\"ctrl.bajar(element)\" title=\"{{\'ordenable.bajar\' | translate}}\"></a>\r\n");
$templateCache.put("app/components/socialshare/social-share.html","<div class=\"share\" ng-class=\"{\'mini\': ctrl.mini}\">\n    <div class=\"redes\">\n\n        <!--Facebook-->\n        <div class=\"red\" ng-if=\"ctrl.facebook\">\n            <a title=\"Facebook\" ng-click=\"ctrl.compartirEnFacebook()\">\n                <span class=\"fa fa-facebook-official\"></span>\n                <span ng-if=\"ctrl.textos\">Facebook</span>\n            </a>\n        </div>\n\n        <!--Twitter-->\n        <div class=\"red\" ng-if=\"ctrl.twitter\">\n            <a title=\"Twitter\" socialshare socialshare-provider=\"twitter\" socialshare-text=\"{{ctrl.tweet}}\" socialshare-hashtags=\"{{ctrl.twHashtags}}\" socialshare-via=\"{{ctrl.twVia}}\" socialshare-url=\"{{ctrl.fullUrl}}\">\n                <span class=\"fa fa-twitter\"></span>\n                <span ng-if=\"ctrl.textos\">Twitter</span>\n            </a>\n        </div>\n\n    </div>\n</div>\n");
$templateCache.put("app/components/socialwidget/social-widget.html","<section class=\"feed\">\r\n    <div class=\"tweets-wrapper\" ng-if=\"ctrl.cookiesAccepted\">\r\n        <div id=\"tweets\"></div>\r\n    </div>\r\n    <div class=\"fb-page-wrapper\" ng-if=\"ctrl.cookiesAccepted\">\r\n        <div class=\"fb-page\" data-href=\"https://www.facebook.com/asociacion.galega\" data-tabs=\"timeline\" data-width=\"\" data-height=\"327\" data-small-header=\"true\" data-adapt-container-width=\"true\" data-hide-cover=\"true\" data-show-facepile=\"false\">\r\n        </div>\r\n    </div>\r\n</section>\r\n");
$templateCache.put("app/public/asociarse/asociarse.html","<section class=\"asociarse\">\r\n    <h1 translate=\"asociarse.titulo\"></h1>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-4\">\r\n            <estatica id=\"asociarse\" bd=\"true\" sin-titulo=\"true\"></estatica>\r\n        </div>\r\n\r\n        <div class=\"col-sm-8\">\r\n            <div class=\"jumbotron jumbotron-thin\">\r\n                <asociarse-form></asociarse-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>\r\n");
$templateCache.put("app/public/home/home.html","<div id=\"inicio\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-9\">\r\n\r\n            <!--Actualidad-->\r\n            <div id=\"actualidad\">\r\n                <h1 translate=\"inicio.actualidad\"></h1>\r\n                <actualidad categoria-rss-id=\"4\"></actualidad>\r\n            </div>\r\n\r\n            <div class=\"separador\"></div>\r\n\r\n            <!--Enlaces-->\r\n            <div class=\"row enlaces\">\r\n                <div class=\"col-sm-4\">\r\n                    <a class=\"enlace-icon\" ui-sref=\"actividad\" title=\"{{\'inicio.actividades\' | translate}}\">\r\n                        <img ng-src=\"assets/images/inicio/actividades.jpg\">\r\n                    </a>\r\n\r\n                </div>\r\n                <div class=\"col-sm-4\">\r\n                    <a class=\"enlace-icon\" href=\"http://www.as-pg.gal/Podcast\" target=\"_blank\" title=\"{{\'inicio.multimedia\' | translate}}\">\r\n                        <img ng-src=\"assets/images/inicio/multimedia.jpg\">\r\n                    </a>\r\n                </div>\r\n                <div class=\"col-sm-4\">\r\n                    <a class=\"enlace-icon\" ui-sref=\"enXogo\" title=\"{{\'inicio.enxogo\' | translate}}\">\r\n                        <img ng-src=\"assets/images/inicio/en_xogo.png\">\r\n                    </a>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Feeds RSS-->\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <rss categoria-id=\"1\" imagen=\"assets/images/inicio/icono-bitaculas.png\"></rss>\r\n                </div>\r\n                <div class=\"col-sm-4\">\r\n                    <rss categoria-id=\"2\" imagen=\"assets/images/inicio/icono-espazo-web.png\"></rss>\r\n                </div>\r\n                <div class=\"col-sm-4\">\r\n                    <rss categoria-id=\"3\" imagen=\"assets/images/inicio/icono-eventos.png\"></rss>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-sm-3\">\r\n            <div id=\"tenda\">\r\n                <h1 translate=\"inicio.infotienda.titulo\"></h1>\r\n                <info-tienda></info-tienda>\r\n            </div>\r\n\r\n            <div class=\"hlt\">\r\n                <h1 translate=\"inicio.hlt.tituloseccion\"></h1>\r\n                <div class=\"thumbnail full thumb-transparent\">\r\n                    <a href=\"http://literaturagalega.as-pg.gal\" target=\"_blank\">\r\n                        <img class=\"ajustada\" src=\"assets/images/historia-da-literatura-galega.jpg\">\r\n                    </a>\r\n                    <div class=\"caption full\">\r\n                        <a href=\"http://literaturagalega.as-pg.gal\" target=\"_blank\">\r\n                            <h5 translate=\"inicio.hlt.titulo\"></h5>\r\n                        </a>\r\n                        <div class=\"info\" translate=\"inicio.hlt.info\"></div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <cursos></cursos>\r\n\r\n            <social-widget></social-widget>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/header/header.html","<div class=\"container\">\n\n    <a ui-sref=\"home\">\n        <img ng-src=\"assets/images/logo_img.png\">\n    </a>\n\n</div>\n");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"error.accessdenied.content\">Acceso denegado</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"error.error.content\">Se ha producido un error</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/footer/footer.admin.html","<div class=\"container\">\r\n    <!--Empty footer-->\r\n</div>\r\n");
$templateCache.put("app/layouts/footer/footer.html","<div class=\"footer\">\r\n    <div class=\"container\">\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-3\">\r\n                <div class=\"footer-logo\">\r\n                    <a ui-sref=\"home\">\r\n                        <img ng-src=\"assets/images/footer/logo-footer.png\">\r\n                    </a>\r\n                </div>\r\n                <div class=\"footer-text\">\r\n                    <img class=\"footer-icon\" ng-src=\"assets/images/footer/direccion-footer.png\">\r\n                    <span ng-bind-html=\"\'contacto.info.direccionTexto\' | translate\"></span>\r\n                </div>\r\n\r\n                <div class=\"footer-text\">\r\n                    <img class=\"footer-icon\" ng-src=\"assets/images/footer/telefono-footer.png\">\r\n                    {{\'contacto.info.telefono\' | translate}}\r\n                </div>\r\n\r\n                <div class=\"footer-text\">\r\n                    <img class=\"footer-icon\" ng-src=\"assets/images/footer/correo-footer.png\">\r\n                    <span ng-bind-html=\"\'contacto.info.email\' | translate\"></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-3 footer-columna\">\r\n                <a ui-sref=\"privacidad\" translate=\"footer.privacidad\"></a><br>\r\n                <a ui-sref=\"cookies\" translate=\"footer.cookies\"></a>\r\n            </div>\r\n\r\n            <div class=\"col-sm-3 footer-columna\">\r\n                <a href=\"http://tenda.as-pg.gal/\" target=\"_blank\" translate=\"footer.tenda\"></a><br>\r\n                <a href=\"http://literaturagalega.as-pg.gal/\" target=\"_blank\" translate=\"footer.enciclopedia\"></a><br>\r\n                <a ui-sref=\"enXogo\" target=\"_blank\" translate=\"footer.enxogo\"></a><br>\r\n                <a href=\"http://www.as-pg.gal/Xestion/Welcome.do\" target=\"_blank\" translate=\"footer.formacion\"></a>\r\n            </div>\r\n\r\n            <div class=\"col-sm-3 footer-columna\">\r\n                <a href=\"http://bitaculas.as-pg.gal/\" target=\"_blank\" translate=\"footer.bitaculas\"></a><br>\r\n                <a href=\"http://espazoweb.as-pg.gal/\" target=\"_blank\" translate=\"footer.espacios\"></a><br>\r\n                <a href=\"http://www.as-pg.gal/Podcast/\" target=\"_blank\" translate=\"footer.multimedia\"></a>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"patrocinadores\">\r\n            <div class=\"logos-patrocinadores\">\r\n                <div class=\"logo-patrocinador\">\r\n                    <a href=\"https://www.dacoruna.gal/\" target=\"_blank\">\r\n                        <img ng-src=\"assets/images/footer/logo_depucoruna.png\">\r\n                    </a>\r\n                </div>\r\n                <div class=\"logo-patrocinador\">\r\n                    <a href=\"https://deputacionlugo.gal/\" target=\"_blank\">\r\n                        <img ng-src=\"assets/images/footer/logo_deplugo.png\">\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/admin/user/admin/admin-form.admin.html","<div class=\"row\">\n    <div class=\"col-md-8 col-md-offset-2\">\n        <form name=\"ctrl.form\" ng-submit=\"ctrl.save()\" role=\"form\" autocomplete=\"off\" novalidate>\n\n            <div class=\"form-group\" ng-if=\"false\">\n                <label-form key=\"admin.admin.form.email\" for=\"email\"></label-form>\n                <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" ng-model=\"ctrl.item.email\" ng-disabled=\"ctrl.mode===\'edit\'\">\n            </div>\n\n            <div class=\"form-group\">\n                <label-form key=\"admin.admin.form.username\" for=\"login\" required=\"true\"></label-form>\n                <input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.item.login\" ng-disabled=\"ctrl.mode===\'edit\'\" ng-pattern=\"/^[a-z0-9]*$/\" ng-pattern-err-type=\"patternLogin\" required>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"ctrl.mode===\'create\'\">\n                <label-form key=\"admin.admin.form.password\" for=\"password\" required=\"true\"></label-form>\n                <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.item.password\" required>\n                <password-strength-bar password-to-check=\"ctrl.item.password\"></password-strength-bar>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"ctrl.mode===\'create\'\">\n                <label-form key=\"admin.admin.form.confirmpassword\" for=\"confirmPassword\" required=\"true\"></label-form>\n                <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" same-as=\"ctrl.item.password\" same-as-err-type ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"ctrl.confirmPassword\" required>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"false\">\n                <enum-select id=\"rol\" model=\"ctrl.item.rol\" label=\"admin.admin.form.rol\" base=\"enum.rol\" options=\"ctrl.roles\" required=\"true\"></enum-select>\n            </div>\n\n            <!--Botones-->\n            <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\n        </form>\n    </div>\n</div>\n\n");
$templateCache.put("app/admin/user/admin/admin-list.admin.html","<div class=\"btn-ctrl\">\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/admin/create\">\n        <span translate=\"global.menu.register\"></span>\n    </a>\n</div>\n\n<div class=\"total-elementos\">\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\n</div>\n<div class=\"table-responsive\">\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped\">\n        <tr ng-repeat=\"usuario in $data track by usuario.id\">\n            <td data-title=\"\'admin.admin.form.login\' | translate\" sortable=\"\'login\'\">\n                <!--<a ui-sref=\"admin/admin/edit({id: usuario.id})\">{{usuario.login}}</a>-->\n                {{usuario.login}}\n            </td>\n\n            <td class=\"col-md-2 text-center\" data-title=\"\'admin.admin.form.rol\' | translate\" sortable=\"\'rol\'\" ng-if=\"false\">\n                <enumerado base=\"enum.rol\" value=\"{{usuario.rol}}\"></enumerado>\n            </td>\n\n            <td class=\"col-md-2 text-center\" data-title=\"\'admin.admin.form.fecharegistro\' | translate\" sortable=\"\'fechaRegistro\'\">\n                <date model=\"usuario.fechaRegistro\"></date>\n            </td>\n\n            <td class=\"col-md-1 text-center button-icons\">\n                <a ng-click=\"ctrl.showRemoveConfirmation(usuario)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\n            </td>\n        </tr>\n    </table>\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\n</div>\n");
$templateCache.put("app/components/auladigital/admin/aula-digital-breadcrumb.admin.html","<!--Breadcrumb para el aula digital con todos los niveles-->\r\n<ol class=\"breadcrumb breadcrumb-admin aula-digital-breadcrumb\">\r\n    <!--Definimos un boolean para saber si el estado es de listado o de creación/edición-->\r\n    {{ctrl.list = $resolve.breadcrumb.getLastStep().name.endsWith(\'list\'); \"\" }}\r\n\r\n    <!--Raíz (lista de nivel educativo)-->\r\n    <li>\r\n        <a ui-sref=\"admin/aulaDigital/nivelEducativo\" translate=\"aulaDigital.nivelEducativo.admin.titulo\" ng-if=\"!ctrl.list || $resolve.nivelEducativo\"></a>\r\n        <span ng-if=\"ctrl.list && !$resolve.nivelEducativo\" class=\"active\" translate=\"aulaDigital.nivelEducativo.admin.titulo\"></span>\r\n    </li>\r\n\r\n    <!--Nivel educativo (lista de materias)-->\r\n    <li ng-if=\"$resolve.nivelEducativo\">\r\n        <a ui-sref=\"admin/aulaDigital/materia({nivelid: $resolve.nivelEducativo.id})\" ng-if=\"!ctrl.list || $resolve.materia\" title=\"{{\'aulaDigital.nivelEducativo.verMaterias\' | translate}}\">\r\n            {{$resolve.nivelEducativo.nombre}}\r\n        </a>\r\n        <span ng-if=\"ctrl.list && !$resolve.materia\" class=\"active\">\r\n            {{$resolve.nivelEducativo.nombre}}\r\n        </span>\r\n    </li>\r\n\r\n    <!--Materia (lista de temas)-->\r\n    <li ng-if=\"$resolve.materia\">\r\n        <a ui-sref=\"admin/aulaDigital/tema({nivelid: $resolve.nivelEducativo.id, materiaid: $resolve.materia.id})\" ng-if=\"!ctrl.list || $resolve.tema\" title=\"{{\'aulaDigital.materia.verTemas\' | translate}}\">\r\n            {{$resolve.materia.nombre}}\r\n        </a>\r\n        <span ng-if=\"ctrl.list && !$resolve.tema\" class=\"active\">\r\n            {{$resolve.materia.nombre}}\r\n        </span>\r\n    </li>\r\n\r\n    <!--Tema (lista de recursos)-->\r\n    <li ng-if=\"$resolve.tema\">\r\n        <a ui-sref=\"admin/aulaDigital/recursoEducativo({nivelid: $resolve.nivelEducativo.id, materiaid: $resolve.materia.id, temaid: $resolve.tema.id})\" ng-if=\"!ctrl.list\" title=\"{{\'aulaDigital.tema.verRecursos\' | translate}}\">\r\n            {{$resolve.tema.titulo}}\r\n        </a>\r\n        <span ng-if=\"ctrl.list\" class=\"active\">\r\n            {{$resolve.tema.titulo}}\r\n        </span>\r\n    </li>\r\n\r\n    <!--Creación/edición (se delega en $breadcrumb)-->\r\n    <li ng-if=\"!ctrl.list\" class=\"active\">\r\n        {{$resolve.breadcrumb.getLastStep().ncyBreadcrumbLabel | translate}}\r\n    </li>\r\n</ol>\r\n");
$templateCache.put("app/components/auladigital/public/aula-digital-template.public.html","<div class=\"aula-digital\">\r\n    <h1 class=\"thin\" translate=\"aulaDigital.titulo\"></h1>\r\n    <div class=\"menu-horizontal row\">\r\n        <nav class=\"principal col-md-10\">\r\n            <div class=\"entrada-menu nivel\" ng-repeat=\"nivel in $resolve.nivelesEducativos track by nivel.id\">\r\n                <a ui-sref=\"aulaDigital/temasByMateria({nivelUrl: nivel.url, materiaUrl: null})\" ng-class=\"{\'active\': $resolve.nivelUrl == nivel.url}\">{{nivel.nombre}}</a>\r\n            </div>\r\n        </nav>\r\n\r\n        <nav class=\"secundario col-md-10\">\r\n            <div class=\"entrada-menu\" ng-repeat=\"materia in $resolve.materias track by materia.id\">\r\n                <a ui-sref=\"aulaDigital/temasByMateria({materiaUrl: materia.url})\" ui-sref-active=\"active\">{{materia.nombre}}</a>\r\n                <span class=\"separador-menu\" ng-if=\"!$last\">|</span>\r\n            </div>\r\n            <div class=\"empty\" ng-if=\"!$resolve.materias.length\" translate=\"aulaDigital.sinMaterias\"></div>\r\n        </nav>\r\n    </div>\r\n\r\n    <div ui-view=\"contentAula\" ng-if=\"$resolve.materias.length\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/public/nivel-educativo-list.public.html","<div class=\"bloques niveles-educativos\">\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-4\" ng-repeat=\"nivel in ctrl.niveles track by nivel.id\">\r\n            <div class=\"bloque nivel-educativo nivel_{{$index}}\">\r\n                <a ui-sref=\"aulaDigital/materiasByNivel({nivelUrl: nivel.url})\">\r\n                    <img ng-src=\"assets/images/static/auladigital/{{nivel.url}}.jpg\">\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/public/tema-list.public.html","<div class=\"tarjetas temas\" ng-if=\"ctrl.temas.length\">\n    <div class=\"tarjeta tema row\" ng-repeat=\"tema in ctrl.temas track by tema.id\">\n        <div class=\"pull-left\">\n            <img src=\"assets/images/auladigital/recursos_digitales.png\">\n        </div>\n        <div class=\"col-md-11 texto\">\n            <div class=\"titulo\">\n            <span>\n                {{tema.titulo}}\n            </span>\n            </div>\n\n            <div class=\"info\">\n                <div class=\"autoria\" ng-if=\"tema.autoria\">\n                    <label-form key=\"aulaDigital.tema.field.autoria\" puntos=\"true\"></label-form>\n                    {{tema.autoria}}\n                </div>\n\n                <div ng-bind-html=\"tema.descripcion\"></div>\n            </div>\n\n            <!--Lista de recursos-->\n            <div class=\"row same-height recursos\" ng-if=\"tema.recursos.length\">\n                <div class=\"recurso col-sm-6\" ng-repeat=\"recurso in tema.recursos track by recurso.id\">\n                    <div class=\"titulo\">\n                        <descargar ng-if=\"recurso.archivoPath\" archivo=\"recurso.archivoPath\" url=\"{{ctrl.urlBaseArchivo + recurso.id + \'/\'}}\" texto=\"{{recurso.titulo}}\" size=\"recurso.archivoSize\">{{recurso.titulo}}\n                        </descargar>\n                        <span ng-if=\"!recurso.archivoPath\">{{recurso.titulo}}</span>\n                    </div>\n                    <div class=\"info\">\n                        <div ng-if=\"recurso.autoria\">\n                            <label-form key=\"aulaDigital.tema.field.autoria\" puntos=\"true\"></label-form>\n                            {{recurso.autoria}}\n                        </div>\n                        <div ng-if=\"recurso.url\">\n                            <a href=\"{{recurso.url}}\" target=\"_blank\">{{recurso.url}}</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"empty\" ng-if=\"!ctrl.temas.length\" translate=\"aulaDigital.sinTemas\"></div>\n");
$templateCache.put("app/components/aspg/actualidad/actualidad.html","<div class=\"contenido\">\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\n\n    <div class=\"row\">\n        <div class=\"col-sm-4\" ng-repeat=\"rss in ctrl.entradas\">\n            <div class=\"thumbnail full thumb-transparent\">\n                <a href=\"{{rss.url}}\" target=\"_blank\">\n                    <img class=\"ajustada\" ng-src=\"{{rss.imagenUrl}}\">\n                </a>\n                <div class=\"caption full\">\n                    <a href=\"{{rss.url}}\" target=\"_blank\">\n                        <h5 ng-bind-html=\"rss.titulo\"></h5>\n                    </a>\n                    <div class=\"info\" ng-bind-html=\"rss.descripcion\" ellipsis=\"3\"></div>\n                    <a class=\"btn btn-primary leer-mas\" href=\"{{rss.url}}\" target=\"_blank\" translate=\"inicio.leer\"></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/aspg/headermenu/header-menu.html","<header>\n    <a ui-sref=\"home\">\n        <img ng-src=\"assets/images/logo_img.png\">\n    </a>\n</header>\n");
$templateCache.put("app/components/aspg/asociarseform/asociarse-form.html","<div class=\"asociarse-form\">\r\n    <form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n        <div class=\"form-body\">\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <!--Nombre-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.nombre\" for=\"nombre\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-8\">\r\n                    <!--Apellidos-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.apellidos\" for=\"apellidos\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"apellidos\" name=\"apellidos\" ng-model=\"ctrl.item.apellidos\" required>\r\n                    </div>\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <!--NIF-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.nif\" for=\"nif\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"nif\" name=\"nif\" ng-model=\"ctrl.item.nif\" required ng-pattern=\"/^[a-zA-Z0-9]{1}\\d{7}[a-zA-Z]{1}$/\" ng-pattern-err-type=\"patternNif\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Teléfono-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.telefono\" for=\"telefono\"></label-form>\r\n                        <input class=\"form-control\" type=\"tel\" id=\"telefono\" name=\"telefono\" ng-model=\"ctrl.item.telefono\" required>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Email-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.email\" for=\"email\"></label-form>\r\n                        <input class=\"form-control\" type=\"email\" id=\"email\" name=\"email\" ng-model=\"ctrl.item.email\" required>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <!--Dirección-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.direccion\" for=\"direccion\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"direccion\" name=\"direccion\" ng-model=\"ctrl.item.direccion\" required>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Población-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.poblacion\" for=\"poblacion\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"poblacion\" name=\"poblacion\" ng-model=\"ctrl.item.poblacion\" required>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Provincia-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.provincia\" for=\"provincia\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"provincia\" name=\"provincia\" ng-model=\"ctrl.item.provincia\" required>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <!--Titulación-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.titulacion\" for=\"titulacion\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"titulacion\" name=\"titulacion\" ng-model=\"ctrl.item.titulacion\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Especialidad-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.especialidad\" for=\"especialidad\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"especialidad\" name=\"especialidad\" ng-model=\"ctrl.item.especialidad\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4\">\r\n                    <!--Centro-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.centro\" for=\"centro\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"centro\" name=\"centro\" ng-model=\"ctrl.item.centro\" ng-required=\"ctrl.item.situacion == (\'asociarse.form.situacion.activo\' | translate)\r\n                               || ctrl.item.situacion == (\'asociarse.form.situacion.estudiante\' | translate)\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-4\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.situacion.titulo\"></label-form>\r\n                        <div>\r\n                            <radio model=\"ctrl.item.situacion\" value=\"\'asociarse.form.situacion.activo\' | translate\" label=\"asociarse.form.situacion.activo\"></radio>\r\n                        </div>\r\n                        <div>\r\n                            <radio model=\"ctrl.item.situacion\" value=\"\'asociarse.form.situacion.estudiante\' | translate\" label=\"asociarse.form.situacion.estudiante\"></radio>\r\n                        </div>\r\n                        <div>\r\n                            <radio model=\"ctrl.item.situacion\" value=\"\'asociarse.form.situacion.parado\' | translate\" label=\"asociarse.form.situacion.parado\"></radio>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-8\">\r\n                    <!--Banco-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.banco\" for=\"banco\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"banco\" name=\"banco\" ng-model=\"ctrl.item.banco\" required>\r\n                    </div>\r\n\r\n                    <!--Titular-->\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"asociarse.form.titular\" for=\"titular\"></label-form>\r\n                        <input class=\"form-control\" type=\"text\" id=\"titular\" name=\"titular\" ng-model=\"ctrl.item.titular\" required>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Cuenta-->\r\n            <div class=\"form-group\">\r\n                <label-form key=\"asociarse.form.cuenta\" for=\"cuenta\" tooltip=\"asociarse.form.cuentatooltip\"></label-form>\r\n                <input class=\"form-control\" type=\"text\" id=\"cuenta\" name=\"cuenta\" ng-maxlength=\"29\" ng-model=\"ctrl.item.cuenta\" ng-pattern=\"/[a-zA-Z]{2}\\d{2} ?\\d{4} ?\\d{4} ?\\d{4} ?\\d{4} ?[\\d]{0,4}/\" ng-pattern-err-type=\"patternIban\" required>\r\n            </div>\r\n\r\n            <p translate=\"asociarse.form.pagamentoInfo\"></p>\r\n\r\n            <!--Observacines-->\r\n            <div class=\"form-group\">\r\n                <label-form key=\"asociarse.form.observaciones\" for=\"observaciones\"></label-form>\r\n                <textarea class=\"form-control\" id=\"observaciones\" name=\"observaciones\" rows=\"4\" ng-model=\"ctrl.item.observaciones\"></textarea>\r\n            </div>\r\n\r\n            <!--Términos y condiciones-->\r\n            <span ng-bind-html=\"\'asociarse.form.informacion\' | translate\"></span>\r\n            <div class=\"form-group no-error-label\">\r\n                <label class=\"noselect\">\r\n                    <input type=\"checkbox\" id=\"terminos\" ng-model=\"ctrl.terminos\" required>\r\n                    <span ng-bind-html=\"\'asociarse.form.terminos\' | translate\"></span>\r\n                </label>\r\n            </div>\r\n            <div class=\"form-group no-error-label\">\r\n                <label class=\"noselect\">\r\n                    <input type=\"checkbox\" id=\"autorizacion\" ng-model=\"ctrl.item.autorizacion\">\r\n                    <span ng-bind-html=\"\'asociarse.form.autorizacion\' | translate\"></span>\r\n                </label>\r\n            </div>\r\n\r\n            <captcha ng-if=\"ctrl.mostrarCaptcha\" on-success=\"ctrl.captchaSuccess({response: response})\"></captcha>\r\n        </div>\r\n\r\n        <button type=\"submit\" class=\"btn btn-primary\">\r\n            <span translate=\"asociarse.form.enviar\"></span>\r\n        </button>\r\n\r\n        <button type=\"reset\" class=\"btn btn-secondary\" ng-click=\"ctrl.init()\">\r\n            <span translate=\"asociarse.form.borrar\"></span>\r\n        </button>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/cursos/cursos.html","<div ng-if=\"ctrl.cursos.length > 0\">\r\n    <h1 translate=\"inicio.formacion.titulo\"></h1>\r\n    <div ng-repeat=\"curso in ctrl.cursos | limitTo:5\">\r\n        <a href=\"{{curso.url}}\" target=\"_blank\">{{curso.denominacion}}</a>\r\n        <p>\r\n            <span translate=\"inicio.formacion.desde\"></span> {{curso.dataInicio | date:\'dd/MM/yyyy\'}} <span translate=\"inicio.formacion.hasta\"></span> {{curso.dataFin | date:\'dd/MM/yyyy\'}}\r\n            <br>\r\n            {{curso.lugar}}\r\n        </p>\r\n    </div>\r\n</div>\r\n<div class=\"text-center\">\r\n<a href=\"http://www.as-pg.gal/Xestion/Curso/EncontrarCursos.do?identifierType=DATA_ID&dateType=AFTER&startIndex=1&count=10\" target=\"_blank\" ng-show=\"ctrl.cursos.length > 5\">\r\n    + Máis\r\n</a>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/enxogo/en-xogo.template.html","<div class=\"enxogo\">\r\n    <h1 class=\"thin\" translate=\"enXogo.titulo\"></h1>\r\n    <div class=\"row\">\r\n        <div class=\"menu-horizontal col-md-6\">\r\n            <nav class=\"secundario\">\r\n                <div class=\"entrada-menu\">\r\n                    <a ui-sref=\"enXogo/xogos\" ui-sref-active=\"active\" translate=\"enXogo.menu.home\"></a>\r\n                </div>\r\n                <div class=\"separador\"></div>\r\n                <div class=\"entrada-menu\">\r\n                    <a ui-sref=\"enXogo/perfil\" ui-sref-active=\"active\" translate=\"enXogo.menu.perfil\"></a>\r\n                </div>\r\n                <div class=\"separador\"></div>\r\n                <div class=\"entrada-menu\">\r\n                    <a ui-sref=\"enXogo/salir\" translate=\"enXogo.menu.salir\"></a>\r\n                </div>\r\n            </nav>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n            <h5 class=\"pull-right saludo\"><span translate=\"enXogo.menu.saludo\"></span>&nbsp;<a ui-sref=\"enXogo/perfil\">{{$resolve.nombre}}</a></h5>\r\n        </div>\r\n    </div>\r\n    <div ui-view=\"contentXogos\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/enxogo/xogos.html","<div class=\"xogos\">\r\n    <div class=\"col-md-8 col-md-offset-2\">\r\n        <div class=\"col-md-6\" ng-repeat=\"(nombre, xogo) in ctrl.xogos track by nombre\">\r\n            <div class=\"xogo thumbnail full\">\r\n                <form action=\"{{xogo.url | trustUrl}}\" target=\"_blank\">\r\n                    <input class=\"imagen btn-link\" ng-style=\"{\'background-image\': \'url(/assets/images/static/managerlogin/\' + nombre + \'_public.png)\'}\" type=\"submit\">\r\n                    <input value=\"{{xogo.password}}\" name=\"password\" type=\"hidden\">\r\n                    <input value=\"true\" name=\"encrypted\" type=\"hidden\">\r\n\r\n                    <input value=\"{{xogo.login}}\" name=\"loginName\" type=\"hidden\" ng-if=\"nombre != \'categorizando\'\">\r\n                    <input value=\"{{xogo.login}}\" name=\"login\" type=\"hidden\" ng-if=\"nombre == \'categorizando\'\">\r\n\r\n                    <div class=\"caption\">\r\n                        <div class=\"pie text-center\">\r\n                            {{\'managerLogin.tipo.\' + nombre | translate}}\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/infotienda/info-tienda.html","<!--Link a la tienda cuando no hay ofertas ni promoción general-->\n<div class=\"thumbnail thumb-transparent full no-oferta-promocion\" ng-if=\"ctrl.destacados.length === 0\">\n    <a href=\"http://tenda.as-pg.gal/\" target=\"_blank\">\n        <img class=\"\" src=\"assets/images/tenda-aspg.jpg\">\n    </a>\n    <div class=\"caption full\">\n        <a href=\"http://tenda.as-pg.gal/\" target=\"_blank\">\n            <h5 translate=\"inicio.infotienda.titulo\"></h5>\n        </a>\n        <div class=\"info\" translate=\"inicio.infotienda.subtitulo\">\n        </div>\n    </div>\n</div>\n\n<div class=\"thumbnail thumb-transparent full\" ng-if=\"ctrl.promocion !== undefined && ctrl.promocion !== null\">\n    <a href=\"http://tenda.as-pg.gal/\">\n        <img class=\"\" src=\"assets/images/tenda-aspg.jpg\">\n    </a>\n    <div class=\"caption full promocion\">\n        <a href=\"http://tenda.as-pg.gal/\">\n            <div class=\"titulo\" translate=\"inicio.infotienda.promocion.titulo\" translate-values=\"{porcentaje: ctrl.promocion.porcentaxe_desconto}\">\n            </div>\n        </a>\n        <span translate=\"inicio.infotienda.promocion.subtitulo.rapido\"></span>\n        <span ng-show=\"ctrl.diasPromocion > 0\">\n        <span translate=\"inicio.infotienda.promocion.subtitulo.dias\" translate-values=\"{dias: ctrl.diasPromocion}\" ng-show=\"ctrl.diasPromocion >= 2\"></span>\n        <span translate=\"inicio.infotienda.promocion.subtitulo.mañana\" ng-show=\"ctrl.diasPromocion === 1\"></span>\n        </span>\n        <span ng-show=\"ctrl.diasPromocion === 0\" translate=\"inicio.infotienda.promocion.subtitulo.hoy\"></span>\n    </div>\n</div>\n\n<!--Carrusel de ofertas-->\n<div uib-carousel interval=\"5000\" active=\"active\" ng-if=\"ctrl.destacados.length > 0\">\n    <div uib-slide ng-repeat=\"destacado in ctrl.destacados\" index=\"$index\">\n        <div class=\"thumbnail thumb-transparent\">\n            <!--Portada-->\n            <a href=\"{{destacado.url}}\" target=\"_blank\">\n                <div class=\"contenedor-portada\">\n                    <div class=\"portada\">\n                        <img ng-src=\"{{destacado.portada}}\">\n                    </div>\n                </div>\n            </a>\n            <!--Detalles-->\n            <div class=\"caption text-center\">\n                <a href=\"{{destacado.url}}\" target=\"_blank\">\n                    <h5>\n                        {{destacado.titulo}}\n                    </h5>\n                </a>\n                <div class=\"info\">\n                    <p class=\"autor\">\n                        {{destacado.apellidosAutor}}<span ng-show=\"destacado.apellidosAutor\">, </span>{{destacado.nombreAutor}}\n                    </p>\n                    <a href=\"{{destacado.url}}\" target=\"_blank\" class=\"btn btn-primary\">\n                        {{destacado.precio | currency}}\n                    </a>\n                    <p></p>\n                    <span ng-if=\"!destacado.pack\">\n                        <span translate=\"inicio.infotienda.antes\"></span> {{destacado.precioAnterior | currency }}\n                    </span>\n                    <span ng-if=\"destacado.pack\">\n                        <span translate=\"inicio.infotienda.ahorras\"></span> {{destacado.precioAnterior - destacado.precio | currency}}\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/aspg/managerlogin/manager-login.admin.html","<div class=\"manager-login col-sm-6 col-md-offset-3\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-4 pagina\" ng-repeat=\"(nombre, datos) in $resolve.datos track by nombre\">\r\n\r\n            <form action=\"{{datos.urlManager | trustUrl}}\" target=\"_blank\" class=\"form-group\">\r\n                <div class=\"imagen\">\r\n                    <input src=\"{{\'/assets/images/static/managerlogin/\' + nombre + \'.png\'}}\" type=\"image\">\r\n                </div>\r\n\r\n                <input value=\"{{datos.password}}\" name=\"password\" type=\"hidden\">\r\n                <input value=\"true\" name=\"encrypted\" type=\"hidden\">\r\n\r\n                <input value=\"{{datos.user}}\" name=\"user\" type=\"hidden\" ng-if=\"datos.user\">\r\n                <input value=\"{{datos.login}}\" name=\"login\" type=\"hidden\" ng-if=\"datos.login\">\r\n                <input value=\"{{datos.loginName}}\" name=\"loginName\" type=\"hidden\" ng-if=\"datos.loginName\">\r\n\r\n                <div class=\"nombre\">{{\'managerLogin.tipo.\' + nombre | translate}}</div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/socialmenu/social-menu.html","<a class=\"icon\" ng-click=\"ctrl.abrir(\'https://twitter.com/asocpedagoxica\')\">\r\n    <img ng-src=\"assets/images/rrss/twitter-menu.png\">\r\n</a>\r\n\r\n<a class=\"icon\" ng-click=\"ctrl.abrir(\'https://www.facebook.com/asociacion.galega\')\">\r\n    <img ng-src=\"assets/images/rrss/face-menu.png\">\r\n</a>\r\n");
$templateCache.put("app/components/estaticas/admin/estatica-form.admin.html","<form name=\"ctrl.form\" role=\"form\" class=\"estatica-form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <h3>{{\'estaticas.pagina.\' + ctrl.item.nombre | translate}}</h3>\r\n\r\n        <uib-tabset active=\"ctrl.active\" ng-class=\"{\'single-language\': ctrl.idiomas.length === 1}\">\r\n            <uib-tab ng-repeat=\"idioma in ctrl.idiomas\" index=\"$index\" heading=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\" ng-init=\"ctrl.item.descripciones[idioma].idioma = idioma\">\r\n                <div class=\"row\">\r\n                    <!--Título-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"estaticas.i18n.titulo\" for=\"titulo_{{idioma}}\" required=\"true\"></label-form>\r\n                            <input type=\"text\" class=\"form-control\" id=\"titulo_{{idioma}}\" required ng-model=\"ctrl.item.descripciones[idioma].titulo\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Contenido-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <text-area id=\"contenido_{{idioma}}\" label=\"estaticas.i18n.contenido\" class=\"{{ctrl.item.nombre}}\" model=\"ctrl.item.descripciones[idioma].contenido\" tipo=\"estatica\"></text-area>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </uib-tab>\r\n        </uib-tabset>\r\n\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"ctrl.validar()\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode == \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/feedrss/rss/rss.html","<section class=\"feeds-rss\" ng-if=\"ctrl.categoria.id\">\n    <h2 class=\"titulo-categoria\">\n        <a ng-href=\"{{ctrl.categoria.url ? ctrl.categoria.url : \'\'}}\" target=\"_blank\">\n            <img class=\"imagen\" ng-if=\"ctrl.imagen\" ng-src=\"{{ctrl.imagen}}\">\n            <span class=\"texto\">{{ctrl.categoria.nombre}}</span>\n        </a>\n    </h2>\n\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\n\n    <div class=\"empty\" ng-if=\"!ctrl.loading && !ctrl.entradas.length\" translate=\"feedsRss.rss.empty\"></div>\n\n    <div class=\"rss media\" ng-repeat=\"rss in ctrl.entradas\">\n\n        <figure class=\"media-left\" ng-if=\"rss.imagenUrl\">\n            <a href=\"{{rss.url}}\" target=\"_blank\">\n                <img ng-src=\"{{rss.imagenUrl}}\" class=\"media-object\">\n            </a>\n        </figure>\n\n        <div class=\"media-body\">\n            <h4 class=\"media-heading\">\n                <a href=\"{{rss.url}}\" target=\"_blank\" ng-bind-html=\"rss.titulo\"></a>\n            </h4>\n            <div class=\"fecha\">\n                <date model=\"rss.fechaPublicacion\"></date>\n            </div>\n            <div class=\"descripcion\" ng-bind-html=\"rss.descripcion\" ellipsis=\"3\"></div>\n        </div>\n    </div>\n</section>\n");
$templateCache.put("app/components/form/buttons/buttons-form.template.html","<!--Botones de atrás/cancelar y crear/guardar-->\r\n<div ng-switch=\"::ctrl.canSave\">\r\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!ctrl.canSave\" ng-click=\"ctrl.validar()\">\r\n        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode == \'create\'\"></span>\r\n        <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode == \'edit\'\"></span>\r\n    </button>\r\n    <button type=\"button\" class=\"btn btn-secondary\" ng-click=\"ctrl.back()\">\r\n        <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n        <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/components/form/captcha/captcha.html","<div class=\"form-group\" ng-if=\"ctrl.apiKey\">\r\n    <div id=\"captcha\" class=\"captcha\" ng-model=\"ctrl.recaptchaResponse\" vc-recaptcha key=\"ctrl.apiKey\" on-success=\"ctrl.success(response)\" required></div>\r\n</div>\r\n");
$templateCache.put("app/components/form/confirm/confirm.modal.html","<form ng-submit=\"ctrl.confirm(ctrl.item)\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{ctrl.params.title}}\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <p translate=\"{{ctrl.params.body}}\" translate-values=\"{id: \'{{::ctrl.item[ctrl.params.property]}}\'}\"></p>\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.dismiss()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"comun.cancelar\"></span>\r\n        </button>\r\n        <button type=\"submit\" ng-disabled=\"ctrl.$invalid\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;<span translate=\"comun.aceptar\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/date/date-picker.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\"></label-form>\r\n\r\n<div class=\"input-group date-picker\">\r\n    <input type=\"text\" class=\"form-control\" id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" uib-datepicker-popup=\"{{ctrl.format}}\" ng-change=\"ctrl.change(ctrl.model)\" ng-focus=\"ctrl.openDatePicker()\" ng-model=\"ctrl.model\" is-open=\"ctrl.opened\" datepicker-options=\"ctrl.dateOptions\" ng-required=\"ctrl.required\" close-text=\"{{\'datepicker.close\' | translate}}\" current-text=\"{{\'datepicker.currentday\' | translate}}\" clear-text=\"{{\'datepicker.clear\' | translate}}\" show-button-bar=\"ctrl.showBar\" ng-disabled=\"$ctrl.disabled\" ng-readonly=\"ctrl.readonly\">\r\n\r\n    <span class=\"input-group-btn\" ng-if=\"!$ctrl.disabled\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.openDatePicker()\">\r\n            <i class=\"glyphicon glyphicon-calendar\"></i>\r\n        </button>\r\n    </span>\r\n</div>\r\n");
$templateCache.put("app/components/form/delete/entity.delete.modal.html","<form ng-submit=\"ctrl.confirmRemove(ctrl.item)\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{ctrl.params.title}}\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <p translate=\"{{ctrl.params.body}}\" translate-values=\"{id: \'{{::ctrl.item[ctrl.params.property]}}\'}\"></p>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.dismiss()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-danger\">\r\n            <span class=\"glyphicon glyphicon-remove-circle\"></span>\r\n            &nbsp\r\n            <span translate=\"admin.form.button.delete\" ng-show=\"::ctrl.params.borradoFisico\"></span>\r\n            <span translate=\"admin.form.button.deshabilitar\" ng-show=\"::!ctrl.params.borradoFisico\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/enum/enum-select-boolean.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\"></label-form>\r\n\r\n<select class=\"form-control\" id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.model\" ng-disabled=\"ctrl.disabled\" ng-required=\"ctrl.required\" ng-options=\"item as \'enum.boolean.\' + item | translate for item in [true, false]\" ng-change=\"ctrl.change(ctrl.model)\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n</select>\r\n");
$templateCache.put("app/components/form/enum/enum-select.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\"></label-form>\r\n\r\n<select class=\"form-control\" id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.model\" ng-disabled=\"ctrl.disabled\" ng-required=\"ctrl.required\" ng-change=\"ctrl.onChange(ctrl.model)\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n    <option ng-repeat=\"value in ctrl.options track by value\" value=\"{{value}}\" required>\r\n        {{ctrl.display ? ctrl.base + \'.\' + value[ctrl.display] : ctrl.base + \'.\' + value | translate}}\r\n    </option>\r\n</select>\r\n");
$templateCache.put("app/components/form/fecha/fecha.html","<fieldset class=\"fieldset-border form-group\">\r\n    <legend ng-if=\"!ctrl.label && ctrl.prefijo === \'nacimiento\'\" translate=\"fecha.legendnacimiento\"></legend>\r\n    <legend ng-if=\"!ctrl.label && ctrl.prefijo === \'muerte\'\" translate=\"fecha.legendmuerte\"></legend>\r\n    <legend ng-if=\"!ctrl.label && ctrl.prefijo !== \'nacimiento\' && ctrl.prefijo !== \'muerte\'\" translate=\"fecha.legendfecha\"></legend>\r\n    <legend ng-if=\"ctrl.label\" translate=\"{{ctrl.label}}\"></legend>\r\n\r\n    <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n            <label-form key=\"fecha.dia\" for=\"{{ctrl.prefijo}}dia\"></label-form>\r\n            <input class=\"form-control\" id=\"{{ctrl.prefijo}}dia\" name=\"{{ctrl.prefijo}}Dia\" type=\"number\" ng-model=\"ctrl.model[ctrl.prefijo + \'Dia\']\" min=\"1\" max=\"31\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n            <label-form key=\"fecha.mes\" for=\"{{ctrl.prefijo}}mes\" required=\"ctrl.model[ctrl.prefijo + \'Dia\']\"></label-form>\r\n            <input class=\"form-control\" id=\"{{ctrl.prefijo}}mes\" name=\"{{ctrl.prefijo}}Mes\" type=\"number\" ng-model=\"ctrl.model[ctrl.prefijo + \'Mes\']\" min=\"1\" max=\"12\" ng-required=\"ctrl.model[ctrl.prefijo + \'Dia\']\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n            <label-form key=\"fecha.ano\" for=\"{{ctrl.prefijo}}ano\" required=\"ctrl.model[ctrl.prefijo + \'Dia\'] || ctrl.model[ctrl.prefijo + \'Mes\']\"></label-form>\r\n            <input class=\"form-control\" id=\"{{ctrl.prefijo}}ano\" name=\"{{ctrl.prefijo}}Ano\" type=\"number\" ng-model=\"ctrl.model[ctrl.prefijo + \'Ano\']\" min=\"1\" max=\"3000\" ng-required=\"ctrl.model[ctrl.prefijo + \'Dia\'] || ctrl.model[ctrl.prefijo + \'Mes\']\">\r\n        </div>\r\n    </div>\r\n</fieldset>\r\n");
$templateCache.put("app/components/form/filter/filter.input.html","<div class=\"form-inline\">\r\n    <div class=\"form-group\">\r\n        <input id=\"keysFilter\" class=\"form-control\" type=\"text\" ng-model=\"ctrl.filter\" placeholder=\"{{\'admin.form.filter\' | translate}}\">\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/form/multiselect/multi-select.html","<div class=\"multi-select\">\r\n\r\n    <label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n    <div ng-dropdown-multiselect=\"\" id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" ng-class=\"{\'enum\': ctrl.enumBase}\" options=\"ctrl.options\" selected-model=\"ctrl.model\" extra-settings=\"ctrl.extraSettings\" translation-texts=\"ctrl.translations\" events=\"{onItemSelect: ctrl.onItemSelect}\"></div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/listform/list-form.html","<fieldset class=\"fieldset-border form-group list-form\">\r\n    <div class=\"row title\">\r\n        <div class=\"col-xs-8\">\r\n            <label-form key=\"{{ctrl.label}}\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4 text-right\">\r\n            <button type=\"button\" ng-click=\"ctrl.addElement()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\">\r\n                <span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row element\" ng-repeat=\"element in ctrl.list track by $index\" ng-class=\"{\'acordeon\': ctrl.acordeon, \'sin-acordeon\': !ctrl.acordeon, \'no-labels\': ctrl.noLabels}\">\r\n\r\n        <ng-include src=\"ctrl.templateUrl\"></ng-include>\r\n\r\n        <!--Eliminar-->\r\n        <div class=\"remove button-icons form-center-vertical\">\r\n            <a ng-click=\"ctrl.removeElement(element)\" class=\"glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n        </div>\r\n    </div>\r\n</fieldset>\r\n");
$templateCache.put("app/components/form/select/select-form.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n<select class=\"form-control\" id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.model\" ng-change=\"ctrl.change(ctrl.model)\" ng-options=\"value as ctrl.formatElement(value) | translate for value in ctrl.options track by value.id\" ng-required=\"ctrl.required\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n</select>\r\n");
$templateCache.put("app/components/form/tesauro/tesauro.html","<div class=\"tesauro\">\r\n\r\n    <ng-include src=\"\'app/templates/tesauro.templates.html\'\" ng-if=\"ctrl.templateUrl\"></ng-include>\r\n\r\n    <label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n    <!--Simple (Angular Bootstrap)-->\r\n    <div ng-class=\"{\'input-group\': ctrl.eliminable}\">\r\n        <input type=\"text\" class=\"form-control\" id=\"t_{{ctrl.id}}\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.ngModel[ctrl.display]\" ng-required=\"ctrl.required\" ng-disabled=\"ctrl.disabled\" ng-blur=\"ctrl.onBlur()\" typeahead-show-hint=\"true\" typeahead-editable=\"!ctrl.restricted\" uib-typeahead=\"element[ctrl.display] for element in ctrl.loadTags($viewValue)\" typeahead-min-length=\"ctrl.minLength | num\" typeahead-on-select=\"ctrl.setElement($item)\" typeahead-select-on-exact=\"true\" typeahead-template-url=\"{{ctrl.templateUrl}}\" autocomplete=\"off\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <span class=\"input-group-addon\" ng-if=\"ctrl.eliminable\">\r\n            <a type=\"button\" class=\"glyphicon glyphicon-remove\" ng-click=\"ctrl.clear()\" title=\"{{\'admin.form.button.remove\' | translate}}\" ng-class=\"{\'disabled\': !ctrl.ngModel[ctrl.display] || ctrl.disabled}\"></a>\r\n        </span>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/tags/tags.html","<div class=\"tesauro\">\r\n    <label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n    <tags-input id=\"{{ctrl.id}}\" name=\"{{ctrl.id}}\" class=\"bootstrap\" ng-class=\"{\'as-list\': ctrl.asList}\" ng-model=\"ctrl.ngModel\" ng-disabled=\"ctrl.disabled\" display-property=\"{{ctrl.display}}\" key-property=\"{{ctrl.key}}\" add-on-blur=\"false\" add-from-autocomplete-only=\"{{ctrl.restricted}}\" on-tag-added=\"ctrl.setElement($tag)\" replace-spaces-with-dashes=\"false\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <auto-complete source=\"ctrl.loadTags($query)\" select-first-match=\"false\" min-length=\"{{ctrl.minLength}}\" load-on-focus=\"true\" load-on-empty=\"{{ctrl.minLength == 0}}\"></auto-complete>\r\n    </tags-input>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/tooltip/tooltip.html","<span class=\"ng-tooltip\">\r\n    <span class=\"icon glyphicon glyphicon-question-sign\" uib-tooltip=\"{{ctrl.label | translate}}\" tooltip-placement=\"{{ctrl.position || \'right\'}}\">\r\n    </span>\r\n</span>\r\n");
$templateCache.put("app/components/novedades/public/novedad-details.public.html","<article class=\"novedad\">\r\n    <div class=\"tarjetas full articulo\">\r\n        <div class=\"tarjeta\">\r\n            <div class=\"media\">\r\n                <!--Imagen (ampliable, si se está en la ficha de la noticia)-->\r\n                <figure class=\"media-left media-imagen\">\r\n\r\n                    <a ng-if=\"!ctrl.ampliada\" ui-sref=\"{{ctrl.novedad.categoriaNovedad.url}}/details({url: ctrl.novedad.url})\">\r\n                        <div class=\"media-object\" ng-style=\"{\'background-image\': ctrl.imagen}\"></div>\r\n                    </a>\r\n                    <a ng-if=\"ctrl.ampliada\" ng-click=\"ctrl.abrirImagen()\">\r\n                        <div class=\"media-object\" ng-style=\"{\'background-image\': ctrl.imagen}\"></div>\r\n                    </a>\r\n                </figure>\r\n\r\n                <div class=\"media-body\">\r\n                    <!--Título (clickable si se está en el listado)-->\r\n                    <div ng-if=\"!ctrl.ampliada\">\r\n                        <a ui-sref=\"{{ctrl.novedad.categoriaNovedad.url}}/details({url: ctrl.novedad.url})\">\r\n                            <h4 class=\"media-heading\">{{ctrl.novedad.titulo}}</h4>\r\n                        </a>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.ampliada\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-sm-10\">\r\n                                <div class=\"media-heading\">{{ctrl.novedad.titulo}}</div>\r\n                            </div>\r\n                            <div class=\"col-sm-2\">\r\n                                <!--Compartir en redes sociales-->\r\n                                <social-share url=\"/novedades/{{ctrl.novedad.url}}\" facebook=\"true\" twitter=\"true\" mini=\"true\" textos=\"false\" tweet=\"{{ctrl.novedad.titulo}}\" tw-hashtags=\"\" tw-via=\"asocpedagoxica\" titulo=\"{{ctrl.novedad.titulo}}\" imagen=\"{{ctrl.novedad.imagenPath ? ctrl.ruta + \'n_\' + ctrl.novedad.imagenPath : null}}\" descripcion=\"{{ctrl.novedad.resumen}}\"></social-share>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Fecha-->\r\n                    <time class=\"fecha\">\r\n                        {{ctrl.novedad.fechaTextual}}\r\n                        <date model=\"ctrl.novedad.fecha\" fecha=\"true\" ng-if=\"!ctrl.novedad.fechaTextual\"></date>\r\n                    </time>\r\n\r\n                    <!--Etiquetas-->\r\n                    <div>\r\n                        <ul>\r\n                            <li style=\"display: inline\" ng-repeat=\"x in ctrl.novedad.etiquetas\">\r\n                               <a class=\"label label-tag\" ui-sref=\"{{ctrl.novedad.categoriaNovedad.url}}/list({page:\'1\', etiqueta:\'{{x.etiqueta.text}}\'})\" data-ui-sref-opts=\"{reload: true}\"> {{x.etiqueta.text}}</a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    <!--Resumen-->\r\n                    <div class=\"resumen\" ng-if=\"ctrl.novedad.resumen\">\r\n                        <span ng-bind-html=\"ctrl.novedad.resumen | unsafe\"></span>\r\n                    </div>\r\n\r\n                    <!--TODO: Estaría bien que el contenido quedase rodeando la imagen, en lugar de dejar el espacio en blanco bajo la imagen (sobre en todo en móviles)-->\r\n                    <!--Contenido-->\r\n                    <div ng-if=\"ctrl.ampliada\">\r\n                        <hr>\r\n                        <div class=\"contenido\" ng-if=\"ctrl.novedad.contenido\">\r\n                            <span ng-bind-html=\"ctrl.novedad.contenido | unsafe\"></span>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Botón para leer más-->\r\n                    <div class=\"acciones\" ng-if=\"!ctrl.ampliada\">\r\n                        <a class=\"btn btn-primary\" ui-sref=\"novedad/details({url: ctrl.novedad.url})\" translate=\"novedades.novedad.mas\"></a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</article>\r\n");
$templateCache.put("app/components/novedades/public/novedad-list.public.html","<div class=\"novedades\">\r\n\r\n    <div class=\"indicador-filtro-etiqueta\" ng-if=\"ctrl.etiqueta!=null\">\r\n        <h4>Filtrando por: <strong>{{ctrl.etiqueta}}</strong></h4>\r\n        <a ui-sref=\"{{ctrl.categoriasNovedad}}/list({page:\'1\', etiqueta: null})\" data-ui-sref-opts=\"{reload: true}\" class=\"glyphicon glyphicon-remove ng-binding\" title=\"Eliminar filtrado\"></a>\r\n    </div>\r\n\r\n    <div class=\"empty text-center\" ng-if=\"!ctrl.novedades.content.length\" translate=\"novedades.novedad.empty\"></div>\r\n\r\n    <div ng-repeat=\"novedad in ctrl.novedades.content track by novedad.url\">\r\n        <novedad-details-public novedad=\"novedad\"></novedad-details-public>\r\n    </div>\r\n\r\n    <pagination current-page=\"ctrl.page\" total-elements=\"ctrl.novedades.totalElements\" separador=\"true\"></pagination>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/novedades/public/novedad-template.public.html","<h1 translate=\"novedades.ultimas\"></h1>\r\n\r\n<div class=\"rss-novedades pull-right\">\r\n    <a href=\"{{$resolve.rssUrl}}\" target=\"_blank\"><i class=\"fa fa-rss\"></i></a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div ng-class=\"$resolve.categorias.content.length ? \'col-md-9\': \'col-md-12\'\">\r\n        <div ui-view=\"contentNovedades\"></div>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\" ng-if=\"$resolve.categorias.content.length\">\r\n        <mi-menu menu=\"$resolve.menu\" lateral=\"true\"></mi-menu>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/web/public/categoria-web-list.public.html","<div class=\"bloques categorias-web\">\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\" ng-repeat=\"categoria in ctrl.categorias track by categoria.id\">\r\n            <div class=\"bloque categoria-web categoria_{{$index}}\">\r\n                <a ui-sref=\"web/websByCategoria({categoriaUrl: categoria.url})\">{{categoria.nombre}}</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/web/public/web-list-template.public.html","<div class=\"web\">\r\n    <h1 class=\"thin\" translate=\"web.titulo\"></h1>\r\n\r\n    <div class=\"menu-horizontal row\">\r\n        <nav class=\"principal\">\r\n            <div class=\"entrada-menu\" ng-repeat=\"categoria in $resolve.categorias track by categoria.id\">\r\n                <a ui-sref=\"web/websByCategoria({categoriaUrl: categoria.url})\" ui-sref-active=\"active\">{{categoria.nombre}}</a>\r\n            </div>\r\n        </nav>\r\n    </div>\r\n\r\n    <web-list-public webs=\"$resolve.webs\"></web-list-public>\r\n</div>\r\n");
$templateCache.put("app/components/web/public/web-list.public.html","<div class=\"tarjetas webs\">\r\n\r\n    <div class=\"empty\" ng-if=\"!ctrl.webs.length\" translate=\"web.web.empty\"></div>\r\n\r\n    <!--Lista de webs-->\r\n    <div class=\"tarjeta web\" ng-repeat=\"web in ctrl.webs track by web.id\">\r\n        <div class=\"titulo\">\r\n            <a href=\"{{ctrl.rutaBase + web.url}}/\" target=\"_blank\" title=\"{{\'comun.ver\' | translate}}\"><i class=\"fa fa-link\"></i> {{web.titulo}}</a>\r\n        </div>\r\n\r\n        <div class=\"info\">\r\n            <div ng-if=\"web.descripcion\">\r\n                <span ng-bind-html=\"web.descripcion | unsafe\"></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/admin/materia/materia-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.materia.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Ocultados los cambios en la jerarquía-->\r\n            <!--Nivel educativo-->\r\n            <div class=\"col-sm-6\" ng-if=\"false\">\r\n                <div class=\"form-group\">\r\n                    <select-form id=\"nivelEducativo\" label=\"aulaDigital.materia.field.nivelEducativo\" model=\"ctrl.item.nivelEducativo\" options=\"ctrl.nivelesEducativos\" required=\"true\"></select-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/auladigital/admin/materia/materia-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/aulaDigital/materia/create\">\r\n        <span translate=\"aulaDigital.materia.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'aulaDigital.materia.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/aulaDigital/materia/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <!--TODO: URL a parte pública. Se necesita la url del nivelEducativo y no se tiene... Habría que pasarlo con un binding-->\r\n                {{element.url}}\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.nivelEducativo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/aulaDigital/tema/list({materiaid: element.id})\" class=\"button glyphicon glyphicon-list\" title=\"{{\'aulaDigital.materia.temas\' | translate}}\"></a>\r\n\r\n                <a ui-sref=\"admin/aulaDigital/materia/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/admin/niveleducativo/nivel-educativo-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.nivelEducativo.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/auladigital/admin/niveleducativo/nivel-educativo-list.admin.html","<div class=\"btn-ctrl\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/aulaDigital/nivelEducativo/create\">\r\n        <span translate=\"aulaDigital.nivelEducativo.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'aulaDigital.nivelEducativo.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/aulaDigital/nivelEducativo/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <a ui-sref=\"aulaDigital/materiasByNivel({nivelUrl: element.url})\" target=\"_blank\" title=\"{{\'comun.nuevaPestana\' | translate}}\">\r\n                    {{element.url}}\r\n                    <i class=\"fa fa-external-link\"></i>\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.nivelEducativo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/aulaDigital/materia/list({nivelid: element.id})\" class=\"button glyphicon glyphicon-list\" title=\"{{\'aulaDigital.nivelEducativo.materias\' | translate}}\"></a>\r\n\r\n                <a ui-sref=\"admin/aulaDigital/nivelEducativo/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" tiene-permisos permiso-elemento=\"\'edit\'\" permiso-config=\"ctrl.permisos\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/admin/recursoeducativo/recurso-educativo-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Título-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.recursoEducativo.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Autoría-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.recursoEducativo.field.autoria\" for=\"autoria\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"autoria\" name=\"autoria\" ng-model=\"ctrl.item.autoria\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--URL-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.recursoEducativo.field.url\" for=\"url\"></label-form>\r\n                    <input class=\"form-control\" type=\"url\" id=\"url\" name=\"url\" ng-model=\"ctrl.item.url\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Archivo-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <file-upload id=\"archivo\" label=\"aulaDigital.recursoEducativo.field.archivo\" required=\"true\" model=\"ctrl.item.archivo\" accept=\"*\" url=\"{{ctrl.urlBaseArchivo}}\" size=\"ctrl.item.archivoSize\"></file-upload>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Ocultados los cambios en la jerarquía-->\r\n        <div class=\"row\" ng-if=\"false\">\r\n            <!--Tema-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <select-form id=\"tema\" label=\"aulaDigital.recursoEducativo.field.tema\" model=\"ctrl.item.tema\" display=\"titulo\" options=\"ctrl.temas\" required=\"true\"></select-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/auladigital/admin/recursoeducativo/recurso-educativo-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/aulaDigital/recursoEducativo/create\">\r\n        <span translate=\"aulaDigital.recursoEducativo.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'aulaDigital.recursoEducativo.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/aulaDigital/recursoEducativo/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.recursoEducativo.field.autoria\' | translate\" sortable=\"\'autoria\'\">\r\n                {{element.autoria}}\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.nivelEducativo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/aulaDigital/recursoEducativo/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/auladigital/admin/tema/tema-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Título-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.tema.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Autoría-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"aulaDigital.tema.field.autoria\" for=\"autoria\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"autoria\" name=\"autoria\" ng-model=\"ctrl.item.autoria\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Descripción-->\r\n        <div class=\"form-group\">\r\n            <text-area model=\"ctrl.item.descripcion\" id=\"descripcion\" label=\"aulaDigital.tema.field.descripcion\" tipo=\"basico\" height=\"100\"></text-area>\r\n        </div>\r\n\r\n        <!--Ocultados los cambios en la jerarquía-->\r\n        <div class=\"row\" ng-if=\"false\">\r\n            <!--Materia-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <select-form id=\"materia\" label=\"aulaDigital.tema.field.materia\" model=\"ctrl.item.materia\" options=\"ctrl.materias\" required=\"true\"></select-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/auladigital/admin/tema/tema-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/aulaDigital/tema/create\">\r\n        <span translate=\"aulaDigital.tema.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'aulaDigital.tema.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/aulaDigital/tema/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.tema.field.autoria\' | translate\" sortable=\"\'autoria\'\">\r\n                {{element.autoria}}\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <!--TODO: URL a parte pública. Falta url de NivelEducativo y Materia-->\r\n                {{element.url}}\r\n            </td>\r\n\r\n            <td data-title=\"\'aulaDigital.nivelEducativo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/aulaDigital/recursoEducativo/list({temaid: element.id})\" class=\"button glyphicon glyphicon-list\" title=\"{{\'aulaDigital.tema.recursosEducativos\' | translate}}\"></a>\r\n\r\n                <a ui-sref=\"admin/aulaDigital/tema/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/boletin/public/boletin-details.public.html","<div class=\"media\">\r\n    <!--Imagen-->\r\n    <figure class=\"media-left media-imagen\">\r\n        <a ng-click=\"ctrl.abrirImagen()\">\r\n            <div class=\"media-object\" ng-style=\"{\'background-image\': ctrl.imagen}\">\r\n            </div>\r\n        </a>\r\n    </figure>\r\n\r\n    <div class=\"media-body\">\r\n        <div class=\"titulo\">\r\n            <span translate=\"boletines.boletin.titulo\" translate-values=\"{num: ctrl.boletin.numero, fecha: ctrl.fecha}\"></span>\r\n        </div>\r\n\r\n        <div class=\"info\">\r\n            <div class=\"subtitulo\">\r\n                {{ctrl.boletin.titulo}}\r\n            </div>\r\n\r\n            <div class=\"descripcion\">\r\n                <div ng-bind-html=\"ctrl.boletin.descripcion\"></div>\r\n            </div>\r\n\r\n            <div class=\"secciones\" ng-if=\"ctrl.boletin.secciones.length\">\r\n                <div class=\"seccion\" ng-repeat=\"seccion in ctrl.boletin.secciones\">\r\n                    <a ng-click=\"ctrl.abrirSeccion(seccion)\">\r\n                        {{seccion.numero}}. {{seccion.titulo}}\r\n                    </a>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"descargas\" ng-if=\"ctrl.boletin.archivoPath\">\r\n                <descargar archivo=\"ctrl.boletin.archivoPath\" url=\"{{ctrl.urlBaseArchivo}}\" texto=\"{{\'boletines.boletin.disponiblePdf\' | translate}}\" size=\"ctrl.boletin.archivoSize\">\r\n                </descargar>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/boletin/public/boletin-list.public.html","<div class=\"tarjetas full articulo\">\r\n\r\n    <div class=\"empty\" ng-if=\"!ctrl.boletines.content.length\" translate=\"boletines.boletin.empty\"></div>\r\n\r\n    <div class=\"tarjeta boletin\" ng-repeat=\"boletin in ctrl.boletines.content track by boletin.id\">\r\n        <boletin-details-public boletin=\"boletin\"></boletin-details-public>\r\n    </div>\r\n\r\n    <pagination current-page=\"ctrl.page\" total-elements=\"ctrl.boletines.totalElements\" separador=\"true\"></pagination>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/aspg/boletin/public/seccion-boletin-details.public.html","<div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n    <h4 class=\"modal-title\" translate=\"boletines.boletin.titulo\" translate-values=\"{num: ctrl.boletin.numero, fecha: ctrl.fecha}\"></h4>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n    <alert modal=\"true\"></alert>\r\n\r\n    <h2>{{ctrl.seccion.numero}}. {{ctrl.seccion.titulo}}</h2>\r\n\r\n    <div ng-bind-html=\"ctrl.seccion.texto\"></div>\r\n\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" ng-click=\"ctrl.dismiss()\" class=\"btn btn-primary\">\r\n        <span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"boletines.boletin.close\"></span>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/admin/usuarios-template.admin.html","<ul class=\"nav nav-tabs\">\r\n    <li ui-sref-active=\"active\">\r\n        <a ui-sref=\"admin/usuario/juegos\" translate=\"usuarios.admin.usuarios.titulo\"></a>\r\n    </li>\r\n    <li ui-sref-active=\"active\">\r\n        <a ui-sref=\"admin/usuario/suscriptor\" translate=\"usuarios.admin.suscriptores.titulo\"></a>\r\n    </li>\r\n    <li ui-sref-active=\"active\">\r\n        <a ui-sref=\"admin/usuario/email\" translate=\"usuarios.admin.email.titulo\"></a>\r\n    </li>\r\n</ul>\r\n\r\n<div ui-view=\"contentUsuario\"></div>\r\n");
$templateCache.put("app/components/aspg/usuarios/login/login.html","<div class=\"row\">\n    <div class=\"col-md-6\">\n        <div class=\"jumbotron jumbotron-thin\">\n            <h3 translate=\"enXogo.login.titulo\"></h3>\n\n            <form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.login()\" novalidate>\n                <div class=\"form-group\">\n                    <label-form key=\"enXogo.login.username\" for=\"username\"></label-form>\n                    <input class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"ctrl.username\" type=\"text\">\n                </div>\n                <div class=\"form-group\">\n                    <label-form key=\"enXogo.login.password\" for=\"password\"></label-form>\n                    <input class=\"form-control\" id=\"password\" ng-model=\"ctrl.password\" type=\"password\">\n                </div>\n\n                <div class=\"form-inline row acciones\">\n                    <div class=\"form-group col-md-3\">\n                        <button class=\"btn btn-primary\" translate=\"enXogo.login.entrar\" type=\"submit\"></button>\n                    </div>\n                    <div class=\"form-group col-md-5\">\n                        <label for=\"rememberMe\">\n                            <input checked=\"true\" id=\"rememberMe\" ng-model=\"ctrl.rememberMe\" type=\"checkbox\">\n                            {{\'enXogo.login.recuerdame\' | translate}}\n                        </label>\n                    </div>\n                    <div class=\"form-group col-md-4\">\n                        <a class=\"forgot\" ui-sref=\"enXogo/recuperar/init\">\n                            {{\'enXogo.login.forgot\' | translate}}\n                        </a>\n                    </div>\n                </div>\n            </form>\n        </div>\n        <h4>\n            <span translate=\"enXogo.login.notienescuenta\"></span>\n            &nbsp;&nbsp;<a ui-sref=\"registro\" translate=\"enXogo.login.registrate\"></a>\n        </h4>\n    </div>\n\n    <div class=\"col-sm-6\">\n        <div class=\"imagen\">\n            <img src=\"assets/images/xogos/logos_xogos.png\">\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/aspg/usuarios/recuperar/recuperar-finish.html","<div class=\"row\" ng-show=\"ctrl.success\">\r\n    <h1 translate=\"enXogo.titulo\"></h1>\r\n    <div class=\"alert alert-success\" translate=\"recuperar.finish.success\" translate-compile></div>\r\n    <login></login>\r\n</div>\r\n<div class=\"row\" ng-show=\"!ctrl.success\">\r\n    <h1 class=\"titulo-principal\">{{\'recuperar.title\' | translate}}</h1>\r\n    <div class=\"col-md-12 jumbotron jumbotron-thin\">\r\n        <div class=\"col-md-4\">\r\n            <form class=\"form\" role=\"form\" ng-submit=\"ctrl.save()\">\r\n                <p>{{\'recuperar.finish.info\' | translate}}</p>\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"recuperar.finish.newpassword\" for=\"newPassword\"></label-form>\r\n                    <input type=\"password\" class=\"form-control\" id=\"newPassword\" ng-model=\"ctrl.newPassword\" required>\r\n                    <password-strength-bar password-to-check=\"ctrl.newPassword\"></password-strength-bar>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"recuperar.finish.confirmpassword\" for=\"confirmPassword\"></label-form>\r\n                    <input class=\"form-control\" id=\"confirmPassword\" type=\"password\" ng-model=\"ctrl.confirmPassword\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"new-password\" ng-maxlength=\"50\" ng-minlength=\"1\" same-as=\"ctrl.newPassword\" same-as-err-type required>\r\n\r\n\r\n                </div>\r\n                <div>\r\n                    <button type=\"submit\" class=\"btn btn-primary\">\r\n                        {{\'recuperar.submit\' | translate}}\r\n                    </button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/recuperar/recuperar-init.html","<h1 class=\"titulo-principal\">{{\'recuperar.title\' | translate}}</h1>\r\n<div class=\"alert alert-success\" ng-show=\"ctrl.success\" translate=\"recuperar.success\" translate-compile></div>\r\n<div class=\"jumbotron jumbotron-thin\" ng-if=\"!ctrl.success\">\r\n    <p>{{\'recuperar.info\' | translate}}</p>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4\">\r\n            <form class=\"form\" role=\"form\" ng-submit=\"ctrl.recuperar(ctrl.email)\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"recuperar.email\" required=\"true\" for=\"email\"></label-form>\r\n                    <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" ng-model=\"ctrl.email\" required>\r\n                </div>\r\n                <div>\r\n                    <button type=\"submit\" class=\"btn btn-primary\">\r\n                        {{\'recuperar.submit\' | translate}}\r\n                    </button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/unsuscribe/unsuscribe.html","<div class=\"row\">\r\n    <h1 data-translate=\"usuarios.unsuscribe.titulo\"></h1>\r\n\r\n    <div ng-show=\"!ctrl.success\">\r\n    <h5 translate=\"usuarios.unsuscribe.mensaje\"></h5>\r\n    <br>\r\n        <button class=\"btn btn-primary\" ng-click=\"ctrl.cancelarSuscripcion()\" translate=\"usuarios.unsuscribe.cancelar\">\r\n        </button>\r\n    </div>\r\n    <div class=\"alert alert-success\" ng-show=\"ctrl.success\" translate=\"usuarios.unsuscribe.success\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/registro/registro.html","<div class=\"registro\">\r\n    <div class=\"alert alert-info\" ng-show=\"ctrl.success && ctrl.mode === \'create\'\">\r\n        {{\'registro.success.email\' | translate}}\r\n    </div>\r\n    <div class=\"jumbotron jumbotron-thin\" ng-show=\"!ctrl.success || ctrl.mode === \'edit\'\">\r\n        <form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n\r\n            <div class=\"form-body\">\r\n\r\n                <div class=\"row\" ng-if=\"false\">\r\n                    <!--Imagen de perfil-->\r\n                    <div class=\"col-sm-4\">\r\n                        <div class=\"form-group\">\r\n                            <imagen-crop model=\"ctrl.item.imagen\" area=\"circle\" on-remove-image=\"ctrl.item.imagen = {eliminar: true}\"></imagen-crop>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-4\">\r\n                        <!--Login-->\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.login\" for=\"login\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" type=\"text\" id=\"login\" name=\"login\" ng-model=\"ctrl.item.login\" required>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-4\" ng-if=\"ctrl.mode === \'create\'\">\r\n                        <!--Email (o login)-->\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.email\" for=\"email\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" type=\"email\" id=\"email\" name=\"email\" ng-model=\"ctrl.item.email\" required>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-4\">\r\n                        <!--Nombre-->\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-4\">\r\n                        <!--Apellidos-->\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.apellidos\" for=\"apellidos\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" type=\"text\" id=\"apellidos\" name=\"apellidos\" ng-model=\"ctrl.item.apellidos\" required>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-3\">\r\n                        <!--NIF-->\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.nif\" for=\"nif\"></label-form>\r\n                            <input class=\"form-control\" type=\"text\" maxlength=\"9\" id=\"nif\" name=\"nif\" ng-model=\"ctrl.item.nif\">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n                <div class=\"row\" ng-if=\"ctrl.mode === \'create\'\">\r\n                    <br>\r\n                    <!--Contraseña-->\r\n                    <div class=\"col-sm-4\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.contrasena\" for=\"password\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" id=\"password\" type=\"password\" ng-model=\"ctrl.item.passwordClaro\" autocomplete=\"new-password\" ng-maxlength=\"50\" ng-minlength=\"1\" required>\r\n                            <password-strength-bar password-to-check=\"ctrl.item.passwordClaro\"></password-strength-bar>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Repetir-->\r\n                    <div class=\"col-sm-4\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"registro.form.repetircontrasena\" for=\"confirmPassword\" required=\"true\"></label-form>\r\n                            <input class=\"form-control\" id=\"confirmPassword\" type=\"password\" ng-model=\"ctrl.confirmPassword\" ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"new-password\" ng-maxlength=\"50\" ng-minlength=\"1\" same-as=\"ctrl.item.passwordClaro\" same-as-err-type required>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <!--Términos y condiciones-->\r\n                <span ng-bind-html=\"\'registro.form.informacion\' | translate\"></span>\r\n                <div class=\"form-group no-error-label\" ng-if=\"ctrl.mode === \'create\'\">\r\n                    <label class=\"noselect\">\r\n                        <input type=\"checkbox\" id=\"terminos\" ng-model=\"ctrl.terminos\" required>\r\n                        <span ng-bind-html=\"\'registro.form.terminos\' | translate\"></span>\r\n                    </label>\r\n                </div>\r\n\r\n                <!--Suscripciones-->\r\n                <!--Info general ASPG-->\r\n                <div class=\"form-group\">\r\n                    <label class=\"noselect\">\r\n                        <input type=\"checkbox\" id=\"infoGeneral\" ng-model=\"ctrl.item.infoGeneral\">\r\n                        {{\'registro.form.infoGeneral\' | translate}}\r\n                    </label>\r\n                </div>\r\n\r\n                <!--Info juegos-->\r\n                <div class=\"form-group\">\r\n                    <label class=\"noselect\">\r\n                        <input type=\"checkbox\" id=\"infoJuegos\" ng-model=\"ctrl.item.infoJuegos\">\r\n                        {{\'registro.form.infoJuegos\' | translate}}\r\n                    </label>\r\n                </div>\r\n\r\n                <!--Campos obligatorios-->\r\n                <div class=\"form-group message-required\">{{\'comun.required\' | translate}}</div>\r\n\r\n                <!--Botones-->\r\n                <div>\r\n                    <!--Registrar-->\r\n                    <button type=\"submit\" class=\"btn btn-primary\">\r\n                        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                        <span translate=\"registro.form.save\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n                        <span translate=\"registro.form.edit\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n                    </button>\r\n                    <a class=\"btn btn-primary\" ui-sref=\"enXogo/cambiar-contrasena\" ng-if=\"ctrl.mode === \'edit\'\">\r\n                        <span translate=\"registro.form.cambiarcontrasena\"></span>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/museos/admin/museos-breadcrumb.admin.html","<!--Breadcrumb para los museos con todos los niveles-->\r\n<ol class=\"breadcrumb breadcrumb-admin museos-breadcrumb\">\r\n    <!--Definimos un boolean para saber si el estado es de listado o de creación/edición-->\r\n    {{ctrl.list = $resolve.breadcrumb.getLastStep().name.endsWith(\'list\'); \"\" }}\r\n\r\n    <!--Raíz (lista de museos)-->\r\n    <li>\r\n        <a ui-sref=\"admin/museos/museo\" translate=\"museos.museo.admin.titulo\" title=\"{{\'museos.museo.admin.titulo\' | translate}}\" ng-if=\"!ctrl.list || $resolve.museo\"></a>\r\n        <span ng-if=\"ctrl.list && !$resolve.museo\" class=\"active\" translate=\"museos.museo.admin.titulo\"></span>\r\n    </li>\r\n\r\n    <!--Museos (lista de salas)-->\r\n    <li ng-if=\"$resolve.museo\">\r\n        <a ui-sref=\"admin/museos/salaMuseo({museoid: $resolve.museo.id})\" ng-if=\"!ctrl.list || $resolve.sala\" title=\"{{\'museos.salaMuseo.admin.titulo\' | translate}}\">{{$resolve.museo.titulo}}</a>\r\n        <span ng-if=\"ctrl.list && !$resolve.sala\" class=\"active\">\r\n            {{$resolve.museo.titulo}}\r\n        </span>\r\n    </li>\r\n\r\n    <!--Salas (lista de obras)-->\r\n    <li ng-if=\"$resolve.sala\">\r\n        <a ui-sref=\"admin/museos/obraMuseo({museoid: $resolve.museo.id, salaid: $resolve.sala.id})\" ng-if=\"!ctrl.list\" title=\"{{\'museos.obraMuseo.admin.titulo\' | translate}}\">{{$resolve.sala.titulo}}</a>\r\n        <span ng-if=\"ctrl.list\" class=\"active\">\r\n            {{$resolve.sala.titulo}}\r\n        </span>\r\n    </li>\r\n\r\n    <!--Creación/edición (se delega en $breadcrumb)-->\r\n    <li ng-if=\"!ctrl.list\" class=\"active\">\r\n        {{$resolve.breadcrumb.getLastStep().ncyBreadcrumbLabel | translate}}\r\n    </li>\r\n</ol>\r\n");
$templateCache.put("app/components/aspg/usuarios/validar/validar.html","<div class=\"row col-md-12\">\r\n    <div class=\"alert alert-success\" ng-show=\"ctrl.success\" translate=\"enXogo.activacion.success.activado\" translate-compile>\r\n    </div>\r\n    <div class=\"alert alert-warning\" ng-show=\"ctrl.error\" translate=\"enXogo.activacion.error.clave\"></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <login></login>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/museos/public/museos-template.public.html","<div class=\"museo-template\">\r\n    <h1 translate=\"museos.titulo\"></h1>\r\n    <div class=\"jumbotron\">\r\n        <h2>\r\n            {{$resolve.museo.titulo}}\r\n        </h2>\r\n        <div class=\"row\">\r\n            <museo-info-public museo=\"$resolve.museo\"></museo-info-public>\r\n        </div>\r\n    </div>\r\n    <div class=\"contenedor-secciones\" ui-view=\"seccionesMuseo\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/feedrss/admin/feedrss/feed-rss-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"feedsRss.feedRss.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--URL del feed-->\r\n            <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"feedsRss.feedRss.field.url\" for=\"numEntradas\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"url\" id=\"url\" name=\"url\" ng-model=\"ctrl.item.url\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Categoría-->\r\n            <div class=\"col-sm-3\">\r\n                <div class=\"form-group\">\r\n                    <div tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisosCategoria\">\r\n                        <button-create click=\"ctrl.openCategoriaModal\"></button-create>\r\n                    </div>\r\n                    <select-form label=\"feedsRss.feedRss.field.categoria\" id=\"categoriaRss\" options=\"ctrl.categorias\" model=\"ctrl.item.categoriaRss\" required=\"true\"></select-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/feedrss/admin/feedrss/feed-rss-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/feedRss/create\">\r\n        <span translate=\"feedsRss.feedRss.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'feedsRss.feedRss.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/feedRss/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'feedsRss.feedRss.field.url\' | translate\" sortable=\"\'url\'\">\r\n                <a href=\"{{element.url}}\" target=\"_blank\" title=\"{{\'comun.nuevaPestana\' | translate}}\">\r\n                    {{element.url}}\r\n                    <i class=\"fa fa-external-link\"></i>\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'feedsRss.feedRss.field.categoria\' | translate\" sortable=\"\'categoriaRss.nombre\'\">\r\n                <a ui-sref=\"admin/categoriaRss/edit({id: element.categoriaRss.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.categoriaRss.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/feedRss/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/feedrss/admin/categoriarss/categoria-rss-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\n    <div class=\"form-body\">\n\n        <div class=\"row\">\n            <!--Nombre-->\n            <div class=\"col-sm-5\">\n                <div class=\"form-group\">\n                    <label-form key=\"feedsRss.categoriaRss.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\n                </div>\n            </div>\n\n            <!--URL-->\n            <div class=\"col-sm-5\">\n                <div class=\"form-group\">\n                    <label-form key=\"feedsRss.categoriaRss.field.url\" for=\"url\" tooltip=\"feedsRss.categoriaRss.tooltip.url\" tooltip-position=\"top\"></label-form>\n                    <input class=\"form-control\" type=\"url\" id=\"url\" name=\"url\" ng-model=\"ctrl.item.url\">\n                </div>\n            </div>\n\n            <!--Nº de entradas-->\n            <div class=\"col-sm-2\">\n                <div class=\"form-group\">\n                    <label-form key=\"feedsRss.categoriaRss.field.numEntradas\" for=\"numEntradas\" tooltip=\"feedsRss.categoriaRss.tooltip.numEntradas\" tooltip-position=\"top\" required=\"true\"></label-form>\n                    <input class=\"form-control\" type=\"number\" id=\"numEntradas\" name=\"numEntradas\" ng-model=\"ctrl.item.numEntradas\" min=\"0\" max=\"20\" required>\n                </div>\n            </div>\n        </div>\n\n        <!--Botones-->\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\n    </div>\n</form>\n");
$templateCache.put("app/components/feedrss/admin/categoriarss/categoria-rss-list.admin.html","<div class=\"btn-ctrl\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/categoriaRss/create\">\r\n        <span translate=\"feedsRss.categoriaRss.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'feedsRss.categoriaRss.field.id\' | translate\" sortable=\"\'id\'\" class=\"col-sm-1 text-center\">\r\n                {{element.id}}\r\n            </td>\r\n\r\n            <td data-title=\"\'feedsRss.categoriaRss.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/categoriaRss/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'feedsRss.categoriaRss.field.numEntradas\' | translate\" sortable=\"\'numEntradas\'\" class=\"col-sm-2 text-center\">\r\n                {{element.numEntradas}}\r\n            </td>\r\n\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/categoriaRss/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" tiene-permisos permiso-elemento=\"\'edit\'\" permiso-config=\"ctrl.permisos\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/download/download.html","<span ng-if=\"ctrl.archivo && ctrl.url\" ng-click=\"ctrl.descargarArchivo()\" title=\"{{\'download\' | translate}}\" class=\"boton-descarga\">\r\n    <span class=\"glyphicon glyphicon-download-alt\"></span>\r\n    <span ng-if=\"ctrl.showLabel\">{{ctrl.archivo || \'-\'}}</span>\r\n</span>\r\n");
$templateCache.put("app/components/form/archivos/imagen/imagen.html","<div class=\"imagen-select\">\r\n    <div class=\"enxe-boton-elegir\" ng-show=\"ctrl.edicion && !ctrl.model.rutaImagen && !ctrl.progresoImagen\">\r\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\" name=\"imagen.path\" ng-model=\"subirImagen\" ng-disabled=\"ctrl.progresoImagen\" ng-click=\"ctrl.clickUpload()\">\r\n            {{\'imagen.upload\' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n    <div class=\"imagen\" ng-if=\"ctrl.model.rutaImagen && ctrl.edicion\" ng-class=\"{\'imagen-profile\' : ctrl.profile}\">\r\n        <div class=\"imagen-wrap\" ng-if=\"ctrl.model.path\">\r\n                <span class=\"glyphicon glyphicon-remove clickable close\" ng-click=\"ctrl.eliminarImagen()\" title=\"{{\'admin.form.button.delete\' | translate}}\"></span>\r\n\r\n            <img class=\"enxe-img pull-left\" ng-src=\"{{ctrl.model.rutaImagen}}\">\r\n\r\n            <radio ng-if=\"ctrl.modelRadio\" class=\"principal\" model=\"ctrl.modelRadio\" value=\"{{ctrl.indice}}\"></radio>\r\n        </div>\r\n\r\n        <loading is-loading=\"ctrl.progresoImagen\"></loading>\r\n    </div>\r\n\r\n    <input id=\"inputFoto{{ctrl.indice}}\" type=\"file\" ngf-select=\"\" class=\"oculto\" ngf-change=\"ctrl.onImagenSelect($files)\" accept=\".jpg,.png,.gif,.jpeg\">\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/fileupload/file-upload.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n<div class=\"file-upload\">\r\n    <!--Información del archivo subido-->\r\n    <div ng-if=\"ctrl.subido && ctrl.model.path\" class=\"datos-archivo\">\r\n        <download ng-if=\"ctrl.url && !ctrl.model.archivoTemporal\" archivo=\"ctrl.model.path\" url=\"{{ctrl.url}}\" show-label=\"false\" has-any-authority=\"{{ctrl.authorities}}\"></download>\r\n\r\n        <span ng-if=\"!ctrl.progresoArchivo\" class=\"glyphicon glyphicon-remove clickable eliminar-archivo\" title=\"Eliminar\" ng-click=\"ctrl.eliminarArchivo()\"></span>\r\n\r\n        <span>{{ctrl.model.path}}</span>\r\n\r\n        <span class=\"size\" ng-if=\"ctrl.size && !ctrl.model.archivoTemporal\">({{ctrl.size | fileSize}})</span>\r\n    </div>\r\n\r\n    <!--Botón de subida-->\r\n    <button type=\"button\" id=\"{{ctrl.id}}\" name=\"archivo.path\" ngf-select=\"\" ngf-change=\"ctrl.onArchivoSelect($files, ficheroForm)\" ngf-accept=\"ctrl.accept\" ngf-pattern=\"ctrl.accept\" ng-disabled=\"ctrl.disabled || ctrl.progresoArchivo\" ng-required=\"ctrl.required && !ctrl.subido\" ng-model=\"ctrl.imagenSeleccionada\" ngf-drag-over-class=\"dragOver\" ngf-drop=\"\" ngf-drop-disabled=\"ctrl.disableDrop\" ngf-capture=\"\'other\'\" class=\"btn btn-default drop-box\">\r\n\r\n        {{\'upload.file.title\' | translate}}\r\n        <loading is-loading=\"ctrl.progresoArchivo\"></loading>\r\n\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/imagencrop/imagen-crop.html","<div class=\"imagen-crop\">\r\n\r\n    <!--Subir imagen-->\r\n    <div ng-show=\"!ctrl.editPreview && !ctrl.model.path && !ctrl.progresoImagen || !ctrl.myCroppedImage\">\r\n        <button type=\"button\" class=\"btn btn-default\" name=\"imagen.path\" ng-model=\"subirImagen\" ng-disabled=\"ctrl.progresoImagen\" ng-click=\"ctrl.clickUpload()\">\r\n            {{\'imagen.upload\' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n    <!--Imagen almacenada-->\r\n    <div class=\"imagen\" ng-show=\"ctrl.model.path || ctrl.editPreview && ctrl.myCroppedImage\">\r\n        <div class=\"imagen-wrap\">\r\n            <!--Eliminar imagen-->\r\n            <span class=\"glyphicon glyphicon-remove clickable close\" ng-click=\"ctrl.eliminarImagen()\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!ctrl.editPreview\"></span>\r\n\r\n            <img class=\"pull-left {{ctrl.area}}\" ng-src=\"{{ctrl.myCroppedImage}}\" ng-show=\"!ctrl.editPreview\">\r\n\r\n            <div oc-lazy-load=\"uiCropper\">\r\n                <div class=\"crop-area pull-left\" ng-show=\"ctrl.editPreview\">\r\n                    <ui-cropper image=\"ctrl.myImage\" area-type=\"{{ctrl.area}}\" result-image=\"ctrl.myCroppedImage\" live-view=\"ctrl.blockingObject\" aspect-ratio=\"ctrl.ratio\" area-min-size=\"50\" result-image-size=\"\'max\'\" result-image-quality=\"1.0\"></ui-cropper>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <loading is-loading=\"ctrl.progresoImagen\"></loading>\r\n\r\n    <!--Confirmar selección-->\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <button type=\"button\" class=\"btn btn-default btn-confirm\" ng-show=\"ctrl.editPreview && ctrl.myCroppedImage\" ng-click=\"ctrl.onImagenSelect(ctrl.myCroppedImage)\">\r\n                {{\'imagen.set\' | translate}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <input id=\"inputFoto{{ctrl.indice}}\" type=\"file\" class=\"oculto\" ngf-select=\"\" ngf-change=\"ctrl.preview($files)\" accept=\".jpg,.png,.gif,.jpeg\">\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/imagenperfilver/imagen-perfil-ver.html","<div class=\"imagen-perfil\">\r\n    <span class=\"glyphicon glyphicon-user\" ng-class=\"ctrl.mini ? \'mini\' : \'normal\'\" ng-if=\"!ctrl.usuario.foto\"></span>\r\n    <img ng-class=\"ctrl.mini ? \'mini\' : \'normal\'\" ng-src=\"upload/usuarios/{{ctrl.usuario.id}}/perfil/n_{{ctrl.usuario.foto}}\" ng-if=\"ctrl.usuario.foto\">\r\n</div>\r\n");
$templateCache.put("app/components/novedades/admin/novedad/novedad-form.admin.html","<form name=\"ctrl.form\" role=\"form\" class=\"novedad-form\" ng-submit=\"ctrl.save()\" novalidate>\r\n\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-6\">\r\n            <div class=\"row\">\r\n                <!--Publicado-->\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"publicado\" type=\"checkbox\" ng-model=\"ctrl.item.publicado\">\r\n                        <label-form key=\"novedades.novedad.field.publicado\" for=\"publicado\"></label-form>\r\n                    </div>\r\n                </div>\r\n                <!--Destacado-->\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"destacado\" type=\"checkbox\" ng-model=\"ctrl.item.destacado\">\r\n                        <label-form key=\"novedades.novedad.field.destacado\" for=\"destacado\"></label-form>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <!--Fecha analítica-->\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <date-picker label=\"novedades.novedad.field.fecha\" id=\"fecha\" model=\"ctrl.item.fecha\" hoy=\"true\" options=\"{datepickerMode: \'day\', maxDate: \'\'}\" required=\"true\"></date-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <!--Categoría-->\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <div tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisosCategoria\">\r\n                            <button-create click=\"ctrl.openCategoriaModal\"></button-create>\r\n                        </div>\r\n                        <select-form required=\"true\" label=\"novedades.novedad.field.categoria\" id=\"categoriaNovedad\" options=\"ctrl.categorias\" model=\"ctrl.item.categoriaNovedad\"></select-form>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Portada-->\r\n        <div class=\"col-sm-3\">\r\n            <div class=\"form-group\">\r\n                <label-form key=\"novedades.novedad.field.imagen\" for=\"imagen\"></label-form>\r\n                <imagen-crop model=\"ctrl.item.imagen\" carpeta=\"{{ctrl.urlBaseImagen}}\" on-remove-image=\"ctrl.item.imagen = {eliminar: true}\"></imagen-crop>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"form-body\">\r\n\r\n\r\n        <uib-tabset active=\"ctrl.active\" class=\"tabs\" ng-class=\"{\'single-language\': ctrl.idiomas.length === 1}\">\r\n\r\n            <uib-tab ng-repeat=\"idioma in ctrl.idiomas\" index=\"$index\" id=\"tab_{{idioma}}\" class=\"tab\" heading=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\" ng-init=\"ctrl.item.descripciones[idioma].idioma = idioma\">\r\n                <div class=\"row\">\r\n\r\n                    <!--Título-->\r\n                    <div class=\"col-sm-10\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"novedades.novedad.field.titulo\" for=\"titulo_{{idioma}}\" required=\"true\"></label-form>\r\n                            <input type=\"text\" class=\"form-control\" id=\"titulo_{{idioma}}\" name=\"descripciones[{{idioma}}].titulo\" required ng-maxlength=\"255\" ng-model=\"ctrl.item.descripciones[idioma].titulo\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Opción de actualizar la URL-->\r\n                    <div class=\"col-sm-2 form-center-vertical\" ng-if=\"ctrl.lang === idioma && ctrl.item.url\">\r\n                        <div class=\"form-group\">\r\n                            <input id=\"actualizarUrl\" type=\"checkbox\" ng-model=\"ctrl.actualizarUrl\">\r\n                            <label-form key=\"novedades.novedad.field.actualizarUrl\" for=\"actualizarUrl\" tooltip=\"novedades.novedad.tooltip.actualizarUrl\" tooltip-position=\"top\"></label-form>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <!--Fecha-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"novedades.novedad.field.fechaTextual\" for=\"fechaTextual_{{idioma}}\"></label-form>\r\n                            <input type=\"text\" class=\"form-control\" id=\"fechaTextual_{{idioma}}\" name=\"descripciones[{{idioma}}].fechaTextual\" ng-maxlength=\"255\" ng-model=\"ctrl.item.descripciones[idioma].fechaTextual\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Resumen-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <text-area id=\"resumen_{{idioma}}\" label=\"novedades.novedad.field.resumen\" height=\"100\" model=\"ctrl.item.descripciones[idioma].resumen\" tipo=\"basico\"></text-area>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Contenido-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <text-area id=\"contenido_{{idioma}}\" label=\"novedades.novedad.field.contenido\" model=\"ctrl.item.descripciones[idioma].contenido\" tipo=\"completo\"></text-area>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </uib-tab>\r\n        </uib-tabset>\r\n\r\n        <!--Etiquetas-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"novedades.novedad.field.tags\" for=\"tags_{{idioma}}\" tooltip=\"novedades.novedad.tooltip.etiquetas\"></label-form>\r\n\r\n                <tags-input id=\"tags_{{idioma}}\" ng-model=\"ctrl.item.etiquetas\" placeholder=\"Engadir etiqueta\">\r\n                </tags-input>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-if=\"ctrl.mode === \'edit\'\">\r\n            <!--URL-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"novedades.novedad.field.url\" for=\"url\" tooltip=\"novedades.novedad.tooltip.url\"></label-form>\r\n                    <input type=\"text\" class=\"form-control\" id=\"url\" name=\"url\" ng-model=\"ctrl.item.url\" readonly=\"readonly\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\" validar=\"ctrl.validar\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/novedades/admin/novedad/novedad-list.admin.html","<div class=\"btn-ctrl\">\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/novedad/create\">\n        <span translate=\"novedades.novedad.admin.create.title\"></span>\n    </a>\n</div>\n\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\n\n<div class=\"total-elementos\">\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\n</div>\n<div class=\"table-responsive\">\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\n\n        <tr ng-repeat=\"element in $data track by element.url\" class=\"animate\">\n            <td data-title=\"\'novedades.novedad.field.fecha\' | translate\" sortable=\"\'n.fecha\'\" class=\"text-center col-md-2\">\n                <date model=\"element.fecha\" fecha=\"true\"></date>\n            </td>\n\n            <td data-title=\"\'novedades.novedad.field.titulo\' | translate\" sortable=\"\'titulo\'\">\n                <a ui-sref=\"admin/novedad/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\n                    {{element.titulo}}\n                </a>\n            </td>\n\n            <td data-title=\"\'novedades.novedad.field.url\' | translate\" sortable=\"\'n.url\'\">\n                <a ui-sref=\"novedad/details({url: element.url})\" target=\"_blank\" title=\"{{\'comun.nuevaPestana\' | translate}}\" ng-if=\"element.publicado\">\n                    {{element.url}}\n                    <i class=\"fa fa-external-link\"></i>\n                </a>\n                <span ng-if=\"!element.publicado\">{{element.url}}</span>\n            </td>\n\n            <td data-title=\"\'novedades.novedad.field.categoria\' | translate\" sortable=\"\'n.categoriaNovedad.nombre\'\">\n                <a ui-sref=\"admin/categoriaNovedad/edit({id: element.categoriaNovedad.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\n                    {{element.categoriaNovedad.nombre}}\n                </a>\n            </td>\n\n            <td data-title=\"\'novedades.novedad.field.publicado\' | translate\" sortable=\"\'n.publicado\'\" class=\"text-center col-sm-1\">\n                <booleano value=\"{{element.publicado}}\"></booleano>\n            </td>\n\n            <td data-title=\"\'novedades.novedad.field.destacado\' | translate\" sortable=\"\'n.destacado\'\" class=\"text-center col-sm-1\">\n                <booleano value=\"{{element.destacado}}\"></booleano>\n            </td>\n\n            <td class=\"col-md-1 text-center button-icons\">\n                <a ui-sref=\"admin/novedad/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\n            </td>\n        </tr>\n    </table>\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\n</div>\n");
$templateCache.put("app/components/novedades/admin/categorianovedad/categoria-novedad-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"novedades.categoriaNovedad.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/novedades/admin/categorianovedad/categoria-novedad-list.admin.html","<div class=\"btn-ctrl\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/categoriaNovedad/create\">\r\n        <span translate=\"novedades.categoriaNovedad.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'novedades.categoriaNovedad.field.id\' | translate\" sortable=\"\'id\'\" class=\"col-sm-1 text-center\">\r\n                {{element.id}}\r\n            </td>\r\n\r\n            <td data-title=\"\'novedades.categoriaNovedad.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/categoriaNovedad/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                {{element.url}}\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/categoriaNovedad/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" tiene-permisos permiso-elemento=\"\'edit\'\" permiso-config=\"ctrl.permisos\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/novedades/public/actividades/actividad-template.public.html","<h1 translate=\"actividades.ultimas\"></h1>\r\n\r\n<div class=\"rss-novedades pull-right\">\r\n    <a href=\"{{$resolve.rssUrl}}\" target=\"_blank\"><i class=\"fa fa-rss\"></i></a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div ng-class=\"$resolve.categorias.content.length ? \'col-md-9\': \'col-md-12\'\">\r\n        <div ui-view=\"contentNovedades\"></div>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\" ng-if=\"$resolve.categorias.content.length\">\r\n        <mi-menu menu=\"$resolve.menu\" lateral=\"true\"></mi-menu>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/web/admin/categoriaweb/categoria-web-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"web.categoriaWeb.field.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"nombre\" name=\"nombre\" ng-model=\"ctrl.item.nombre\" required>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/web/admin/categoriaweb/categoria-web-list.admin.html","<div class=\"btn-ctrl\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/categoriaWeb/create\">\r\n        <span translate=\"web.categoriaWeb.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'web.categoriaWeb.field.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                <a ui-sref=\"admin/categoriaWeb/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.nombre}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <a ui-sref=\"web/websByCategoria({categoriaUrl: element.url})\" target=\"_blank\" title=\"{{\'comun.nuevaPestana\' | translate}}\">\r\n                    {{element.url}}\r\n                    <i class=\"fa fa-external-link\"></i>\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'web.categoriaWeb.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <div tiene-permisos permiso-elemento=\"\'edit\'\" permiso-config=\"ctrl.permisos\">\r\n                    <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n                </div>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/categoriaWeb/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" tiene-permisos permiso-elemento=\"\'edit\'\" permiso-config=\"ctrl.permisos\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisos\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/web/admin/web/web-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <!--Nombre-->\r\n            <div class=\"col-sm-7\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"web.web.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Categoría-->\r\n            <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                    <div tiene-permisos permiso-elemento=\"\'create\'\" permiso-config=\"ctrl.permisosCategoria\">\r\n                        <button-create click=\"ctrl.openCategoriaModal\"></button-create>\r\n                    </div>\r\n                    <select-form label=\"web.web.field.categoria\" id=\"categoriaWeb\" options=\"ctrl.categorias\" model=\"ctrl.item.categoriaWeb\" required=\"true\"></select-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Resumen-->\r\n            <div class=\"col-sm-12\">\r\n                <div class=\"form-group\">\r\n                    <text-area id=\"descripcion\" label=\"web.web.field.descripcion\" height=\"100\" model=\"ctrl.item.descripcion\" tipo=\"basico\"></text-area>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Archivo-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <file-upload id=\"archivo\" label=\"web.web.field.archivo\" tooltip=\"web.web.tooltip.archivo\" required=\"true\" model=\"ctrl.item.archivo\" accept=\".zip\" url=\"{{ctrl.urlBaseArchivo}}\" size=\"ctrl.item.archivoSize\"></file-upload>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/web/admin/web/web-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/web/create\">\r\n        <span translate=\"web.web.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'web.web.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/web/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <!--TODO: URL a parte pública-->\r\n                {{element.url}}\r\n            </td>\r\n\r\n            <td data-title=\"\'web.web.field.categoria\' | translate\" sortable=\"\'categoriaWeb.nombre\'\">\r\n                {{element.categoriaWeb.nombre}}\r\n            </td>\r\n\r\n            <td class=\"text-center\">\r\n                <a href=\"{{ctrl.rutaBase + element.url}}/\" target=\"_blank\" title=\"{{\'comun.ver\' | translate}}\"><i class=\"fa fa-eye\"></i></a>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/web/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/admin/usuarios/usuarios-list.admin.html","<div class=\"row\">\r\n    <div class=\"col-sm-2\">\r\n        <filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n    </div>\r\n    <div class=\"col-sm-3 form-center-vertical\">\r\n        <div class=\"form-group\">\r\n            <input id=\"eliminado\" type=\"checkbox\" ng-model=\"ctrl.filter.eliminado\">\r\n            <label-form key=\"usuarios.admin.usuarios.deshabilitados\" for=\"eliminado\"></label-form>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-sm-offset-4 col-sm-3 text-right\">\r\n        <a ng-click=\"ctrl.generarExcel()\" title=\"{{\'usuarios.admin.usuarios.generarExcel.ayuda\' | translate}}\"><i class=\"fa fa-file-excel-o\"></i> {{\'usuarios.admin.usuarios.generarExcel.exportar\' | translate}}</a>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.email\" class=\"animate\">\r\n            <td data-title=\"\'usuarios.admin.usuarios.login\' | translate\" sortable=\"\'login\'\">\r\n                {{element.login}}\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.email\' | translate\" sortable=\"\'email\'\">\r\n                {{element.email}}\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n                {{element.nombre}}\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.apellidos\' | translate\" sortable=\"\'apellidos\'\">\r\n                {{element.apellidos}}\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.nif\' | translate\" sortable=\"\'nif\'\">\r\n                {{element.nif}}\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.validado\' | translate\" sortable=\"\'validado\'\" class=\"col-sm-1 text-center\">\r\n                <booleano value=\"{{element.validado}}\"></booleano>\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.infoJuegos\' | translate\" sortable=\"\'s.infoJuegos\'\" class=\"col-sm-1 text-center\">\r\n                <booleano value=\"{{element.infoJuegos}}\"></booleano>\r\n            </td>\r\n\r\n            <td data-title=\"\'usuarios.admin.usuarios.infoGeneral\' | translate\" sortable=\"\'s.infoGeneral\'\" class=\"col-sm-1 text-center\">\r\n                <booleano value=\"{{element.infoGeneral}}\"></booleano>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <!--<a ui-sref=\"admin/aulaDigital/materia/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\"-->\r\n                <!--title=\"{{\'admin.form.button.edit\' | translate}}\"></a>-->\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element, false)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.deshabilitar\' | translate}}\" ng-if=\"!element.eliminado\"></a>\r\n                <a ng-click=\"ctrl.showRecoverConfirmation(element)\" class=\"button glyphicon glyphicon-ok\" title=\"{{\'usuarios.admin.usuarios.recover.title\' | translate}}\" ng-if=\"element.eliminado\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element, true)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/usuarios/admin/suscriptores/suscriptor-edit.html","<form ng-submit=\"ctrl.confirm(ctrl.item)\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"usuarios.admin.suscriptores.edit.modal.titulo\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <!--Info general ASPG-->\r\n        <div class=\"form-group\">\r\n            <label class=\"noselect\">\r\n                <input type=\"checkbox\" id=\"infoGeneral\" ng-model=\"ctrl.item.infoGeneral\">\r\n                {{\'usuarios.admin.usuarios.infoGeneral\' | translate}}\r\n            </label>\r\n        </div>\r\n\r\n        <!--Info juegos-->\r\n        <div class=\"form-group\">\r\n            <label class=\"noselect\">\r\n                <input type=\"checkbox\" id=\"infoJuegos\" ng-model=\"ctrl.item.infoJuegos\">\r\n                {{\'usuarios.admin.usuarios.infoJuegos\' | translate}}\r\n            </label>\r\n        </div>\r\n\r\n        <!--Info tienda-->\r\n        <div class=\"form-group\">\r\n            <label class=\"noselect\">\r\n                <input type=\"checkbox\" id=\"infoTienda\" ng-model=\"ctrl.item.infoTienda\">\r\n                {{\'usuarios.admin.usuarios.infoTienda\' | translate}}\r\n            </label>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.dismiss()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;<span translate=\"admin.form.button.save\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/aspg/usuarios/admin/suscriptores/suscriptores-list.admin.html","<filter-input filter=\"ctrl.filter.key\"></filter-input>\n\n<div class=\"total-elementos\">\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\n</div>\n<div class=\"table-responsive\">\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\n\n        <tr ng-repeat=\"element in $data track by element.email\" class=\"animate\">\n            <td data-title=\"\'usuarios.admin.usuarios.email\' | translate\" sortable=\"\'email\'\">\n                {{element.email}}\n            </td>\n\n            <td data-title=\"\'usuarios.admin.usuarios.infoGeneral\' | translate\" sortable=\"\'infoGeneral\'\" class=\"col-sm-1 text-center\">\n                <booleano value=\"{{element.infoGeneral}}\"></booleano>\n            </td>\n\n            <td data-title=\"\'usuarios.admin.usuarios.infoJuegos\' | translate\" sortable=\"\'infoJuegos\'\" class=\"col-sm-1 text-center\">\n                <booleano value=\"{{element.infoJuegos}}\"></booleano>\n            </td>\n\n            <td data-title=\"\'usuarios.admin.usuarios.infoTienda\' | translate\" sortable=\"\'infoTienda\'\" class=\"col-sm-1 text-center\">\n                <booleano value=\"{{element.infoTienda}}\"></booleano>\n            </td>\n            <td class=\"col-md-1 text-center button-icons\">\n                <a ng-click=\"ctrl.showEditModal(element)\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\n                <a ng-click=\"ctrl.showRemoveConfirmation(element)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\n            </td>\n        </tr>\n    </table>\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\n</div>\n");
$templateCache.put("app/components/aspg/usuarios/admin/email/enviar-mail.html","<div class=\"alert alert-success\" ng-show=\"ctrl.success\" translate=\"usuarios.admin.email.success\"></div>\r\n<div class=\"alert alert-danger\" ng-show=\"ctrl.error\" translate=\"usuarios.admin.email.error\"></div>\r\n<form class=\"form\" ng-submit=\"ctrl.enviar()\">\r\n    <div class=\"form-body\" role=\"form\">\r\n        <!--Asunto-->\r\n        <div class=\"form-group\">\r\n            <label-form key=\"usuarios.admin.email.asunto\" for=\"login\" required=\"true\"></label-form>\r\n            <input class=\"form-control\" type=\"text\" id=\"login\" name=\"login\" ng-model=\"ctrl.email.asunto\" required>\r\n        </div>\r\n\r\n        <!--Cuerpo-->\r\n        <div class=\"form-group\">\r\n            <text-area id=\"email\" label=\"usuarios.admin.email.mensaje\" model=\"ctrl.email.cuerpo\" height=\"350\" tipo=\"completo\" required>\r\n            </text-area>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group form-inline\">\r\n        <label translate=\"usuarios.admin.email.destinatario\"></label><br>\r\n\r\n        <div class=\"radio\">\r\n            <label>\r\n                <input id=\"grupo\" type=\"radio\" ng-model=\"ctrl.tipoDestinatario\" value=\"grupo\">\r\n                <label-form key=\"usuarios.admin.email.lista\" for=\"grupo\"></label-form>\r\n            </label>\r\n        </div>\r\n\r\n        <div class=\"radio\">\r\n            <label>\r\n                <input id=\"usuario\" class=\"radio\" type=\"radio\" ng-model=\"ctrl.tipoDestinatario\" value=\"suscriptor\">\r\n                <label-form key=\"usuarios.admin.email.usuario\" for=\"usuario\"></label-form>\r\n            </label>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\" ng-show=\"ctrl.tipoDestinatario === \'grupo\'\">\r\n        <input type=\"checkbox\" ng-model=\"ctrl.infoGeneral\">\r\n        <label translate=\"usuarios.admin.email.infoGeneral\"></label><br>\r\n        <input type=\"checkbox\" ng-model=\"ctrl.infoJuegos\">\r\n        <label translate=\"usuarios.admin.email.infoJuegos\"></label><br>\r\n        <input id=\"t\" type=\"checkbox\" ng-model=\"ctrl.infoTienda\">\r\n        <label translate=\"usuarios.admin.email.infoTienda\"></label>\r\n        <div class=\"has-error\">\r\n            <span class=\"help-block\" ng-show=\"ctrl.errorDestinatario\" translate=\"usuarios.admin.email.errordestinatario\">\r\n        </span>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group row\" ng-if=\"ctrl.tipoDestinatario === \'suscriptor\'\">\r\n        <div class=\"col-md-3\">\r\n            <select ng-options=\"suscriptor.email for suscriptor in ctrl.suscriptores.content track by suscriptor.email\" ng-model=\"ctrl.suscriptor\" required></select>\r\n        </div>\r\n    </div>\r\n    <input class=\"btn btn-primary\" type=\"submit\">\r\n</form>\r\n");
$templateCache.put("app/components/aspg/museos/admin/museo/museo-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-10\">\r\n                <!--Publicado-->\r\n                <div class=\"form-group\">\r\n                    <input id=\"publicado\" type=\"checkbox\" ng-model=\"ctrl.item.publicado\">\r\n                    <label-form key=\"museos.museo.field.publicado\" for=\"publicado\"></label-form>\r\n                </div>\r\n\r\n                <!--Título-->\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"museos.museo.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\r\n                </div>\r\n\r\n                <!--Descripción-->\r\n                <div class=\"form-group\">\r\n                    <text-area model=\"ctrl.item.descripcion\" id=\"descripcion\" label=\"museos.museo.field.descripcion\" tipo=\"basico\" height=\"160\"></text-area>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Portada-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"museos.museo.field.imagen\" for=\"imagen\" required=\"true\"></label-form>\r\n                    <imagen-crop model=\"ctrl.item.imagen\" carpeta=\"{{ctrl.urlBaseImagen}}\" ratio=\"0.75\" on-remove-image=\"ctrl.item.imagen = {eliminar: true}\"></imagen-crop>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/aspg/museos/admin/museo/museo-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/museos/museo/create\">\r\n        <span translate=\"museos.museo.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'museos.museo.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/museos/museo/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'comun.url\' | translate\" sortable=\"\'url\'\">\r\n                <!--TODO: URL a parte pública.-->\r\n                {{element.url}}\r\n            </td>\r\n\r\n            <td data-title=\"\'museos.museo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/museos/salaMuseo/list({museoid: element.id})\" class=\"button glyphicon glyphicon-list\" title=\"{{\'museos.salaMuseo.admin.titulo\' | translate}}\"></a>\r\n\r\n                <a ui-sref=\"admin/museos/museo/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/museos/admin/obramuseo/obra-museo-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\r\n    <div class=\"form-body\">\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-10\">\r\n                <!--Título-->\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"museos.obraMuseo.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\r\n                </div>\r\n\r\n                <!--Descripción-->\r\n                <div class=\"form-group\">\r\n                    <text-area model=\"ctrl.item.descripcion\" id=\"descripcion\" label=\"museos.obraMuseo.field.descripcion\" tipo=\"basico\" height=\"160\"></text-area>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Portada-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"museos.obraMuseo.field.imagen\" for=\"imagen\" required=\"true\"></label-form>\r\n                    <imagen model=\"ctrl.item.imagen\" carpeta=\"{{ctrl.urlBaseImagen}}\" edicion=\"true\" indice=\"0\" on-remove-image=\"ctrl.item.imagen = {eliminar: true}\"></imagen>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/aspg/museos/admin/obramuseo/obra-museo-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/museos/obraMuseo/create\">\r\n        <span translate=\"museos.obraMuseo.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'museos.obraMuseo.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/museos/obraMuseo/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'museos.obraMuseo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/museos/obraMuseo/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/museos/admin/salamuseo/sala-museo-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" novalidate>\n    <div class=\"form-body\">\n\n        <div class=\"row\">\n            <div class=\"col-sm-6\">\n                <!--Título-->\n                <div class=\"form-group\">\n                    <label-form key=\"museos.salaMuseo.field.titulo\" for=\"titulo\" required=\"true\"></label-form>\n                    <input class=\"form-control\" type=\"text\" id=\"titulo\" name=\"titulo\" ng-model=\"ctrl.item.titulo\" required>\n                </div>\n            </div>\n\n            <!--Portada-->\n            <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                    <label-form key=\"museos.salaMuseo.field.imagen\" for=\"imagen\"></label-form>\n                    <imagen-crop model=\"ctrl.item.imagen\" carpeta=\"{{ctrl.urlBaseImagen}}\" ratio=\"1.75\" on-remove-image=\"ctrl.item.imagen = {eliminar: true}\"></imagen-crop>\n                </div>\n            </div>\n        </div>\n\n        <!--Botones-->\n        <buttons can-save=\"ctrl.canSave\" mode=\"ctrl.mode\"></buttons>\n    </div>\n</form>\n");
$templateCache.put("app/components/aspg/museos/admin/salamuseo/sala-museo-list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/museos/salaMuseo/create\">\r\n        <span translate=\"museos.salaMuseo.admin.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter-input filter=\"ctrl.filter.key\"></filter-input>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'comun.totalelementos\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <!--<td data-title=\"\'museos.salaMuseo.field.sala\' | translate\" sortable=\"\'orden\'\" class=\"col-md-1 text-center\">-->\r\n            <!--{{$index + 1}}-->\r\n            <!--</td>-->\r\n\r\n            <td data-title=\"\'museos.salaMuseo.field.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n                <a ui-sref=\"admin/museos/salaMuseo/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                    {{element.titulo}}\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'museos.salaMuseo.field.orden\' | translate\" class=\"col-md-1 text-center button-icons\" sortable=\"\'orden\'\">\r\n                <ordenable id=\"element.id\" resource=\"ctrl.item\" on-change=\"ctrl.tableParams.reload()\"></ordenable>\r\n            </td>\r\n\r\n            <td class=\"col-md-1 text-center button-icons\">\r\n                <a ui-sref=\"admin/museos/obraMuseo/list({salaid: element.id})\" class=\"button glyphicon glyphicon-list\" title=\"{{\'museos.obraMuseo.admin.title\' | translate}}\"></a>\r\n\r\n                <a ui-sref=\"admin/museos/salaMuseo/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n                <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n</div>\r\n");
$templateCache.put("app/components/aspg/museos/public/obramuseo/obra-list.public.html","<h4>\n    <a ng-click=\"ctrl.irARecepcion()\"><i class=\"fa fa-arrow-left\"></i>\n        &nbsp;<span translate=\"museos.obraMuseo.recepcion\"></span>\n    </a>\n</h4>\n<div class=\"seccion-museo\">\n    <h2>\n        {{ctrl.sala.titulo}}\n    </h2>\n    <h4>\n        <span translate=\"museos.obraMuseo.sala\"></span>&nbsp;{{ctrl.sala.orden}}\n    </h4>\n    <div class=\"contenedor-thumbnails\">\n        <ng-image-gallery images=\"ctrl.imagenes\" thumb-size=\"215\" bubble-size=\"10\" bg-close=\"true\">\n        </ng-image-gallery>\n    </div>\n</div>\n");
$templateCache.put("app/components/aspg/museos/public/museo/museo-details.public.html","<div class=\"media\">\n    <!--Imagen-->\n    <figure class=\"media-left media-imagen\">\n        <a ui-sref=\"museos/museo({url: ctrl.museo.url, museo: ctrl.museo})\">\n            <div class=\"media-object\" ng-style=\"{\'background-image\': ctrl.imagen}\"></div>\n        </a>\n    </figure>\n\n    <!--Contenido-->\n    <div class=\"media-body\">\n        <div class=\"titulo\">\n            <a ui-sref=\"museos/museo({url: ctrl.museo.url, museo: ctrl.museo})\">\n                <h3>{{ctrl.museo.titulo}}</h3>\n            </a>\n        </div>\n\n        <div class=\"info\">\n            <div class=\"subtitulo\" translate=\"museos.museo.permanente\"></div>\n\n            <div class=\"descripcion\">\n                <!-- En esta sección se permite que la ellipsis trunque las palabras, porque si se fuerza a que no -->\n                <!-- lo haga la librería falla, debido a que dentro del div existen elementos html (ng-bind-html) -->\n                <div ng-bind-html=\"ctrl.museo.descripcion\" ellipsis=\"7\" ellipsis-truncar-palabra=\"true\"></div>\n            </div>\n        </div>\n        <a class=\"btn btn-primary\" ui-sref=\"museos/museo({url: ctrl.museo.url, museo: ctrl.museo})\" translate=\"museos.museo.ver\">\n        </a>\n    </div>\n</div>\n");
$templateCache.put("app/components/aspg/museos/public/museo/museo-info.public.html","<div class=\"col-md-2\">\n    <figure class=\"media-object\">\n        <img ng-src=\"{{ctrl.imagen}}\" ng-click=\"ctrl.abrirImagen()\">\n    </figure>\n</div>\n<div class=\"col-md-10\" ng-bind-html=\"ctrl.museo.descripcion\"></div>\n\n");
$templateCache.put("app/components/aspg/museos/public/museo/museo-list.public.html","<div class=\"tarjetas full articulo\">\n\n    <div class=\"empty\" ng-if=\"!ctrl.museos.content.length\" translate=\"museos.empty\"></div>\n\n    <div class=\"row\">\n        <div class=\"col-md-6\" ng-repeat=\"museo in ctrl.museos.content track by museo.id\">\n            <div class=\"tarjeta\">\n                <museo-details-public museo=\"museo\"></museo-details-public>\n            </div>\n        </div>\n    </div>\n\n    <pagination current-page=\"ctrl.page\" total-elements=\"ctrl.boletines.totalElements\" separador=\"true\"></pagination>\n\n</div>\n\n");
$templateCache.put("app/components/aspg/museos/public/salamuseo/sala-details.public.html","<a ui-sref=\"museos/museo/sala({id: ctrl.sala.id, sala: ctrl.sala})\">\r\n    <div class=\"thumbnail full\">\r\n        <div class=\"imagen\" ng-style=\"{\'background-image\': ctrl.imagen}\">\r\n            <div class=\"contenedor-etiqueta\">\r\n                <span class=\"etiqueta\">Sala {{ctrl.sala.orden}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"caption\">\r\n            <div class=\"pie\">\r\n                {{ctrl.sala.titulo}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</a>\r\n\r\n");
$templateCache.put("app/components/aspg/museos/public/salamuseo/sala-list.public.html","<div class=\"seccion-museo\">\r\n    <h2 translate=\"museos.salaMuseo.recepcion\"></h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\" ng-repeat=\"sala in ctrl.salas\">\r\n            <sala-details-public sala=\"sala\"></sala-details-public>\r\n        </div>\r\n    </div>\r\n</div>\r\n");}]);})();